
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1M56W", function(module, exports) {

$parcel$export(module.exports, "default", () => $14ae3d12445bce67$export$2e2bcd8739ae039);

var $6umAO = parcelRequire("6umAO");
var $14ae3d12445bce67$export$2e2bcd8739ae039 = (0, $6umAO.default);

});
parcelRegister("6umAO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9711d9bb4845ae$export$2e2bcd8739ae039);

var $gwFzn = parcelRequire("gwFzn");
var $4b9711d9bb4845ae$var$AnalyticsNextContext = (0, $gwFzn.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $4b9711d9bb4845ae$export$2e2bcd8739ae039 = $4b9711d9bb4845ae$var$AnalyticsNextContext;

});


parcelRegister("034wI", function(module, exports) {

$parcel$export(module.exports, "ConfluenceWorkspaceAri", () => $0093cad3a0d9b067$export$d47d8a7e69df1865);

var $6IE8e = parcelRequire("6IE8e");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/workspace/manifest.ts
var $0093cad3a0d9b067$var$confluenceWorkspaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6IE8e.ConfluenceWorkspaceAriResourceOwner),
    resourceType: (0, $6IE8e.ConfluenceWorkspaceAriResourceType),
    resourceIdSlug: "{activationId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/
    }
};
// src/confluence/workspace/index.ts
var $0093cad3a0d9b067$export$d47d8a7e69df1865 = class _ConfluenceWorkspaceAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $0093cad3a0d9b067$var$confluenceWorkspaceAriStaticOpts.qualifier,
            platformQualifier: $0093cad3a0d9b067$var$confluenceWorkspaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $0093cad3a0d9b067$var$confluenceWorkspaceAriStaticOpts.resourceOwner,
            resourceType: $0093cad3a0d9b067$var$confluenceWorkspaceAriStaticOpts.resourceType,
            resourceId: `${opts.activationId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $0093cad3a0d9b067$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $0093cad3a0d9b067$var$confluenceWorkspaceAriStaticOpts);
        return new _ConfluenceWorkspaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId;
    }
};

});
parcelRegister("6IE8e", function(module, exports) {

$parcel$export(module.exports, "ConfluenceWorkspaceAriResourceOwner", () => $4e45fb79bcdf693a$export$19f1a63686ec0369);
$parcel$export(module.exports, "ConfluenceWorkspaceAriResourceType", () => $4e45fb79bcdf693a$export$f1c423a93fbc71);
// src/confluence/workspace/types.ts
var $4e45fb79bcdf693a$export$19f1a63686ec0369 = "confluence", $4e45fb79bcdf693a$export$f1c423a93fbc71 = "workspace";

});

parcelRegister("fY4NL", function(module, exports) {

$parcel$export(module.exports, "RegisteredAri", () => $ba002f1a6a8e70cf$export$579ee78b1dcf0a11);

var $jLIWc = parcelRequire("jLIWc");
// src/core/registered-ari.ts
var $ba002f1a6a8e70cf$export$579ee78b1dcf0a11 = class extends (0, $jLIWc.Ari) {
    static check(maybeAri) {
        try {
            return this.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return (0, $jLIWc.AnyAri).parse(this.toString());
    }
};

});
parcelRegister("jLIWc", function(module, exports) {

$parcel$export(module.exports, "Ari", () => $e64543c96f4666d6$export$3a4885701291260b);
$parcel$export(module.exports, "AnyAri", () => $e64543c96f4666d6$export$44a7af7122933d6b);

var $3w0K2 = parcelRequire("3w0K2");
// src/core/ari.ts
var $e64543c96f4666d6$export$3a4885701291260b = class {
    get platformQualifier() {
        return this._ati.platformQualifier;
    }
    get cloudId() {
        return this._cloudId;
    }
    get resourceOwner() {
        return this._ati.resourceOwner;
    }
    get resourceType() {
        return this._ati.resourceType;
    }
    get resourceId() {
        return this._resourceId;
    }
    get ati() {
        return this._ati;
    }
    equals(other) {
        return this.toString() === other.toString();
    }
    toString() {
        return `ari:${this.platformQualifier}:${this.resourceOwner}:${this.cloudId || ""}:${this.resourceType}/${this.resourceId}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this.platformQualifier,
            resourceOwner: this.resourceOwner,
            cloudId: this.cloudId,
            resourceType: this.resourceType,
            resourceId: this.resourceId
        };
    }
    constructor(opts){
        this._ati = (0, $3w0K2.Ati).create({
            platformQualifier: opts.platformQualifier || "cloud",
            resourceOwner: opts.resourceOwner,
            resourceType: opts.resourceType
        }), this._cloudId = opts.cloudId !== "" ? opts.cloudId : void 0, this._resourceId = opts.resourceId;
    }
};
// src/any-ari.ts
var $e64543c96f4666d6$export$44a7af7122933d6b = class _AnyAri extends $e64543c96f4666d6$export$3a4885701291260b {
    static create(ariOpts, ariStaticOpts) {
        let ariOptsWithDefaults = {
            ...ariOpts,
            resourceIdSegmentValues: {}
        }, validatedOpts = (0, $3w0K2.AriParser).fromOpts(ariOptsWithDefaults, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static parse(maybeAri, ariStaticOpts) {
        let validatedOpts = (0, $3w0K2.AriParser).fromString(maybeAri, ariStaticOpts);
        return new _AnyAri(validatedOpts);
    }
    static check(maybeAri) {
        try {
            return _AnyAri.parse(maybeAri.toString()), !0;
        } catch (err) {
            return !1;
        }
    }
    asAnyAri() {
        return this;
    }
    constructor(opts){
        super(opts);
    }
};

});
parcelRegister("3w0K2", function(module, exports) {

$parcel$export(module.exports, "AriParser", () => $28f4ef7fb2c5309e$export$4c3a8cde7a55740b);
$parcel$export(module.exports, "Ati", () => $28f4ef7fb2c5309e$export$ab4b293d0121b8ee);

var $cYjZU = parcelRequire("cYjZU");

var $ebGg4 = parcelRequire("ebGg4");
// src/core/rules/cloud-id.ts
function $28f4ef7fb2c5309e$var$validateCloudId(cloudId, format = new RegExp("^[a-zA-Z0-9_\\-.]{0,255}$")) {
    if (!cloudId.match(format)) throw new (0, $ebGg4.ValidationError)(`Invalid cloud ID, expected ID of format ${format}.`);
}
// src/core/rules/resource-id.ts
function $28f4ef7fb2c5309e$var$validateResourceId(id, format = new RegExp("[!a-zA-Z0-9\\-_.~@:{}=]+(/[!a-zA-Z0-9\\-_.~@:{}=]+)*" /* ANY_RESOURCE_ID */ ), key = "resourceId") {
    let formatWithCarets = new RegExp(`^${format.source}$`);
    if (!id.match(formatWithCarets)) throw new (0, $ebGg4.ValidationError)(`Invalid ${key} - ${id}, expected ID of format ${formatWithCarets}.`);
}
// src/core/rules/resource-id-segments.ts
function $28f4ef7fb2c5309e$var$validateResourceIdSegments(resourceIdSegmentValues, resourceIdSegmentFormats) {
    Object.entries(resourceIdSegmentValues).forEach(([resourceIdKey, resourceIdValue])=>{
        $28f4ef7fb2c5309e$var$validateResourceId(resourceIdValue, resourceIdSegmentFormats == null ? void 0 : resourceIdSegmentFormats[resourceIdKey], resourceIdKey);
    });
}
// src/core/rules/resource-owner.ts
function $28f4ef7fb2c5309e$var$validateResourceOwner(owner, expectedResourceOwner) {
    if (expectedResourceOwner && owner !== expectedResourceOwner) throw new (0, $ebGg4.ValidationError)(`Invalid resource owner - ${owner}, expected ${expectedResourceOwner}.`);
}
// src/core/rules/resource-type.ts
function $28f4ef7fb2c5309e$var$validateResourceType(type, expectedResourceType) {
    if (expectedResourceType && type !== expectedResourceType) throw new (0, $ebGg4.ValidationError)(`Invalid resource type - ${type}, expected ${expectedResourceType}.`);
}
// src/core/parser/ari.ts
var $28f4ef7fb2c5309e$var$NUMBER_OF_ARI_SEGMENTS = 5, $28f4ef7fb2c5309e$export$4c3a8cde7a55740b = class extends (0, $cYjZU.BaseParser) {
    static fromString(maybeAri, ariProperties) {
        let segments = this.getIdentifierSegments(maybeAri, $28f4ef7fb2c5309e$var$NUMBER_OF_ARI_SEGMENTS), [qualifier, platformQualifier, resourceOwner, cloudId, resourceTypeAndId] = segments, [resourceType, ...resourceIdSegments] = resourceTypeAndId.split("/"), maybeAriDerivedProperties = {
            qualifier: qualifier,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            resourceId: resourceIdSegments.join("/"),
            resourceIdSegmentValues: ariProperties != null && ariProperties.resourceIdSlug ? this.ariSegmentValuesFromSlug(ariProperties.resourceIdSlug, resourceIdSegments.join("/"), Object.keys(ariProperties.resourceIdSegmentFormats)) : {}
        };
        return this.fromOpts(maybeAriDerivedProperties, ariProperties);
    }
    static fromOpts(maybeAriOpts, ariProperties) {
        let { qualifier: qualifier = "ari", platformQualifier: platformQualifier = "cloud", resourceOwner: resourceOwner, cloudId: cloudId, resourceId: resourceId, resourceIdSegmentValues: resourceIdSegmentValues, resourceType: resourceType } = maybeAriOpts;
        return (0, $cYjZU.validateAriQualifier)(qualifier), (0, $cYjZU.validatePlatformQualifier)(platformQualifier), $28f4ef7fb2c5309e$var$validateCloudId(maybeAriOpts.cloudId || "", ariProperties == null ? void 0 : ariProperties.cloudId), $28f4ef7fb2c5309e$var$validateResourceOwner(resourceOwner, ariProperties == null ? void 0 : ariProperties.resourceOwner), $28f4ef7fb2c5309e$var$validateResourceType(resourceType, ariProperties == null ? void 0 : ariProperties.resourceType), $28f4ef7fb2c5309e$var$validateResourceIdSegments(resourceIdSegmentValues, ariProperties == null ? void 0 : ariProperties.resourceIdSegmentFormats), {
            qualifier: qualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType,
            platformQualifier: platformQualifier,
            cloudId: cloudId,
            resourceId: resourceId,
            resourceIdSegmentValues: resourceIdSegmentValues
        };
    }
    static ariSegmentValuesFromSlug(slug, incomingSegments, expectedKeys) {
        let regexpResult = new RegExp("^" + slug.replace(/\{(.*?)\}/g, "(?<$1>.*?)") + "$").exec(incomingSegments);
        if (!regexpResult) throw new (0, $ebGg4.ValidationError)(`Segment '${incomingSegments}' don't match expected slug: ${slug}`);
        return expectedKeys.forEach((expectedKey)=>{
            var _a;
            if (!((_a = regexpResult.groups) != null && _a[expectedKey])) throw new (0, $ebGg4.ValidationError)(`No value supplied for '${expectedKey}' based on slug ${slug}`);
        }), regexpResult.groups || {};
    }
};
// src/core/parser/ati.ts
var $28f4ef7fb2c5309e$var$NUMBER_OF_ATI_SEGMENTS = 4, $28f4ef7fb2c5309e$var$AtiParser = class extends (0, $cYjZU.BaseParser) {
    static fromString(inputStr, atiOpts) {
        let segments = this.getIdentifierSegments(inputStr, $28f4ef7fb2c5309e$var$NUMBER_OF_ATI_SEGMENTS), [qualifier = "ati", platformQualifier = "cloud", resourceOwner, resourceType] = segments;
        return (0, $cYjZU.validateAtiQualifier)(qualifier), (0, $cYjZU.validatePlatformQualifier)(platformQualifier), $28f4ef7fb2c5309e$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $28f4ef7fb2c5309e$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
    static fromOpts(maybeAtiOpts, atiOpts) {
        let { qualifier: qualifier, platformQualifier: platformQualifier, resourceOwner: resourceOwner, resourceType: resourceType } = maybeAtiOpts;
        return (0, $cYjZU.validateAtiQualifier)(qualifier), (0, $cYjZU.validatePlatformQualifier)(platformQualifier), $28f4ef7fb2c5309e$var$validateResourceOwner(resourceOwner, atiOpts == null ? void 0 : atiOpts.resourceOwner), $28f4ef7fb2c5309e$var$validateResourceType(resourceType, atiOpts == null ? void 0 : atiOpts.resourceType), {
            platformQualifier: platformQualifier,
            resourceOwner: resourceOwner,
            resourceType: resourceType
        };
    }
};
// src/ati.ts
var $28f4ef7fb2c5309e$export$ab4b293d0121b8ee = class _Ati {
    get platformQualifier() {
        return this._platformQualifier;
    }
    get resourceOwner() {
        return this._resourceOwner;
    }
    get resourceType() {
        return this._resourceType;
    }
    static create(opts) {
        return new _Ati(opts.platformQualifier || "cloud", opts.resourceOwner, opts.resourceType);
    }
    static parse(maybeAti, atiOpts) {
        let opts = $28f4ef7fb2c5309e$var$AtiParser.fromString(maybeAti, atiOpts);
        return new _Ati(opts.platformQualifier, opts.resourceOwner, opts.resourceType);
    }
    toString() {
        return `ati:${this.platformQualifier}:${this.resourceOwner}:${this.resourceType}`;
    }
    toJSON() {
        return this.toString();
    }
    toOpts() {
        return {
            platformQualifier: this._platformQualifier,
            resourceOwner: this._resourceOwner,
            resourceType: this._resourceType
        };
    }
    constructor(platformQualifier, resourceOwner, resourceType){
        this._platformQualifier = platformQualifier, this._resourceOwner = resourceOwner, this._resourceType = resourceType;
    }
};

});
parcelRegister("cYjZU", function(module, exports) {

$parcel$export(module.exports, "validatePlatformQualifier", () => $971a99bec9086a7d$export$4f6e8fa90a16fdc4);
$parcel$export(module.exports, "validateAtiQualifier", () => $971a99bec9086a7d$export$da331df28ad1f3d9);
$parcel$export(module.exports, "validateAriQualifier", () => $971a99bec9086a7d$export$822bcd2b6f6774a1);
$parcel$export(module.exports, "BaseParser", () => $971a99bec9086a7d$export$3d09a5c28ff3e040);

var $ebGg4 = parcelRequire("ebGg4");
// src/core/rules/platform-qualifier.ts
function $971a99bec9086a7d$export$4f6e8fa90a16fdc4(qualifier) {
    if (qualifier !== "cloud" && qualifier !== "third-party") throw new (0, $ebGg4.ValidationError)(`Identifier must have a qualifier of 'cloud' or 'third-party'. Received: ${qualifier}`);
}
// src/core/rules/qualifier.ts
function $971a99bec9086a7d$export$da331df28ad1f3d9(qualifier) {
    if (qualifier !== "ati") throw new (0, $ebGg4.ValidationError)(`ATI must have a qualifier of 'ati'. Received: ${qualifier}`);
}
function $971a99bec9086a7d$export$822bcd2b6f6774a1(qualifier) {
    if (qualifier !== "ari") throw new (0, $ebGg4.ValidationError)(`ARI must have a qualifier of 'ari'. Received: ${qualifier}`);
}
function $971a99bec9086a7d$export$277c2bbc487e609d(qualifier) {
    if (qualifier !== "arm") throw new (0, $ebGg4.ValidationError)(`ARM must have a qualifier of 'arm'. Received: ${qualifier}`);
}
// src/core/parser/base.ts
var $971a99bec9086a7d$var$NUMBER_OF_BASE_SEGMENTS = 5, $971a99bec9086a7d$var$SEGMENT_SEPARATOR = ":", $971a99bec9086a7d$export$3d09a5c28ff3e040 = class {
    static getIdentifierSegments(inputStr, numberOfSegmentsRequired) {
        let allSegments = inputStr.split($971a99bec9086a7d$var$SEGMENT_SEPARATOR);
        if (allSegments.length < numberOfSegmentsRequired) throw new (0, $ebGg4.ValidationError)(`Input string must have ${numberOfSegmentsRequired} segments.`);
        if (allSegments.length > numberOfSegmentsRequired) {
            let segments = allSegments.slice(0, $971a99bec9086a7d$var$NUMBER_OF_BASE_SEGMENTS - 1), segmentsForResourceId = allSegments.slice($971a99bec9086a7d$var$NUMBER_OF_BASE_SEGMENTS - 1, allSegments.length);
            return [
                ...segments,
                segmentsForResourceId.join($971a99bec9086a7d$var$SEGMENT_SEPARATOR)
            ];
        }
        return allSegments;
    }
};

});
parcelRegister("ebGg4", function(module, exports) {

$parcel$export(module.exports, "ValidationError", () => $a542df5c8f42db48$export$2191b9da168c6cf0);
// src/errors.ts
var $a542df5c8f42db48$export$2191b9da168c6cf0 = class extends Error {
};

});






parcelRegister("bnGHl", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAri", () => $8492f6a7ac2fdb1c$export$1e9d09c2be53e55e);

var $hgMtV = parcelRequire("hgMtV");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/identity/user/manifest.ts
var $8492f6a7ac2fdb1c$var$identityUserAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $hgMtV.IdentityUserAriResourceOwner),
    resourceType: (0, $hgMtV.IdentityUserAriResourceType),
    resourceIdSlug: "{userId}",
    resourceIdSegmentFormats: {
        userId: /[a-zA-Z0-9_\-\:]{1,128}/
    }
};
// src/identity/user/index.ts
var $8492f6a7ac2fdb1c$export$1e9d09c2be53e55e = class _IdentityUserAri extends (0, $fY4NL.RegisteredAri) {
    get userId() {
        return this._userId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $8492f6a7ac2fdb1c$var$identityUserAriStaticOpts.qualifier,
            platformQualifier: $8492f6a7ac2fdb1c$var$identityUserAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $8492f6a7ac2fdb1c$var$identityUserAriStaticOpts.resourceOwner,
            resourceType: $8492f6a7ac2fdb1c$var$identityUserAriStaticOpts.resourceType,
            resourceId: `${opts.userId}`,
            resourceIdSegmentValues: {
                userId: opts.userId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $8492f6a7ac2fdb1c$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $8492f6a7ac2fdb1c$var$identityUserAriStaticOpts);
        return new _IdentityUserAri(opts);
    }
    getVariables() {
        return {
            userId: this.userId
        };
    }
    constructor(opts){
        super(opts);
        this._userId = opts.resourceIdSegmentValues.userId;
    }
};

});
parcelRegister("hgMtV", function(module, exports) {

$parcel$export(module.exports, "IdentityUserAriResourceOwner", () => $c92989bb9b6a8a87$export$b4c14c54282a779d);
$parcel$export(module.exports, "IdentityUserAriResourceType", () => $c92989bb9b6a8a87$export$e9b50e20f4fbfb71);
// src/identity/user/types.ts
var $c92989bb9b6a8a87$export$b4c14c54282a779d = "identity", $c92989bb9b6a8a87$export$e9b50e20f4fbfb71 = "user";

});


parcelRegister("dyHbo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fQsf7 = parcelRequire("fQsf7");

$fQsf7.__exportStar((parcelRequire("5D1fn")), module.exports);

$fQsf7.__exportStar((parcelRequire("hBtrT")), module.exports);

});
parcelRegister("5D1fn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doesMeetConditions = void 0;

var $9GDd9 = parcelRequire("9GDd9");

var $9OooC = parcelRequire("9OooC");

var $3T0zY = parcelRequire("3T0zY");
var $41918fe8584573a7$var$unhandledOperation = function(operation) {
    throw new Error($9OooC.errors.unhandledOperation(operation));
};
var $41918fe8584573a7$var$checkOperation = function(operation, conditionsInput, staticContextInput, clientData) {
    var conditions = $9GDd9.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    var staticContext = $9GDd9.isObject(staticContextInput) ? staticContextInput : {};
    var staticKeys = [];
    var operationEntries = [];
    var propertyConditions;
    if (Array.isArray(conditions)) propertyConditions = conditions;
    else {
        staticKeys = Object.keys(conditions).filter($9GDd9.isStaticKey);
        propertyConditions = Object.entries(conditions).filter(function(_a) {
            var key = _a[0];
            return $9GDd9.isEntityPropertyCondition(key);
        }).map(function(_a) {
            var _b;
            var key = _a[0], condition = _a[1];
            return _b = {}, _b[key] = condition, _b;
        });
        operationEntries = Object.entries(conditions).filter(function(_a) {
            var key = _a[0], _ = _a[1];
            return $9GDd9.isOperation(key);
        });
    }
    var staticKeysLength = staticKeys.length;
    var operationsLength = operationEntries.length;
    var propertyConditionsLength = propertyConditions.length;
    var staticEqualityComparator = function(key) {
        return (Array.isArray(conditions[key]) ? conditions[key] : [
            conditions[key]
        ]).includes(staticContext[key]);
    };
    if (staticKeysLength === 0 && operationsLength === 0 && propertyConditionsLength === 0) return $9GDd9.Instruction.Skip;
    if (staticKeysLength !== 0 || propertyConditionsLength !== 0) {
        var clientDataConditionResult = void 0;
        switch(operation){
            case $9GDd9.AND_OPERATION:
                if (staticKeysLength && !staticKeys.every(staticEqualityComparator)) return false;
                clientDataConditionResult = $3T0zY.entityPropertyHandlers[$9GDd9.AND_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== $9GDd9.Instruction.Continue) return clientDataConditionResult;
                break;
            case $9GDd9.OR_OPERATION:
                if (staticKeysLength && staticKeys.some(staticEqualityComparator)) return true;
                clientDataConditionResult = $3T0zY.entityPropertyHandlers[$9GDd9.OR_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== $9GDd9.Instruction.Continue) return clientDataConditionResult;
                break;
            case $9GDd9.NOT_OPERATION:
                if (staticKeysLength && staticKeys.some(function(key) {
                    return !staticEqualityComparator(key);
                })) return true;
                clientDataConditionResult = $3T0zY.entityPropertyHandlers[$9GDd9.NOT_OPERATION](propertyConditions, clientData);
                if (clientDataConditionResult !== $9GDd9.Instruction.Continue) return clientDataConditionResult;
                break;
            default:
                return $41918fe8584573a7$var$unhandledOperation(operation);
        }
    }
    for(var index = 0; index < operationEntries.length; index += 1){
        var _a = operationEntries[index], nextOperation = _a[0], nextConditions = _a[1];
        var nextOperationResult = $41918fe8584573a7$var$checkOperation(nextOperation, nextConditions, staticContext, clientData);
        if (nextOperationResult === $9GDd9.Instruction.NeedData) return nextOperationResult;
        switch(operation){
            case $9GDd9.AND_OPERATION:
                if (nextOperationResult === false) return false;
                if (nextOperationResult === $9GDd9.Instruction.Skip && operationsLength === 1) return staticKeysLength + propertyConditionsLength === 0 ? $9GDd9.Instruction.Skip : true;
                break;
            case $9GDd9.OR_OPERATION:
                if (nextOperationResult === true) return true;
                if (nextOperationResult === $9GDd9.Instruction.Skip && operationsLength === 1) return staticKeysLength + propertyConditionsLength === 0 ? $9GDd9.Instruction.Skip : false;
                break;
            case $9GDd9.NOT_OPERATION:
                if (nextOperationResult === false) return true;
                if (nextOperationResult === $9GDd9.Instruction.Skip && operationsLength === 1) return staticKeysLength + propertyConditionsLength === 0 ? $9GDd9.Instruction.Skip : false;
                break;
            default:
                return $41918fe8584573a7$var$unhandledOperation(operation);
        }
    }
    switch(operation){
        case $9GDd9.AND_OPERATION:
            return true;
        case $9GDd9.OR_OPERATION:
            return false;
        case $9GDd9.NOT_OPERATION:
            return false;
        default:
            return $41918fe8584573a7$var$unhandledOperation(operation);
    }
};
var $41918fe8584573a7$var$validateNesting = function(conditionsInput, nesting) {
    if (nesting === void 0) nesting = 0;
    if (nesting >= 10) throw new Error($9OooC.errors.nestingOvercomplicated());
    var conditions = $9GDd9.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    if (Array.isArray(conditions)) return;
    Object.entries(conditions).filter(function(_a) {
        var key = _a[0], _ = _a[1];
        return $9GDd9.isOperation(key);
    }).forEach(function(_a) {
        var _ = _a[0], condition = _a[1];
        return $41918fe8584573a7$var$validateNesting(condition, nesting + 1);
    });
};
module.exports.doesMeetConditions = function(conditions, staticContext, clientDataProvider) {
    try {
        $41918fe8584573a7$var$validateNesting(conditions);
        var result_1 = $41918fe8584573a7$var$checkOperation($9GDd9.AND_OPERATION, conditions, staticContext);
        if (result_1 !== $9GDd9.Instruction.NeedData) return result_1 === $9GDd9.Instruction.Skip ? true : result_1;
        if (!clientDataProvider) return false;
        return clientDataProvider.fetchPropertyValues($3T0zY.collectEntityPropertiesToFetch(conditions)).then(function(clientData) {
            result_1 = $41918fe8584573a7$var$checkOperation($9GDd9.AND_OPERATION, conditions, staticContext, clientData);
            return result_1 === $9GDd9.Instruction.Skip ? true : result_1;
        }).catch(function() {
            return false;
        });
    } catch (_a) {
        return false;
    }
};

});
parcelRegister("9GDd9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isStaticKey = module.exports.isEntityPropertyCondition = module.exports.isOperation = module.exports.isObjectOrArray = module.exports.isObject = module.exports.Instruction = module.exports.SUPPORTED_OPERATIONS = module.exports.NOT_OPERATION = module.exports.OR_OPERATION = module.exports.AND_OPERATION = void 0;

var $hBtrT = parcelRequire("hBtrT");
module.exports.AND_OPERATION = 'and';
module.exports.OR_OPERATION = 'or';
module.exports.NOT_OPERATION = 'not';
module.exports.SUPPORTED_OPERATIONS = [
    module.exports.AND_OPERATION,
    module.exports.OR_OPERATION,
    module.exports.NOT_OPERATION
];
var $70d673cb702ac6a5$var$Instruction;
(function(Instruction) {
    Instruction["Skip"] = "skip";
    Instruction["NeedData"] = "need-data";
    Instruction["Continue"] = "continue";
})($70d673cb702ac6a5$var$Instruction = module.exports.Instruction || (module.exports.Instruction = {}));
module.exports.isObject = function(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
};
module.exports.isObjectOrArray = function(x) {
    return module.exports.isObject(x) || Array.isArray(x);
};
module.exports.isOperation = function(key) {
    return module.exports.SUPPORTED_OPERATIONS.includes(key);
};
module.exports.isEntityPropertyCondition = function(key) {
    return Object.values($hBtrT.PropertyConditionType).includes(key);
};
module.exports.isStaticKey = function(key) {
    return !module.exports.isOperation(key) && !module.exports.isEntityPropertyCondition(key);
};

});
parcelRegister("hBtrT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientDataProvider = module.exports.EntityType = module.exports.PropertyConditionType = void 0;
var $cd0cbc52bf89df4b$var$PropertyConditionType;
(function(PropertyConditionType) {
    PropertyConditionType["EntityPropertyExists"] = "entityPropertyExists";
    PropertyConditionType["EntityPropertyEqualTo"] = "entityPropertyEqualTo";
    PropertyConditionType["EntityPropertyContainsAny"] = "entityPropertyContainsAny";
    PropertyConditionType["EntityPropertyContainsAll"] = "entityPropertyContainsAll";
})($cd0cbc52bf89df4b$var$PropertyConditionType = module.exports.PropertyConditionType || (module.exports.PropertyConditionType = {}));
var $cd0cbc52bf89df4b$var$EntityType;
(function(EntityType) {
    EntityType["Space"] = "space";
    EntityType["Content"] = "content";
})($cd0cbc52bf89df4b$var$EntityType = module.exports.EntityType || (module.exports.EntityType = {}));
var $cd0cbc52bf89df4b$var$ClientDataProvider = function() {
    function ClientDataProvider() {
        var _this = this;
        this.globalFetchPromise = new Promise(function(resolve, reject) {
            _this.globalFetchResolve = resolve;
            _this.globalFetchReject = reject;
        });
        this.propertyValueRequests = [];
    }
    ClientDataProvider.prototype.fetchPropertyValues = function(propValueRequests) {
        var _a;
        (_a = this.propertyValueRequests).push.apply(_a, propValueRequests);
        return this.globalFetchPromise;
    };
    ClientDataProvider.prototype.resolve = function(clientData) {
        var _a;
        (_a = this.globalFetchResolve) === null || _a === void 0 || _a.call(this, clientData);
    };
    ClientDataProvider.prototype.reject = function(reason) {
        var _a;
        (_a = this.globalFetchReject) === null || _a === void 0 || _a.call(this, reason);
    };
    return ClientDataProvider;
}();
module.exports.ClientDataProvider = $cd0cbc52bf89df4b$var$ClientDataProvider;

});


parcelRegister("9OooC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.errors = void 0;
module.exports.errors = {
    nestingOvercomplicated: function() {
        return 'Nesting of display conditions exceeds 10 levels';
    },
    unhandledOperation: function(operation) {
        return "Unhandled operation: " + operation;
    },
    unsupportedConditionType: function(conditionType) {
        return "Unsupported condition type: " + conditionType;
    }
};

});

parcelRegister("3T0zY", function(module, exports) {
"use strict";
var $2d46f52ce0401e2c$var$_a;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.collectEntityPropertiesToFetch = module.exports.entityPropertyHandlers = void 0;

var $fQsf7 = parcelRequire("fQsf7");

var $hBtrT = parcelRequire("hBtrT");

var $9OooC = parcelRequire("9OooC");

var $9GDd9 = parcelRequire("9GDd9");
var $2d46f52ce0401e2c$var$asArray = function(value) {
    return Array.isArray(value) ? value : [
        value
    ];
};
var $2d46f52ce0401e2c$var$entityId = function(entityProperty) {
    return [
        entityProperty.entity,
        entityProperty.propertyKey,
        entityProperty.objectName
    ].filter(Boolean).join('-');
};
var $2d46f52ce0401e2c$var$doesEntityPropertyMatch = function(condition, propertyValuesResponse) {
    var conditionType = Object.keys(condition)[0];
    var conditionFields = condition[conditionType];
    var id = $2d46f52ce0401e2c$var$entityId(conditionFields);
    var propertyValue = propertyValuesResponse[id];
    var expectedValue = conditionFields.value;
    var propValueArray;
    switch(conditionType){
        case $hBtrT.PropertyConditionType.EntityPropertyExists:
            return propertyValue != null;
        case $hBtrT.PropertyConditionType.EntityPropertyEqualTo:
            return propertyValue === expectedValue;
        case $hBtrT.PropertyConditionType.EntityPropertyContainsAny:
            propValueArray = $2d46f52ce0401e2c$var$asArray(propertyValue);
            return $2d46f52ce0401e2c$var$asArray(expectedValue).some(function(expected) {
                return propValueArray.includes(expected);
            });
        case $hBtrT.PropertyConditionType.EntityPropertyContainsAll:
            propValueArray = $2d46f52ce0401e2c$var$asArray(propertyValue);
            return $2d46f52ce0401e2c$var$asArray(expectedValue).every(function(expected) {
                return propValueArray.includes(expected);
            });
        default:
            throw new Error($9OooC.errors.unsupportedConditionType(conditionType));
    }
};
var $2d46f52ce0401e2c$var$clientConditionsPreCheck = function(clientDataConditionsLength, clientData) {
    if (!clientDataConditionsLength) return $9GDd9.Instruction.Continue;
    if (!clientData) return $9GDd9.Instruction.NeedData;
};
var $2d46f52ce0401e2c$var$entityPropertyAndHandler = function(propertyConditions, clientData) {
    var preCheck = $2d46f52ce0401e2c$var$clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) return preCheck;
    if (!propertyConditions.every(function(propCondition) {
        return $2d46f52ce0401e2c$var$doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) return false;
    return $9GDd9.Instruction.Continue;
};
var $2d46f52ce0401e2c$var$entityPropertyOrHandler = function(propertyConditions, clientData) {
    var preCheck = $2d46f52ce0401e2c$var$clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) return preCheck;
    if (propertyConditions.some(function(propCondition) {
        return $2d46f52ce0401e2c$var$doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) return true;
    return $9GDd9.Instruction.Continue;
};
var $2d46f52ce0401e2c$var$entityPropertyNotHandler = function(propertyConditions, clientData) {
    var preCheck = $2d46f52ce0401e2c$var$clientConditionsPreCheck(propertyConditions.length, clientData);
    if (preCheck) return preCheck;
    if (propertyConditions.some(function(propCondition) {
        return !$2d46f52ce0401e2c$var$doesEntityPropertyMatch(propCondition, clientData.propertyValues);
    })) return true;
    return $9GDd9.Instruction.Continue;
};
module.exports.entityPropertyHandlers = ($2d46f52ce0401e2c$var$_a = {}, $2d46f52ce0401e2c$var$_a[$9GDd9.AND_OPERATION] = $2d46f52ce0401e2c$var$entityPropertyAndHandler, $2d46f52ce0401e2c$var$_a[$9GDd9.OR_OPERATION] = $2d46f52ce0401e2c$var$entityPropertyOrHandler, $2d46f52ce0401e2c$var$_a[$9GDd9.NOT_OPERATION] = $2d46f52ce0401e2c$var$entityPropertyNotHandler, $2d46f52ce0401e2c$var$_a);
var $2d46f52ce0401e2c$var$buildPropertyValueRequest = function(entityProperty) {
    return $fQsf7.__assign({
        id: $2d46f52ce0401e2c$var$entityId(entityProperty),
        entity: entityProperty.entity,
        propertyKey: entityProperty.propertyKey
    }, entityProperty.objectName && {
        objectName: entityProperty.objectName
    });
};
module.exports.collectEntityPropertiesToFetch = function(conditionsInput) {
    var conditions = $9GDd9.isObjectOrArray(conditionsInput) ? conditionsInput : {};
    var propertyRequests = [];
    if (Array.isArray(conditions)) {
        for(var _i = 0, conditions_1 = conditions; _i < conditions_1.length; _i++){
            var propertyCondition = conditions_1[_i];
            var key = Object.keys(propertyCondition).find($9GDd9.isEntityPropertyCondition);
            if (key) {
                var entityProperty = propertyCondition[key];
                propertyRequests.push($2d46f52ce0401e2c$var$buildPropertyValueRequest(entityProperty));
            }
        }
        return propertyRequests;
    }
    Object.entries(conditions).filter(function(_a) {
        var key = _a[0], _ = _a[1];
        return $9GDd9.isEntityPropertyCondition(key);
    }).forEach(function(_a) {
        var _ = _a[0], condition = _a[1];
        return propertyRequests.push($2d46f52ce0401e2c$var$buildPropertyValueRequest(condition));
    });
    Object.entries(conditions).filter(function(_a) {
        var key = _a[0], _ = _a[1];
        return $9GDd9.isOperation(key);
    }).forEach(function(_a) {
        var _ = _a[0], condition = _a[1];
        return propertyRequests.push.apply(propertyRequests, module.exports.collectEntityPropertiesToFetch(condition));
    });
    return propertyRequests;
};

});



parcelRegister("30K2d", function(module, exports) {

$parcel$export(module.exports, "generateUuid", () => $231514bdc0c41b2d$export$1c3aefb711c3a4cc);
$parcel$export(module.exports, "uuid", () => $231514bdc0c41b2d$export$31b40729666a4ae0);
/* eslint-disable no-bitwise */ var $231514bdc0c41b2d$export$1c3aefb711c3a4cc = function generateUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
/* eslint-enable no-bitwise */ var $231514bdc0c41b2d$var$staticValue = false;
var $231514bdc0c41b2d$export$31b40729666a4ae0 = {
    setStatic: function setStatic(value) {
        $231514bdc0c41b2d$var$staticValue = value;
    },
    generate: function generate() {
        return $231514bdc0c41b2d$var$staticValue || $231514bdc0c41b2d$export$1c3aefb711c3a4cc();
    }
};

});

parcelRegister("kx99t", function(module, exports) {

$parcel$export(module.exports, "inlineNodes", () => $ef2dfd148d39097d$export$b1f729c6af6f2a6e);

var $6btu3 = parcelRequire("6btu3");
var $ef2dfd148d39097d$var$typedNodes = $6btu3;
var $ef2dfd148d39097d$export$b1f729c6af6f2a6e = new Set(Object.keys($ef2dfd148d39097d$var$typedNodes).filter(function(key) {
    return $ef2dfd148d39097d$var$typedNodes[key] && $ef2dfd148d39097d$var$typedNodes[key].group === 'inline';
}));

});
parcelRegister("6btu3", function(module, exports) {

$parcel$export(module.exports, "expand", () => (parcelRequire("hJ7IY")).expand);
$parcel$export(module.exports, "expandWithNestedExpand", () => (parcelRequire("hJ7IY")).expandWithNestedExpand);
$parcel$export(module.exports, "expandToJSON", () => (parcelRequire("hJ7IY")).toJSON);
$parcel$export(module.exports, "confluenceJiraIssue", () => (parcelRequire("4h1RM")).confluenceJiraIssue);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => (parcelRequire("3sY9d")).confluenceUnsupportedBlock);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => (parcelRequire("4SZyh")).confluenceUnsupportedInline);
$parcel$export(module.exports, "doc", () => (parcelRequire("7e7vU")).doc);
$parcel$export(module.exports, "blockquote", () => (parcelRequire("jHRmz")).blockquote);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => (parcelRequire("jHRmz")).blockquoteWithNestedCodeblockOrMedia);
$parcel$export(module.exports, "extendedBlockquote", () => (parcelRequire("jHRmz")).extendedBlockquote);
$parcel$export(module.exports, "blockquoteWithList", () => (parcelRequire("jHRmz")).blockquoteWithList);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => (parcelRequire("jHRmz")).blockquoteWithoutNonBodiedMacros);
$parcel$export(module.exports, "bulletList", () => (parcelRequire("anCdB")).bulletList);
$parcel$export(module.exports, "bulletListSelector", () => (parcelRequire("anCdB")).bulletListSelector);
$parcel$export(module.exports, "codeBlock", () => (parcelRequire("ddar1")).codeBlock);
$parcel$export(module.exports, "codeBlockToJSON", () => (parcelRequire("ddar1")).toJSON);
$parcel$export(module.exports, "hardBreak", () => (parcelRequire("dFBOI")).hardBreak);
$parcel$export(module.exports, "heading", () => (parcelRequire("kECe5")).heading);
$parcel$export(module.exports, "rule", () => (parcelRequire("8Pe9m")).rule);
$parcel$export(module.exports, "orderedList", () => (parcelRequire("k9LfQ")).orderedList);
$parcel$export(module.exports, "orderedListSelector", () => (parcelRequire("k9LfQ")).orderedListSelector);
$parcel$export(module.exports, "orderedListWithOrder", () => (parcelRequire("k9LfQ")).orderedListWithOrder);
$parcel$export(module.exports, "paragraph", () => (parcelRequire("k9Kf6")).paragraph);
$parcel$export(module.exports, "emoji", () => (parcelRequire("VrJSs")).emoji);
$parcel$export(module.exports, "image", () => (parcelRequire("iXL55")).image);
$parcel$export(module.exports, "mention", () => (parcelRequire("ilnFA")).mention);
$parcel$export(module.exports, "mentionToJSON", () => (parcelRequire("ilnFA")).toJSON);
$parcel$export(module.exports, "listItem", () => (parcelRequire("bljJ6")).listItem);
$parcel$export(module.exports, "listItemWithTask", () => (parcelRequire("bljJ6")).listItemWithTask);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => (parcelRequire("bljJ6")).listItemWithDecisionStage0);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => (parcelRequire("bljJ6")).listItemWithoutNonBodiedMacros);
$parcel$export(module.exports, "extendedPanel", () => (parcelRequire("kyLrk")).extendedPanel);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => (parcelRequire("kyLrk")).panelWithoutNestedNonBodiedMacros);
$parcel$export(module.exports, "PanelType", () => (parcelRequire("kyLrk")).PanelType);
$parcel$export(module.exports, "text", () => (parcelRequire("2UNHE")).text);
$parcel$export(module.exports, "unknownBlock", () => (parcelRequire("gl6qh")).default);
$parcel$export(module.exports, "caption", () => (parcelRequire("DPd50")).caption);
$parcel$export(module.exports, "media", () => (parcelRequire("jGJid")).media);
$parcel$export(module.exports, "copyPrivateMediaAttributes", () => (parcelRequire("jGJid")).copyPrivateAttributes);
$parcel$export(module.exports, "mediaToJSON", () => (parcelRequire("jGJid")).toJSON);
$parcel$export(module.exports, "mediaGroup", () => (parcelRequire("cApIr")).mediaGroup);
$parcel$export(module.exports, "mediaInline", () => (parcelRequire("j99rC")).mediaInline);
$parcel$export(module.exports, "mediaSingle", () => (parcelRequire("dQPhK")).mediaSingle);
$parcel$export(module.exports, "mediaSingleSpec", () => (parcelRequire("dQPhK")).mediaSingleSpec);
$parcel$export(module.exports, "mediaSingleWithCaption", () => (parcelRequire("dQPhK")).mediaSingleWithCaption);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => (parcelRequire("dQPhK")).mediaSingleWithWidthType);
$parcel$export(module.exports, "mediaSingleFull", () => (parcelRequire("dQPhK")).mediaSingleFull);
$parcel$export(module.exports, "mediaSingleToJSON", () => (parcelRequire("dQPhK")).toJSON);
$parcel$export(module.exports, "table", () => (parcelRequire("65GP4")).table);
$parcel$export(module.exports, "tableWithNestedTable", () => (parcelRequire("65GP4")).tableWithNestedTable);
$parcel$export(module.exports, "tableRowWithNestedTable", () => (parcelRequire("65GP4")).tableRowWithNestedTable);
$parcel$export(module.exports, "tableCellWithNestedTable", () => (parcelRequire("65GP4")).tableCellWithNestedTable);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => (parcelRequire("65GP4")).tableHeaderWithNestedTable);
$parcel$export(module.exports, "tableStage0", () => (parcelRequire("65GP4")).tableStage0);
$parcel$export(module.exports, "tableWithCustomWidth", () => (parcelRequire("65GP4")).tableWithCustomWidth);
$parcel$export(module.exports, "tableToJSON", () => (parcelRequire("65GP4")).tableToJSON);
$parcel$export(module.exports, "tableCell", () => (parcelRequire("65GP4")).tableCell);
$parcel$export(module.exports, "toJSONTableCell", () => (parcelRequire("65GP4")).toJSONTableCell);
$parcel$export(module.exports, "tableHeader", () => (parcelRequire("65GP4")).tableHeader);
$parcel$export(module.exports, "toJSONTableHeader", () => (parcelRequire("65GP4")).toJSONTableHeader);
$parcel$export(module.exports, "tableRow", () => (parcelRequire("65GP4")).tableRow);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => (parcelRequire("65GP4")).tableBackgroundColorPalette);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => (parcelRequire("65GP4")).tableBackgroundBorderColor);
$parcel$export(module.exports, "tableBackgroundColorNames", () => (parcelRequire("65GP4")).tableBackgroundColorNames);
$parcel$export(module.exports, "getCellAttrs", () => (parcelRequire("65GP4")).getCellAttrs);
$parcel$export(module.exports, "getCellDomAttrs", () => (parcelRequire("65GP4")).getCellDomAttrs);
$parcel$export(module.exports, "tablePrefixSelector", () => (parcelRequire("65GP4")).tablePrefixSelector);
$parcel$export(module.exports, "tableCellSelector", () => (parcelRequire("65GP4")).tableCellSelector);
$parcel$export(module.exports, "tableHeaderSelector", () => (parcelRequire("65GP4")).tableHeaderSelector);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => (parcelRequire("65GP4")).tableCellContentWrapperSelector);
$parcel$export(module.exports, "tableCellContentDomSelector", () => (parcelRequire("65GP4")).tableCellContentDomSelector);
$parcel$export(module.exports, "decisionList", () => (parcelRequire("gF5vD")).decisionList);
$parcel$export(module.exports, "decisionListSelector", () => (parcelRequire("gF5vD")).decisionListSelector);
$parcel$export(module.exports, "decisionItem", () => (parcelRequire("3MGtf")).decisionItem);
$parcel$export(module.exports, "taskList", () => (parcelRequire("sHAtT")).taskList);
$parcel$export(module.exports, "taskListSelector", () => (parcelRequire("sHAtT")).taskListSelector);
$parcel$export(module.exports, "taskItem", () => (parcelRequire("iamME")).taskItem);
$parcel$export(module.exports, "date", () => (parcelRequire("gUPLp")).date);
$parcel$export(module.exports, "placeholder", () => (parcelRequire("jnsRQ")).placeholder);
$parcel$export(module.exports, "layoutSection", () => (parcelRequire("jlC8q")).layoutSection);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => (parcelRequire("jlC8q")).layoutSectionWithSingleColumn);
$parcel$export(module.exports, "layoutColumn", () => (parcelRequire("wJ4ih")).layoutColumn);
$parcel$export(module.exports, "inlineCard", () => (parcelRequire("e0eEI")).inlineCard);
$parcel$export(module.exports, "blockCard", () => (parcelRequire("1cqNn")).blockCard);
$parcel$export(module.exports, "unsupportedBlock", () => (parcelRequire("faMeF")).unsupportedBlock);
$parcel$export(module.exports, "unsupportedInline", () => (parcelRequire("cPaCL")).unsupportedInline);
$parcel$export(module.exports, "status", () => (parcelRequire("fbcXy")).status);
$parcel$export(module.exports, "nestedExpand", () => (parcelRequire("2SP0l")).nestedExpand);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => (parcelRequire("2SP0l")).nestedExpandWithoutNonBodiedMacros);
$parcel$export(module.exports, "embedCard", () => (parcelRequire("6fv5N")).embedCard);
$parcel$export(module.exports, "extension", () => (parcelRequire("jV2EZ")).extension);
$parcel$export(module.exports, "inlineExtension", () => (parcelRequire("6NYOZ")).inlineExtension);
$parcel$export(module.exports, "bodiedExtension", () => (parcelRequire("bCf9G")).bodiedExtension);
$parcel$export(module.exports, "extensionFrame", () => (parcelRequire("6jY0P")).extensionFrame);
$parcel$export(module.exports, "multiBodiedExtension", () => (parcelRequire("6jY0P")).multiBodiedExtension);

var $hJ7IY = parcelRequire("hJ7IY");

var $4h1RM = parcelRequire("4h1RM");

var $3sY9d = parcelRequire("3sY9d");

var $4SZyh = parcelRequire("4SZyh");

var $7e7vU = parcelRequire("7e7vU");

var $jHRmz = parcelRequire("jHRmz");

var $anCdB = parcelRequire("anCdB");

var $ddar1 = parcelRequire("ddar1");

var $dFBOI = parcelRequire("dFBOI");

var $kECe5 = parcelRequire("kECe5");

var $8Pe9m = parcelRequire("8Pe9m");

var $k9LfQ = parcelRequire("k9LfQ");

var $k9Kf6 = parcelRequire("k9Kf6");

var $VrJSs = parcelRequire("VrJSs");

var $iXL55 = parcelRequire("iXL55");

var $ilnFA = parcelRequire("ilnFA");

var $bljJ6 = parcelRequire("bljJ6");

var $kyLrk = parcelRequire("kyLrk");

var $2UNHE = parcelRequire("2UNHE");

var $gl6qh = parcelRequire("gl6qh");

var $DPd50 = parcelRequire("DPd50");

var $jGJid = parcelRequire("jGJid");

var $cApIr = parcelRequire("cApIr");

var $j99rC = parcelRequire("j99rC");

var $dQPhK = parcelRequire("dQPhK");

var $65GP4 = parcelRequire("65GP4");

var $gF5vD = parcelRequire("gF5vD");

var $3MGtf = parcelRequire("3MGtf");

var $sHAtT = parcelRequire("sHAtT");

var $iamME = parcelRequire("iamME");

var $gUPLp = parcelRequire("gUPLp");

var $jnsRQ = parcelRequire("jnsRQ");

var $jlC8q = parcelRequire("jlC8q");

var $wJ4ih = parcelRequire("wJ4ih");

var $e0eEI = parcelRequire("e0eEI");

var $1cqNn = parcelRequire("1cqNn");

var $faMeF = parcelRequire("faMeF");

var $cPaCL = parcelRequire("cPaCL");

var $fbcXy = parcelRequire("fbcXy");

var $2SP0l = parcelRequire("2SP0l");

var $6fv5N = parcelRequire("6fv5N");

var $jV2EZ = parcelRequire("jV2EZ");

var $6NYOZ = parcelRequire("6NYOZ");

var $bCf9G = parcelRequire("bCf9G");

var $6jY0P = parcelRequire("6jY0P");

});
parcelRegister("hJ7IY", function(module, exports) {

$parcel$export(module.exports, "expand", () => $ce7ca18c59bb6280$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithNestedExpand", () => $ce7ca18c59bb6280$export$7b80cba28d10b2c1);
$parcel$export(module.exports, "toJSON", () => $ce7ca18c59bb6280$export$54fd2c36b5cc6731);

var $1tVDE = parcelRequire("1tVDE");

var $7p61p = parcelRequire("7p61p");
function $ce7ca18c59bb6280$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce7ca18c59bb6280$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce7ca18c59bb6280$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce7ca18c59bb6280$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name expand_node
 */ /**
 * @name expand_with_no_mark_node
 */ /**
 * @name expand_root_only_node
 */ function $ce7ca18c59bb6280$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $ce7ca18c59bb6280$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ce7ca18c59bb6280$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ce7ca18c59bb6280$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $ce7ca18c59bb6280$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $ce7ca18c59bb6280$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $ce7ca18c59bb6280$export$9f77e0932fb78f72 = (0, $7p61p.expandWithoutNestedExpand)($ce7ca18c59bb6280$var$nodeSpecOptions);
var $ce7ca18c59bb6280$export$7b80cba28d10b2c1 = (0, $7p61p.expand)($ce7ca18c59bb6280$var$nodeSpecOptions);
var $ce7ca18c59bb6280$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return !key.startsWith('__');
        }).reduce(function(obj, key) {
            return $ce7ca18c59bb6280$var$_objectSpread($ce7ca18c59bb6280$var$_objectSpread({}, obj), {}, (0, $1tVDE.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});
parcelRegister("7p61p", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $563f8a038ca9fddb$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $563f8a038ca9fddb$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteLegacy", () => $563f8a038ca9fddb$export$199922e5af8e9a6);
$parcel$export(module.exports, "blockquoteWithoutNestedCodeblockOrMedia", () => $563f8a038ca9fddb$export$a91509d1c739c16f);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $563f8a038ca9fddb$export$32b1dde15f5fe85b);
$parcel$export(module.exports, "bodiedExtension", () => $563f8a038ca9fddb$export$27903d543b563e39);
$parcel$export(module.exports, "bulletList", () => $563f8a038ca9fddb$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $563f8a038ca9fddb$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "codeBlock", () => $563f8a038ca9fddb$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "confluenceJiraIssue", () => $563f8a038ca9fddb$export$daf889beb5092f95);
$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $563f8a038ca9fddb$export$e6e4878f43c27cab);
$parcel$export(module.exports, "confluenceUnsupportedInline", () => $563f8a038ca9fddb$export$3e6d667072febc87);
$parcel$export(module.exports, "date", () => $563f8a038ca9fddb$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $563f8a038ca9fddb$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $563f8a038ca9fddb$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $563f8a038ca9fddb$export$2a111da947c407d2);
$parcel$export(module.exports, "embedCard", () => $563f8a038ca9fddb$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $563f8a038ca9fddb$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $563f8a038ca9fddb$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expandWithoutNestedExpand", () => $563f8a038ca9fddb$export$63c0f3992661097b);
$parcel$export(module.exports, "extension", () => $563f8a038ca9fddb$export$1b45514b112dd749);
$parcel$export(module.exports, "extensionFrameStage0", () => $563f8a038ca9fddb$export$b555be60c7703afb);
$parcel$export(module.exports, "hardBreak", () => $563f8a038ca9fddb$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $563f8a038ca9fddb$export$46e4a324ac90507f);
$parcel$export(module.exports, "image", () => $563f8a038ca9fddb$export$5c452ff88e35e47d);
$parcel$export(module.exports, "inlineCard", () => $563f8a038ca9fddb$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtensionWithMarks", () => $563f8a038ca9fddb$export$b3b1e36c2105006d);
$parcel$export(module.exports, "layoutColumn", () => $563f8a038ca9fddb$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $563f8a038ca9fddb$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionFull", () => $563f8a038ca9fddb$export$cdae19acb0a520fd);
$parcel$export(module.exports, "layoutSectionWithSingleColumnStage0", () => $563f8a038ca9fddb$export$206007566ca0aca5);
$parcel$export(module.exports, "listItem", () => $563f8a038ca9fddb$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithNestedDecisionStage0", () => $563f8a038ca9fddb$export$df876f0305235056);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $563f8a038ca9fddb$export$171e9ff2be159af7);
$parcel$export(module.exports, "media", () => $563f8a038ca9fddb$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $563f8a038ca9fddb$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $563f8a038ca9fddb$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $563f8a038ca9fddb$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleCaption", () => $563f8a038ca9fddb$export$8d067f22dc2d1254);
$parcel$export(module.exports, "mediaSingleFull", () => $563f8a038ca9fddb$export$7e767666f2ce108a);
$parcel$export(module.exports, "mediaSingleWidthType", () => $563f8a038ca9fddb$export$4bd9a38995f6bf50);
$parcel$export(module.exports, "mention", () => $563f8a038ca9fddb$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtensionStage0", () => $563f8a038ca9fddb$export$750e45819f66d9d0);
$parcel$export(module.exports, "nestedExpand", () => $563f8a038ca9fddb$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $563f8a038ca9fddb$export$15ebf236772fa336);
$parcel$export(module.exports, "orderedList", () => $563f8a038ca9fddb$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $563f8a038ca9fddb$export$21f42ab9b6679f44);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $563f8a038ca9fddb$export$220c665c23b9541b);
$parcel$export(module.exports, "paragraph", () => $563f8a038ca9fddb$export$9c206ddddb32a9b);
$parcel$export(module.exports, "placeholder", () => $563f8a038ca9fddb$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $563f8a038ca9fddb$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $563f8a038ca9fddb$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "table", () => $563f8a038ca9fddb$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithNestedTable", () => $563f8a038ca9fddb$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableCell", () => $563f8a038ca9fddb$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $563f8a038ca9fddb$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeader", () => $563f8a038ca9fddb$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $563f8a038ca9fddb$export$2a5a518232fa1a97);
$parcel$export(module.exports, "tableRow", () => $563f8a038ca9fddb$export$ce666bf02318c957);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $563f8a038ca9fddb$export$7d657479499397);
$parcel$export(module.exports, "taskItem", () => $563f8a038ca9fddb$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $563f8a038ca9fddb$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $563f8a038ca9fddb$export$6f093cfa640b7166);
$parcel$export(module.exports, "unsupportedBlock", () => $563f8a038ca9fddb$export$44b79b0979d0f0f7);
$parcel$export(module.exports, "unsupportedInline", () => $563f8a038ca9fddb$export$310ebe0d80122e9b);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $lW8kt = parcelRequire("lW8kt");
var $563f8a038ca9fddb$export$c4c2f833baaebdb8 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $563f8a038ca9fddb$export$67dc04e652a298ca = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    selectable: true,
    defining: true
});
var $563f8a038ca9fddb$export$199922e5af8e9a6 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
var $563f8a038ca9fddb$export$a91509d1c739c16f = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
var $563f8a038ca9fddb$export$32b1dde15f5fe85b = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: true,
    defining: true
});
var $563f8a038ca9fddb$export$27903d543b563e39 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $563f8a038ca9fddb$export$e7320d153c538837 = (0, $lW8kt.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
var $563f8a038ca9fddb$export$a140c94e5ea26bee = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    selectable: false
});
var $563f8a038ca9fddb$export$8e3c2dfdc4f0453d = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    selectable: false,
    isolating: true
});
var $563f8a038ca9fddb$export$7bb0d5c671655cc4 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $563f8a038ca9fddb$export$e4f1c66d84049f8b = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        }
    },
    code: true,
    defining: true
});
var $563f8a038ca9fddb$export$daf889beb5092f95 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
var $563f8a038ca9fddb$export$e6e4878f43c27cab = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $563f8a038ca9fddb$export$3e6d667072febc87 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
var $563f8a038ca9fddb$export$324d90190a8b822a = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$47988d68fe575725 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$6959e16eeff859b4 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
var $563f8a038ca9fddb$export$62d45a65fb43d95e = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$2a111da947c407d2 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment breakout'
});
var $563f8a038ca9fddb$export$be4283d9a1cb1ff6 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$a19185d1233fc4b2 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$f5574b5d45fc2112 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$9f77e0932fb78f72 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $563f8a038ca9fddb$export$7e3788972005cc72 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $563f8a038ca9fddb$export$63c0f3992661097b = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $563f8a038ca9fddb$export$1b45514b112dd749 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$a8baf338431a691 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$b555be60c7703afb = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
var $563f8a038ca9fddb$export$371da9dd35aba193 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        }
    },
    selectable: false,
    linebreakReplacement: true
});
var $563f8a038ca9fddb$export$46e4a324ac90507f = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$1b0c1557b234fa00 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$85461f751c457cc2 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$2b380a0f7e250af1 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$5c452ff88e35e47d = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
var $563f8a038ca9fddb$export$cbf8224b64e0d942 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $563f8a038ca9fddb$export$2f4e72b9459914ad = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
var $563f8a038ca9fddb$export$16b353b2649bd8d9 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$b3b1e36c2105006d = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$ab76e7c03cd6f650 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        }
    },
    selectable: false,
    isolating: true
});
var $563f8a038ca9fddb$export$b3b6a70a7fa4a5be = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
var $563f8a038ca9fddb$export$cdae19acb0a520fd = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    isolating: true
});
var $563f8a038ca9fddb$export$206007566ca0aca5 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        }
    },
    isolating: true
});
var $563f8a038ca9fddb$export$76c7e83ecc9cdf05 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$df876f0305235056 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | decisionList | extension)*',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$171e9ff2be159af7 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$987d49ffe1b0900f = (0, $lW8kt.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$2855e964765eac9 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
var $563f8a038ca9fddb$export$38bab695e3f720f1 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$969fe3781ca15058 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
var $563f8a038ca9fddb$export$8d067f22dc2d1254 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$7e767666f2ce108a = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$4bd9a38995f6bf50 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$db83999c14438df4 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$46f790bd65f760d0 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$750e45819f66d9d0 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
var $563f8a038ca9fddb$export$63cadbf5f4296627 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $563f8a038ca9fddb$export$f03786aa6312d1e4 = (0, $lW8kt.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $563f8a038ca9fddb$export$15ebf236772fa336 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        }
    },
    selectable: true,
    isolating: true
});
var $563f8a038ca9fddb$export$a5dc81035676e7a = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        }
    },
    selectable: false
});
var $563f8a038ca9fddb$export$21f42ab9b6679f44 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$220c665c23b9541b = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$9c206ddddb32a9b = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $563f8a038ca9fddb$export$4f98472e6dc14293 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $563f8a038ca9fddb$export$ea332b61641b0588 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $563f8a038ca9fddb$export$a1f41dc4901771f8 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
var $563f8a038ca9fddb$export$c7187bbd1a7a9244 = (0, $lW8kt.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        }
    },
    selectable: false
});
var $563f8a038ca9fddb$export$fbeb3a3956e8a3c7 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block'
});
var $563f8a038ca9fddb$export$471f7ae5c4103ae1 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$b6ce52be8d7a261 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$9852986a3ec5f6a0 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $563f8a038ca9fddb$export$ce086a560a1d05f5 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
var $563f8a038ca9fddb$export$e1e720e5f4603e6a = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $563f8a038ca9fddb$export$abf39ca178940ff3 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
var $563f8a038ca9fddb$export$48884d2a5190dc73 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $563f8a038ca9fddb$export$2a5a518232fa1a97 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
var $563f8a038ca9fddb$export$ce666bf02318c957 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
var $563f8a038ca9fddb$export$7d657479499397 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    selectable: false,
    tableRole: 'row'
});
var $563f8a038ca9fddb$export$6d8b0ef52e2e6390 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$375b6afcc5f4d291 = (0, $lW8kt.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock)+ (taskItem | taskList | unsupportedBlock)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
var $563f8a038ca9fddb$export$6f093cfa640b7166 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline'
});
var $563f8a038ca9fddb$export$5ea06bc686c59dc2 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline'
});
var $563f8a038ca9fddb$export$93256a4c17b33a82 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline'
});
var $563f8a038ca9fddb$export$a12828d0f14a2762 = (0, $lW8kt.createPMNodeSpecFactory)({});
var $563f8a038ca9fddb$export$44b79b0979d0f0f7 = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
var $563f8a038ca9fddb$export$310ebe0d80122e9b = (0, $lW8kt.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});

});
parcelRegister("lW8kt", function(module, exports) {

$parcel$export(module.exports, "createPMNodeSpecFactory", () => $ff8579c85508700d$export$bf0a80f00e2b8ff6);
$parcel$export(module.exports, "createPMMarkSpecFactory", () => $ff8579c85508700d$export$cf5823ed4e9f4c6f);

var $1tVDE = parcelRequire("1tVDE");
function $ff8579c85508700d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff8579c85508700d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff8579c85508700d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff8579c85508700d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ff8579c85508700d$export$bf0a80f00e2b8ff6 = function createPMNodeSpecFactory(nodeSpec) {
    return function(_ref) {
        var parseDOM = _ref.parseDOM, toDOM = _ref.toDOM, toDebugString = _ref.toDebugString;
        return $ff8579c85508700d$var$_objectSpread($ff8579c85508700d$var$_objectSpread($ff8579c85508700d$var$_objectSpread($ff8579c85508700d$var$_objectSpread({}, nodeSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};
var $ff8579c85508700d$export$cf5823ed4e9f4c6f = function createPMMarkSpecFactory(markSpec) {
    return function(_ref2) {
        var parseDOM = _ref2.parseDOM, toDOM = _ref2.toDOM, toDebugString = _ref2.toDebugString;
        return $ff8579c85508700d$var$_objectSpread($ff8579c85508700d$var$_objectSpread($ff8579c85508700d$var$_objectSpread($ff8579c85508700d$var$_objectSpread({}, markSpec), parseDOM && {
            parseDOM: parseDOM
        }), toDOM && {
            toDOM: toDOM
        }), toDebugString && {
            toDebugString: toDebugString
        });
    };
};

});



parcelRegister("4h1RM", function(module, exports) {

$parcel$export(module.exports, "confluenceJiraIssue", () => $31ca32997dd0355a$export$daf889beb5092f95);

var $7p61p = parcelRequire("7p61p");
var $31ca32997dd0355a$var$name = 'confluenceJiraIssue';
var $31ca32997dd0355a$export$daf889beb5092f95 = (0, $7p61p.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: "span[data-node-type=\"".concat($31ca32997dd0355a$var$name, "\"]"),
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $31ca32997dd0355a$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});

});

parcelRegister("3sY9d", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedBlock", () => $2862a4b53792b833$export$e6e4878f43c27cab);

var $7p61p = parcelRequire("7p61p");
var $2862a4b53792b833$var$name = 'confluenceUnsupportedBlock';
var $2862a4b53792b833$export$e6e4878f43c27cab = (0, $7p61p.confluenceUnsupportedBlock)({
    toDOM: function toDOM(node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        var attrs = {
            'data-node-type': $2862a4b53792b833$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($2862a4b53792b833$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("4SZyh", function(module, exports) {

$parcel$export(module.exports, "confluenceUnsupportedInline", () => $38ebf3795caa00c8$export$3e6d667072febc87);

var $7p61p = parcelRequire("7p61p");
var $38ebf3795caa00c8$var$name = 'confluenceUnsupportedInline';
var $38ebf3795caa00c8$export$3e6d667072febc87 = (0, $7p61p.confluenceUnsupportedInline)({
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': $38ebf3795caa00c8$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($38ebf3795caa00c8$var$name, "\"]"),
            getAttrs: function getAttrs(dom) {
                return {
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});

});

parcelRegister("7e7vU", function(module, exports) {

$parcel$export(module.exports, "doc", () => $542fab46b6a489d1$export$2a111da947c407d2);

var $7p61p = parcelRequire("7p61p");
var $542fab46b6a489d1$export$2a111da947c407d2 = (0, $7p61p.doc)({});

});

parcelRegister("jHRmz", function(module, exports) {

$parcel$export(module.exports, "blockquote", () => $e58b6d4202fc84d7$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockquoteWithNestedCodeblockOrMedia", () => $e58b6d4202fc84d7$export$c4d50234112df933);
$parcel$export(module.exports, "extendedBlockquote", () => $e58b6d4202fc84d7$export$70a64939da3e8455);
$parcel$export(module.exports, "blockquoteWithList", () => $e58b6d4202fc84d7$export$9b4686c4b9672643);
$parcel$export(module.exports, "blockquoteWithoutNonBodiedMacros", () => $e58b6d4202fc84d7$export$32b1dde15f5fe85b);

var $7p61p = parcelRequire("7p61p");
/**
 * @name blockquote_node
 */ var $e58b6d4202fc84d7$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
};
var $e58b6d4202fc84d7$export$67dc04e652a298ca = (0, $7p61p.blockquoteLegacy)($e58b6d4202fc84d7$var$nodeSpecOptions);
var $e58b6d4202fc84d7$export$c4d50234112df933 = (0, $7p61p.blockquoteWithoutNonBodiedMacros)($e58b6d4202fc84d7$var$nodeSpecOptions);
var $e58b6d4202fc84d7$export$70a64939da3e8455 = (0, $7p61p.blockquote)($e58b6d4202fc84d7$var$nodeSpecOptions);
var $e58b6d4202fc84d7$export$9b4686c4b9672643 = (0, $7p61p.blockquoteWithoutNestedCodeblockOrMedia)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
});
var $e58b6d4202fc84d7$export$32b1dde15f5fe85b = (0, $7p61p.blockquoteWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM: function toDOM() {
        return [
            'blockquote',
            0
        ];
    }
});

});

parcelRegister("anCdB", function(module, exports) {

$parcel$export(module.exports, "bulletListSelector", () => $78e9b2ba9b01fc73$export$5f25a39efab3b58b);
$parcel$export(module.exports, "bulletList", () => $78e9b2ba9b01fc73$export$a140c94e5ea26bee);

var $7p61p = parcelRequire("7p61p");
var $78e9b2ba9b01fc73$export$5f25a39efab3b58b = '.ak-ul';
var $78e9b2ba9b01fc73$export$a140c94e5ea26bee = (0, $7p61p.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $78e9b2ba9b01fc73$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});

});

parcelRegister("ddar1", function(module, exports) {

$parcel$export(module.exports, "codeBlock", () => $99e4956138682083$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "toJSON", () => $99e4956138682083$export$54fd2c36b5cc6731);

var $kviC1 = parcelRequire("kviC1");

var $7p61p = parcelRequire("7p61p");
/**
 * @name codeBlock_with_no_marks_node
 */ /**
 * @name codeBlock_node
 */ var $99e4956138682083$var$getLanguageFromEditorStyle = function getLanguageFromEditorStyle(dom) {
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
var $99e4956138682083$var$getLanguageFromBitbucketStyle = function getLanguageFromBitbucketStyle(dom) {
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $99e4956138682083$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
var $99e4956138682083$var$getLanguageFromCode = function getLanguageFromCode(dom) {
    var firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
var $99e4956138682083$var$extractLanguageFromClass = function extractLanguageFromClass(className) {
    var languageRegex = /(?:^|\s)language-([^\s]+)/;
    var result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
var $99e4956138682083$var$removeLastNewLine = function removeLastNewLine(dom) {
    var parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) dom.textContent = dom.textContent.replace(/\n$/, '');
    return dom;
};
function $99e4956138682083$var$parseCodeFromHtml(node) {
    var code = '';
    node.childNodes.forEach(function(child) {
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            var tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $99e4956138682083$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
var $99e4956138682083$export$7bb0d5c671655cc4 = (0, $7p61p.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var language = $99e4956138682083$var$getLanguageFromBitbucketStyle(dom.parentElement) || $99e4956138682083$var$getLanguageFromEditorStyle(dom.parentElement) || $99e4956138682083$var$getLanguageFromCode(dom) || dom.getAttribute('data-language');
                dom = $99e4956138682083$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: function getContent(domNode, schema) {
                var code = $99e4956138682083$var$parseCodeFromHtml(domNode);
                return code ? (0, $kviC1.Fragment).from(schema.text(code)) : (0, $kviC1.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(dom) {
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                // TODO: ED-5604 Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                var lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach(function(line) {
                    return line.remove();
                });
                return {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
var $99e4956138682083$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(memo, key) {
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    };
};

});

parcelRegister("dFBOI", function(module, exports) {

$parcel$export(module.exports, "hardBreak", () => $9f3c705f13ef9749$export$371da9dd35aba193);

var $7p61p = parcelRequire("7p61p");
var $9f3c705f13ef9749$export$371da9dd35aba193 = (0, $7p61p.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM: function toDOM() {
        return [
            'br'
        ];
    }
});

});

parcelRegister("kECe5", function(module, exports) {

$parcel$export(module.exports, "heading", () => $f09532015bec7c4d$export$46e4a324ac90507f);

var $7p61p = parcelRequire("7p61p");
/**
 * @name heading_node
 */ /**
 * @name heading_with_no_marks_node
 */ // Check `paragraph` node for why we are doing things like this
/**
 * @name heading_with_alignment_node
 */ /**
 * @name heading_with_indentation_node
 */ var $f09532015bec7c4d$var$getAttrs = function getAttrs(level) {
    return function(domNode) {
        var _heading$attrs, _heading$attrs$localI;
        return {
            level: level,
            localId: domNode.getAttribute('data-local-id') || ((_heading$attrs = $f09532015bec7c4d$export$46e4a324ac90507f.attrs) === null || _heading$attrs === void 0 ? void 0 : (_heading$attrs$localI = _heading$attrs.localId) === null || _heading$attrs$localI === void 0 ? void 0 : _heading$attrs$localI.default)
        };
    };
};
var $f09532015bec7c4d$export$46e4a324ac90507f = (0, $7p61p.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $f09532015bec7c4d$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $f09532015bec7c4d$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $f09532015bec7c4d$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $f09532015bec7c4d$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $f09532015bec7c4d$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $f09532015bec7c4d$var$getAttrs(6)
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, level = _node$attrs.level, localId = _node$attrs.localId;
        var name = 'h' + level;
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("8Pe9m", function(module, exports) {

$parcel$export(module.exports, "rule", () => $66ce100baabd3efb$export$fbeb3a3956e8a3c7);

var $7p61p = parcelRequire("7p61p");
/**
 * @name rule_node
 */ var $66ce100baabd3efb$var$hrDOM = [
    'hr'
];
var $66ce100baabd3efb$export$fbeb3a3956e8a3c7 = (0, $7p61p.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM: function toDOM() {
        return $66ce100baabd3efb$var$hrDOM;
    }
});

});

parcelRegister("k9LfQ", function(module, exports) {

$parcel$export(module.exports, "orderedListSelector", () => $eac94db34fb5bbd6$export$4e7125c7ff595be5);
$parcel$export(module.exports, "orderedList", () => $eac94db34fb5bbd6$export$a5dc81035676e7a);
$parcel$export(module.exports, "orderedListWithOrder", () => $eac94db34fb5bbd6$export$b9ab759e8298198f);

var $7p61p = parcelRequire("7p61p");
var $eac94db34fb5bbd6$export$4e7125c7ff595be5 = '.ak-ol';
var $eac94db34fb5bbd6$export$a5dc81035676e7a = (0, $7p61p.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            class: $eac94db34fb5bbd6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
var $eac94db34fb5bbd6$var$resolveStart = function resolveStart(start) {
    var num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
var $eac94db34fb5bbd6$export$b9ab759e8298198f = (0, $7p61p.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    var start = $eac94db34fb5bbd6$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var start = $eac94db34fb5bbd6$var$resolveStart(node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order);
        var attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $eac94db34fb5bbd6$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("k9Kf6", function(module, exports) {

$parcel$export(module.exports, "paragraph", () => $eac884b5668b981c$export$9c206ddddb32a9b);

var $7p61p = parcelRequire("7p61p");
var $eac884b5668b981c$export$9c206ddddb32a9b = (0, $7p61p.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: function getAttrs(domNode) {
                var _paragraph$attrs, _paragraph$attrs$loca;
                var dom = domNode;
                var attrs = {
                    localId: dom.getAttribute('data-local-id') || ((_paragraph$attrs = $eac884b5668b981c$export$9c206ddddb32a9b.attrs) === null || _paragraph$attrs === void 0 ? void 0 : (_paragraph$attrs$loca = _paragraph$attrs.localId) === null || _paragraph$attrs$loca === void 0 ? void 0 : _paragraph$attrs$loca.default)
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var name = 'p';
        var attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name
        ].concat(attrs, [
            0
        ]);
    }
});

});

parcelRegister("VrJSs", function(module, exports) {

$parcel$export(module.exports, "emoji", () => $0acad75d62a58f8e$export$a19185d1233fc4b2);

var $lwQo4 = parcelRequire("lwQo4");

var $7p61p = parcelRequire("7p61p");
var $0acad75d62a58f8e$export$a19185d1233fc4b2 = (0, $7p61p.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $0acad75d62a58f8e$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $0acad75d62a58f8e$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $0acad75d62a58f8e$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: function getAttrs(dom) {
                return (0, $lwQo4.acNameToEmoji)(dom.getAttribute('data-emoticon-name'));
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: function getAttrs(dom) {
                return (0, $lwQo4.acShortcutToEmoji)(dom.getAttribute('data-hipchat-emoticon'));
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    shortName: dom.getAttribute('data-emoji-short-name') || $0acad75d62a58f8e$export$a19185d1233fc4b2.attrs.shortName.default,
                    id: dom.getAttribute('data-emoji-id') || $0acad75d62a58f8e$export$a19185d1233fc4b2.attrs.id.default,
                    text: dom.getAttribute('data-emoji-text') || $0acad75d62a58f8e$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, shortName = _node$attrs.shortName, id = _node$attrs.id, text = _node$attrs.text;
        var attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});
parcelRegister("lwQo4", function(module, exports) {

$parcel$export(module.exports, "acNameToEmoji", () => $fac539204c9b3417$export$f61e93bda2a8b420);
$parcel$export(module.exports, "acShortcutToEmoji", () => $fac539204c9b3417$export$441f8b58f5790a68);
$parcel$export(module.exports, "getEmojiAcName", () => $fac539204c9b3417$export$880a2465992fbbe);
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
var $fac539204c9b3417$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
var $fac539204c9b3417$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
var $fac539204c9b3417$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ var $fac539204c9b3417$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        "\uD83D\uDE42"
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        "\uD83D\uDE41"
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        "\uD83D\uDE1B"
    ],
    laugh: [
        '1f600',
        ':grinning:',
        "\uD83D\uDE00"
    ],
    wink: [
        '1f609',
        ':wink:',
        "\uD83D\uDE09"
    ],
    information: [
        '2139',
        ':information_source:',
        "\u2139"
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        "\u2705"
    ],
    cross: [
        '274c',
        ':x:',
        "\u274C"
    ],
    warning: [
        '26a0',
        ':warning:',
        "\u26A0"
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        "\u2795"
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        "\u2796"
    ],
    question: [
        '2753',
        ':question:',
        "?"
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        "\uD83D\uDC4D"
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        "\uD83D\uDC4E"
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        "\uD83D\uDCA1"
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        "\uD83D\uDC9B"
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        "\uD83D\uDEAB"
    ],
    'red-star': [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        "\uD83D\uDC9A"
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        "\uD83D\uDC99"
    ],
    heart: [
        '2764',
        ':heart:',
        "\u2764\uFE0F"
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        "\uD83D\uDC94"
    ]
};
function $fac539204c9b3417$export$f61e93bda2a8b420(acName) {
    var emojiData = $fac539204c9b3417$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $fac539204c9b3417$var$DEFAULT_EMOJI_ID,
        shortName: ":".concat(acName, ":"),
        text: ''
    };
}
function $fac539204c9b3417$export$bc94e44ec0e7bd82(emojiId) {
    var filterEmojis = function filterEmojis(acName) {
        return $fac539204c9b3417$var$acNameToEmojiMap[acName] ? $fac539204c9b3417$var$acNameToEmojiMap[acName][0] === emojiId : false;
    };
    return Object.keys($fac539204c9b3417$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $fac539204c9b3417$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: "".concat($fac539204c9b3417$var$HC_EMOTICON_PREFIX).concat(hipchatEmoticonShortName),
        shortName: ":".concat(hipchatEmoticonShortName, ":"),
        text: ''
    };
}
function $fac539204c9b3417$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $fac539204c9b3417$export$880a2465992fbbe(_ref) {
    var id = _ref.id, shortName = _ref.shortName;
    if ($fac539204c9b3417$var$DEFAULT_EMOJI_ID === id) {
        var possibleName = $fac539204c9b3417$var$getAcNameFromShortName(shortName);
        if (possibleName in $fac539204c9b3417$var$acNameToEmojiMap) return possibleName;
    }
    return $fac539204c9b3417$export$bc94e44ec0e7bd82(id) || $fac539204c9b3417$var$DEFAULT_EMOJI_ACNAME;
}

});


parcelRegister("iXL55", function(module, exports) {

$parcel$export(module.exports, "image", () => $dce241fa39f9bda5$export$5c452ff88e35e47d);

var $7p61p = parcelRequire("7p61p");
var $dce241fa39f9bda5$export$5c452ff88e35e47d = (0, $7p61p.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'img',
            node.attrs
        ];
    }
});

});

parcelRegister("ilnFA", function(module, exports) {

$parcel$export(module.exports, "mention", () => $d5ac8c742f4f523e$export$db83999c14438df4);
$parcel$export(module.exports, "toJSON", () => $d5ac8c742f4f523e$export$54fd2c36b5cc6731);

var $1tVDE = parcelRequire("1tVDE");

var $30K2d = parcelRequire("30K2d");

var $7p61p = parcelRequire("7p61p");
function $d5ac8c742f4f523e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d5ac8c742f4f523e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d5ac8c742f4f523e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d5ac8c742f4f523e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d5ac8c742f4f523e$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
var $d5ac8c742f4f523e$export$db83999c14438df4 = (0, $7p61p.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-mention-id') || $d5ac8c742f4f523e$export$db83999c14438df4.attrs.id.default,
                    text: dom.textContent || $d5ac8c742f4f523e$export$db83999c14438df4.attrs.text.default,
                    accessLevel: dom.getAttribute('data-access-level') || $d5ac8c742f4f523e$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $30K2d.uuid).generate()
                };
                var userType = dom.getAttribute('data-user-type');
                if ($d5ac8c742f4f523e$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, id = _node$attrs.id, accessLevel = _node$attrs.accessLevel, text = _node$attrs.text, userType = _node$attrs.userType, localId = _node$attrs.localId;
        var attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
var $d5ac8c742f4f523e$var$isOptional = function isOptional(key) {
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
var $d5ac8c742f4f523e$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($d5ac8c742f4f523e$var$isOptional(key) && !node.attrs[key]) return obj;
            return $d5ac8c742f4f523e$var$_objectSpread($d5ac8c742f4f523e$var$_objectSpread({}, obj), {}, (0, $1tVDE.default)({}, key, node.attrs[key]));
        }, {})
    };
};

});

parcelRegister("bljJ6", function(module, exports) {

$parcel$export(module.exports, "listItem", () => $8420f52272d36726$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "listItemWithTask", () => $8420f52272d36726$export$58dca2f0678302a4);
$parcel$export(module.exports, "listItemWithDecisionStage0", () => $8420f52272d36726$export$b2cd54d5ce935ddb);
$parcel$export(module.exports, "listItemWithoutNonBodiedMacros", () => $8420f52272d36726$export$171e9ff2be159af7);

var $7p61p = parcelRequire("7p61p");
var $8420f52272d36726$export$76c7e83ecc9cdf05 = (0, $7p61p.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $8420f52272d36726$export$58dca2f0678302a4 = $8420f52272d36726$export$76c7e83ecc9cdf05;
var $8420f52272d36726$export$b2cd54d5ce935ddb = (0, $7p61p.listItemWithNestedDecisionStage0)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});
var $8420f52272d36726$export$171e9ff2be159af7 = (0, $7p61p.listItemWithoutNonBodiedMacros)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM: function toDOM() {
        return [
            'li',
            0
        ];
    }
});

});

parcelRegister("kyLrk", function(module, exports) {

$parcel$export(module.exports, "PanelType", () => $ef7bc82a396a474a$export$969277cf61e5a7aa);
$parcel$export(module.exports, "extendedPanel", () => $ef7bc82a396a474a$export$ce20b13564211141);
$parcel$export(module.exports, "panelWithoutNestedNonBodiedMacros", () => $ef7bc82a396a474a$export$220c665c23b9541b);

var $1tVDE = parcelRequire("1tVDE");

var $7p61p = parcelRequire("7p61p");
function $ef7bc82a396a474a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ef7bc82a396a474a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ef7bc82a396a474a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ef7bc82a396a474a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ef7bc82a396a474a$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
/**
 * @name panel_node
 */ var $ef7bc82a396a474a$var$getDomAttrs = function getDomAttrs(nodeAttrs) {
    var attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor
    };
    return attrs;
};
var $ef7bc82a396a474a$var$getParseDOMAttrs = function getParseDOMAttrs(allowCustomPanel, dom) {
    var parseDOMAttrs = {
        panelType: dom.getAttribute('data-panel-type')
    };
    if (allowCustomPanel) parseDOMAttrs = $ef7bc82a396a474a$var$_objectSpread($ef7bc82a396a474a$var$_objectSpread({}, parseDOMAttrs), {}, {
        panelIcon: dom.getAttribute('data-panel-icon'),
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        panelColor: dom.getAttribute('data-panel-color')
    });
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === $ef7bc82a396a474a$export$969277cf61e5a7aa.CUSTOM ? $ef7bc82a396a474a$export$969277cf61e5a7aa.INFO : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
var $ef7bc82a396a474a$var$createPanelNodeSpecOptions = function createPanelNodeSpecOptions(allowCustomPanel) {
    return {
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: function getAttrs(dom) {
                    return $ef7bc82a396a474a$var$getParseDOMAttrs(allowCustomPanel, dom);
                }
            }
        ],
        toDOM: function toDOM(node) {
            var attrs = $ef7bc82a396a474a$var$getDomAttrs(node.attrs);
            var contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    };
};
var $ef7bc82a396a474a$export$ce20b13564211141 = function extendedPanel(allowCustomPanel) {
    return (0, $7p61p.panel)($ef7bc82a396a474a$var$createPanelNodeSpecOptions(allowCustomPanel));
};
var $ef7bc82a396a474a$export$220c665c23b9541b = function panelWithoutNestedNonBodiedMacros(allowCustomPanel) {
    return (0, $7p61p.panelWithoutNestedNonBodiedMacros)($ef7bc82a396a474a$var$createPanelNodeSpecOptions(allowCustomPanel));
};

});

parcelRegister("2UNHE", function(module, exports) {

$parcel$export(module.exports, "text", () => $21f75db79d9868f5$export$6f093cfa640b7166);

var $7p61p = parcelRequire("7p61p");
var $21f75db79d9868f5$export$6f093cfa640b7166 = (0, $7p61p.text)({
    toDebugString: function() {
        return 'text_node';
    }
});

});

parcelRegister("gl6qh", function(module, exports) {

$parcel$export(module.exports, "default", () => $be5396f286b03563$export$2e2bcd8739ae039);
var $be5396f286b03563$var$name = 'unknownBlock';
var $be5396f286b03563$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': $be5396f286b03563$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: "div[data-node-type=\"".concat($be5396f286b03563$var$name, "\"]")
        }
    ]
};

});

parcelRegister("DPd50", function(module, exports) {

$parcel$export(module.exports, "caption", () => $077b5ddd635c6e79$export$8e3c2dfdc4f0453d);

var $7p61p = parcelRequire("7p61p");
var $077b5ddd635c6e79$export$8e3c2dfdc4f0453d = (0, $7p61p.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});

});

parcelRegister("jGJid", function(module, exports) {

$parcel$export(module.exports, "createMediaSpec", () => $e55512caa440ae02$export$35bdbf5bc8caa677);
$parcel$export(module.exports, "copyPrivateAttributes", () => $e55512caa440ae02$export$111130fa8968d741);
$parcel$export(module.exports, "media", () => $e55512caa440ae02$export$987d49ffe1b0900f);
$parcel$export(module.exports, "toJSON", () => $e55512caa440ae02$export$54fd2c36b5cc6731);

var $2g8PV = parcelRequire("2g8PV");

var $7p61p = parcelRequire("7p61p");
var $e55512caa440ae02$export$bb3fe706be61f640 = (0, $7p61p.media)({}).attrs;
var $e55512caa440ae02$export$35bdbf5bc8caa677 = function createMediaSpec(attributes) {
    var inline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var domNodeType = inline ? 'span' : 'div';
    var nodeName = inline ? 'mediaInline' : 'media';
    var parseDOM = [
        {
            tag: "".concat(domNodeType, "[data-node-type=\"").concat(nodeName, "\"]"),
            getAttrs: function getAttrs(dom) {
                var attrs = {};
                if (attributes) Object.keys(attributes).forEach(function(k) {
                    var key = $e55512caa440ae02$export$f84fdfb973c05bd8(k).replace(/^__/, '');
                    var value = dom.getAttribute("data-".concat(key)) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                var width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                var height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    var toDOM = function toDOM(node) {
        var attrs = {
            'data-id': node.attrs.id,
            'data-node-type': "".concat(nodeName),
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: "display: inline-block; border-radius: 3px; background: ".concat((0, $2g8PV.N30), "; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);")
        };
        $e55512caa440ae02$export$111130fa8968d741(node.attrs, attrs, function(key) {
            return "data-".concat($e55512caa440ae02$export$f84fdfb973c05bd8(key.slice(2)));
        });
        return [
            "".concat(domNodeType),
            attrs
        ];
    };
    if (inline) return (0, $7p61p.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $7p61p.media)({
        parseDOM: [].concat(parseDOM, [
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: function getAttrs(dom) {
                    return {
                        type: 'external',
                        url: dom.getAttribute('src') || '',
                        alt: dom.getAttribute('alt') || ''
                    };
                }
            }
        ]),
        toDOM: toDOM
    });
};
var $e55512caa440ae02$export$987d49ffe1b0900f = $e55512caa440ae02$export$35bdbf5bc8caa677($e55512caa440ae02$export$bb3fe706be61f640, false);
var $e55512caa440ae02$export$f84fdfb973c05bd8 = function camelCaseToKebabCase(str) {
    return str.replace(/([^A-Z]+)([A-Z])/g, function(_, x, y) {
        return "".concat(x, "-").concat(y.toLowerCase());
    });
};
var $e55512caa440ae02$export$111130fa8968d741 = function copyPrivateAttributes(from, to, map) {
    if ($e55512caa440ae02$export$987d49ffe1b0900f.attrs) Object.keys($e55512caa440ae02$export$987d49ffe1b0900f.attrs).forEach(function(key) {
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ var $e55512caa440ae02$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt'
];
var $e55512caa440ae02$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt'
];
var $e55512caa440ae02$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter(function(key) {
            return !(key[0] === '_' && key[1] === '_');
        }).reduce(function(obj, key) {
            if (node.attrs.type === 'external' && $e55512caa440ae02$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($e55512caa440ae02$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("2g8PV", function(module, exports) {

$parcel$export(module.exports, "R50", () => $1a53ee210d9067e4$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $1a53ee210d9067e4$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $1a53ee210d9067e4$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R300", () => $1a53ee210d9067e4$export$4a7404f376229999);
$parcel$export(module.exports, "R500", () => $1a53ee210d9067e4$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $1a53ee210d9067e4$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $1a53ee210d9067e4$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y200", () => $1a53ee210d9067e4$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y400", () => $1a53ee210d9067e4$export$59619663aa6500fb);
$parcel$export(module.exports, "G50", () => $1a53ee210d9067e4$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $1a53ee210d9067e4$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G200", () => $1a53ee210d9067e4$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $1a53ee210d9067e4$export$940e1f69e873f202);
$parcel$export(module.exports, "G500", () => $1a53ee210d9067e4$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $1a53ee210d9067e4$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $1a53ee210d9067e4$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $1a53ee210d9067e4$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B400", () => $1a53ee210d9067e4$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $1a53ee210d9067e4$export$a6ee3d71bc067634);
$parcel$export(module.exports, "L200", () => $1a53ee210d9067e4$export$f72948ef771f6f15);
$parcel$export(module.exports, "N0", () => $1a53ee210d9067e4$export$29a4f05edc054374);
$parcel$export(module.exports, "N20", () => $1a53ee210d9067e4$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $1a53ee210d9067e4$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N60", () => $1a53ee210d9067e4$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N80", () => $1a53ee210d9067e4$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "Neutral300", () => $1a53ee210d9067e4$export$1ae1cebe22dcedb4);
$parcel$export(module.exports, "N300A", () => $1a53ee210d9067e4$export$13609db0e6812ab8);
$parcel$export(module.exports, "N600", () => $1a53ee210d9067e4$export$7090862dc3038a9f);
$parcel$export(module.exports, "N800", () => $1a53ee210d9067e4$export$7d61b15e0da132af);
$parcel$export(module.exports, "N1000", () => $1a53ee210d9067e4$export$f78789c8b01753cd);
$parcel$export(module.exports, "M200", () => $1a53ee210d9067e4$export$a19f0c33186f7767);
$parcel$export(module.exports, "O200", () => $1a53ee210d9067e4$export$51716a84e62e022c);
$parcel$export(module.exports, "P50", () => $1a53ee210d9067e4$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $1a53ee210d9067e4$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $1a53ee210d9067e4$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $1a53ee210d9067e4$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $1a53ee210d9067e4$export$b48405b95304b5a1);
$parcel$export(module.exports, "P500", () => $1a53ee210d9067e4$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $1a53ee210d9067e4$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $1a53ee210d9067e4$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $1a53ee210d9067e4$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $1a53ee210d9067e4$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $1a53ee210d9067e4$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T500", () => $1a53ee210d9067e4$export$6036577f95c3877e);
$parcel$export(module.exports, "normalizeHexColor", () => $1a53ee210d9067e4$export$b61655071712e690);
$parcel$export(module.exports, "isHex", () => $1a53ee210d9067e4$export$8a9b6341a7c96bc);
$parcel$export(module.exports, "isRgb", () => $1a53ee210d9067e4$export$e698776ec826343);
$parcel$export(module.exports, "rgbToHex", () => $1a53ee210d9067e4$export$34d09c4a771c46ef);
$parcel$export(module.exports, "hexToRgb", () => $1a53ee210d9067e4$export$5a544e13ad4e1fa5);
$parcel$export(module.exports, "hexToRgba", () => $1a53ee210d9067e4$export$9665a07d9187b414);

var $8GwJ7 = parcelRequire("8GwJ7");

var $98eGx = parcelRequire("98eGx");
var $1a53ee210d9067e4$export$4b84fd0e2c617bd = '#FFEBE6';
var $1a53ee210d9067e4$export$b34b069eff244586 = '#FFBDAD';
var $1a53ee210d9067e4$export$be802dd0d8b57f35 = '#FF8F73';
var $1a53ee210d9067e4$export$4a7404f376229999 = '#FF5630';
var $1a53ee210d9067e4$export$2010d0fb4295b346 = '#DE350B';
var $1a53ee210d9067e4$export$2837b5a1a71d5c02 = '#BF2600';
var $1a53ee210d9067e4$export$8d9596b529bbb9cf = '#FFFAE6';
var $1a53ee210d9067e4$export$41060a744ab0b7ae = '#FFF0B3';
var $1a53ee210d9067e4$export$5aae31392d72caaa = '#FFC400';
var $1a53ee210d9067e4$export$59619663aa6500fb = '#FF991F';
var $1a53ee210d9067e4$export$874739ea9e379ab6 = '#FF8B00';
var $1a53ee210d9067e4$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $1a53ee210d9067e4$export$69a3bf21b9686c2b = '#ABF5D1';
var $1a53ee210d9067e4$export$747d86715d4175de = '#57D9A3';
var $1a53ee210d9067e4$export$940e1f69e873f202 = '#36B37E';
var $1a53ee210d9067e4$export$a49394138f7b8e85 = '#00875A';
var $1a53ee210d9067e4$export$6fa04827ac68a4fb = '#006644';
var $1a53ee210d9067e4$export$226de0355ed012f8 = '#DEEBFF';
var $1a53ee210d9067e4$export$8c13c2ee36917869 = '#B3D4FF';
var $1a53ee210d9067e4$export$ecfc1dff386a3e7a = '#4C9AFF';
var $1a53ee210d9067e4$export$b3de0ae08da2ce64 = '#0052CC';
var $1a53ee210d9067e4$export$a6ee3d71bc067634 = '#0747A6';
var $1a53ee210d9067e4$export$f72948ef771f6f15 = '#D3F1A7';
var $1a53ee210d9067e4$export$29a4f05edc054374 = '#FFFFFF';
var $1a53ee210d9067e4$export$9fdfb749e33cdf97 = '#F4F5F7';
var $1a53ee210d9067e4$export$3e51e8f1440314ba = '#EBECF0';
var $1a53ee210d9067e4$export$1ce2d1575d444ceb = '#DFE1E6';
var $1a53ee210d9067e4$export$8754fc7e6d8b3000 = '#C1C7D0';
var $1a53ee210d9067e4$export$c2e91cbeada39b8b = '#B3BAC5';
var $1a53ee210d9067e4$export$eaa8c8a70ac22806 = '#97A0AF';
var $1a53ee210d9067e4$export$7c87d337fb91a97d = '#8993A4';
var $1a53ee210d9067e4$export$f563ee71e9ee74cd = '#6B778C';
var $1a53ee210d9067e4$export$e2ef2124cf4024b1 = '#5E6C84';
var $1a53ee210d9067e4$export$1ae1cebe22dcedb4 = '#DCDFE4';
var $1a53ee210d9067e4$export$13609db0e6812ab8 = '#091E4224';
var $1a53ee210d9067e4$export$c39c0fe0f26207ae = '#42526E';
var $1a53ee210d9067e4$export$7090862dc3038a9f = '#758195';
var $1a53ee210d9067e4$export$7d61b15e0da132af = '#172B4D';
var $1a53ee210d9067e4$export$f78789c8b01753cd = '#172B4D';
var $1a53ee210d9067e4$export$a19f0c33186f7767 = '#FDD0EC';
var $1a53ee210d9067e4$export$51716a84e62e022c = '#FEDEC8';
var $1a53ee210d9067e4$export$363e4475840015bb = '#EAE6FF';
var $1a53ee210d9067e4$export$4b0a4417ed59760f = '#C0B6F2';
var $1a53ee210d9067e4$export$6011520a64d9a187 = '#998DD9';
var $1a53ee210d9067e4$export$a7175d4e9206bc80 = '#DFD8FD';
var $1a53ee210d9067e4$export$b48405b95304b5a1 = '#6554C0';
var $1a53ee210d9067e4$export$c71e4279dd54a18d = '#5243AA';
var $1a53ee210d9067e4$export$147899de772240ec = '#403294';
var $1a53ee210d9067e4$export$2cf711fe14c66f06 = '#E6FCFF';
var $1a53ee210d9067e4$export$7a8f4d33f6f9772c = '#B3F5FF';
var $1a53ee210d9067e4$export$776c9c497ef08533 = '#79E2F2';
var $1a53ee210d9067e4$export$69cb3ca10c1e330e = '#C6EDFB';
var $1a53ee210d9067e4$export$9dc1ef0f3f48059b = '#00B8D9';
var $1a53ee210d9067e4$export$6036577f95c3877e = '#008DA6';
function $1a53ee210d9067e4$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($1a53ee210d9067e4$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map(function(c) {
            return c === '#' ? '#' : "".concat(c).concat(c);
        }).join('');
    } else if ($1a53ee210d9067e4$export$e698776ec826343(color)) return $1a53ee210d9067e4$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if ($98eGx.default && $98eGx.default[color]) color = $98eGx.default[color];
        else if ($98eGx && $98eGx[color]) color = $98eGx[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $1a53ee210d9067e4$export$5a544e13ad4e1fa5(color) {
    if (!$1a53ee210d9067e4$export$8a9b6341a7c96bc(color)) return null;
    var colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    var rgb = Number("0x".concat(colorBits.join('')));
    // eslint-disable-next-line no-bitwise
    return "rgb(".concat(rgb >> 16 & 255, ",").concat(rgb >> 8 & 255, ",").concat(rgb & 255, ")");
}
function $1a53ee210d9067e4$export$9665a07d9187b414(rawColor, alpha) {
    var color = $1a53ee210d9067e4$export$b61655071712e690(rawColor);
    if (!color) return null;
    var hex2rgb = function hex2rgb(color) {
        return color.match(/[a-z0-9]{2}/gi).map(function(hex) {
            return parseInt(hex, 16);
        });
    };
    return "rgba(".concat(hex2rgb(color).concat(alpha).join(','), ")");
}
function $1a53ee210d9067e4$export$34d09c4a771c46ef(value) {
    var matches = value.match(/(0?\.?\d{1,3})%?\b/g);
    if (matches && matches.length >= 3) {
        var _matches$map = matches.map(Number), _matches$map2 = (0, $8GwJ7.default)(_matches$map, 3), red = _matches$map2[0], green = _matches$map2[1], blue = _matches$map2[2];
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1) // eslint-disable-line no-bitwise
        ;
    }
    return null;
}
function $1a53ee210d9067e4$export$e698776ec826343(color) {
    return /rgba?\(/.test(color);
}
function $1a53ee210d9067e4$export$8a9b6341a7c96bc(color) {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(color);
}

});


parcelRegister("cApIr", function(module, exports) {

$parcel$export(module.exports, "mediaGroup", () => $929ccb7897cd7e66$export$2855e964765eac9);

var $7p61p = parcelRequire("7p61p");
var $929ccb7897cd7e66$export$2855e964765eac9 = (0, $7p61p.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM: function toDOM() {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});

});

parcelRegister("j99rC", function(module, exports) {

$parcel$export(module.exports, "mediaInline", () => $df062f109ba1df0f$export$38bab695e3f720f1);

var $jGJid = parcelRequire("jGJid");

var $7p61p = parcelRequire("7p61p");
var $df062f109ba1df0f$export$38bab695e3f720f1 = (0, $jGJid.createMediaSpec)((0, $7p61p.mediaInline)({}).attrs, true);

});

parcelRegister("dQPhK", function(module, exports) {

$parcel$export(module.exports, "mediaSingleSpec", () => $a157e9da5c2f28a5$export$5a1e124099b60c6b);
$parcel$export(module.exports, "mediaSingle", () => $a157e9da5c2f28a5$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingleWithCaption", () => $a157e9da5c2f28a5$export$d35e6c006d4abdfb);
$parcel$export(module.exports, "mediaSingleWithWidthType", () => $a157e9da5c2f28a5$export$9c58e19811ce4cf5);
$parcel$export(module.exports, "mediaSingleFull", () => $a157e9da5c2f28a5$export$7e767666f2ce108a);
$parcel$export(module.exports, "toJSON", () => $a157e9da5c2f28a5$export$54fd2c36b5cc6731);

var $1tVDE = parcelRequire("1tVDE");

var $lDLdB = parcelRequire("lDLdB");

var $c5sSV = parcelRequire("c5sSV");

var $7p61p = parcelRequire("7p61p");
function $a157e9da5c2f28a5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a157e9da5c2f28a5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a157e9da5c2f28a5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a157e9da5c2f28a5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a157e9da5c2f28a5$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    // null makes small images to have original size by default
    layout: {
        default: 'center'
    }
};
var $a157e9da5c2f28a5$export$5a1e124099b60c6b = function mediaSingleSpec(_ref) {
    var _ref$withCaption = _ref.withCaption, withCaption = _ref$withCaption === void 0 ? false : _ref$withCaption, _ref$withExtendedWidt = _ref.withExtendedWidthTypes, withExtendedWidthTypes = _ref$withExtendedWidt === void 0 ? false : _ref$withExtendedWidt;
    var getAttrs = function getAttrs(dom) {
        if (!(0, $c5sSV.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        var layout = dom.getAttribute('data-layout') || 'center';
        var width = Number(dom.getAttribute('data-width')) || null;
        var widthType = dom.getAttribute('data-width-type');
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $lDLdB.WidthType).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    var getAttrsFromNode = function getAttrsFromNode(node) {
        var _node$attrs = node.attrs, layout = _node$attrs.layout, width = _node$attrs.width;
        var attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            var widthType = node.attrs.widthType;
            return $a157e9da5c2f28a5$var$_objectSpread($a157e9da5c2f28a5$var$_objectSpread({}, attrs), {}, {
                'data-width-type': widthType || (0, $lDLdB.WidthType).PERCENTAGE
            });
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $7p61p.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $7p61p.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $7p61p.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $7p61p.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM: function toDOM(node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
var $a157e9da5c2f28a5$export$969fe3781ca15058 = $a157e9da5c2f28a5$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
var $a157e9da5c2f28a5$export$d35e6c006d4abdfb = $a157e9da5c2f28a5$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
var $a157e9da5c2f28a5$export$9c58e19811ce4cf5 = $a157e9da5c2f28a5$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
var $a157e9da5c2f28a5$export$7e767666f2ce108a = $a157e9da5c2f28a5$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
var $a157e9da5c2f28a5$export$54fd2c36b5cc6731 = function toJSON(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};

});
parcelRegister("lDLdB", function(module, exports) {

$parcel$export(module.exports, "WidthType", () => $fc11de107a7d71da$export$4d41558722ac7eed);
/**
 * @description The widthType attribute is used to support fixed with media single
 */ var $fc11de107a7d71da$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});

});

parcelRegister("c5sSV", function(module, exports) {

$parcel$export(module.exports, "isDOMElement", () => $8ccc5ba0d9ac01e9$export$c296e2d4365c37a5);
var $8ccc5ba0d9ac01e9$export$c296e2d4365c37a5 = function isDOMElement(maybeNode) {
    return maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
};

});


parcelRegister("65GP4", function(module, exports) {

$parcel$export(module.exports, "tablePrefixSelector", () => $46f46d6d32249daa$export$9cfceb893b24742a);
$parcel$export(module.exports, "tableCellSelector", () => $46f46d6d32249daa$export$69cb4c3f80383763);
$parcel$export(module.exports, "tableHeaderSelector", () => $46f46d6d32249daa$export$7b07d37d879c957f);
$parcel$export(module.exports, "tableCellContentWrapperSelector", () => $46f46d6d32249daa$export$8dd42a84cd52da07);
$parcel$export(module.exports, "tableCellContentDomSelector", () => $46f46d6d32249daa$export$5e26a5c19f0865d8);
$parcel$export(module.exports, "getCellAttrs", () => $46f46d6d32249daa$export$43977bde391e007);
$parcel$export(module.exports, "getCellDomAttrs", () => $46f46d6d32249daa$export$363c8dda799bfe9c);
$parcel$export(module.exports, "tableBackgroundColorNames", () => $46f46d6d32249daa$export$8cc2833b5b349a1e);
$parcel$export(module.exports, "tableBackgroundColorPalette", () => $46f46d6d32249daa$export$219b7f492ad209f8);
$parcel$export(module.exports, "tableBackgroundBorderColor", () => $46f46d6d32249daa$export$95e9c925fbf01d1c);
$parcel$export(module.exports, "table", () => $46f46d6d32249daa$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableWithCustomWidth", () => $46f46d6d32249daa$export$90e634fbace1f0c4);
$parcel$export(module.exports, "tableStage0", () => $46f46d6d32249daa$export$3862de5c8c9098cf);
$parcel$export(module.exports, "tableToJSON", () => $46f46d6d32249daa$export$1f92a2f429e06fa8);
$parcel$export(module.exports, "tableRow", () => $46f46d6d32249daa$export$ce666bf02318c957);
$parcel$export(module.exports, "tableCell", () => $46f46d6d32249daa$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "toJSONTableCell", () => $46f46d6d32249daa$export$2ac34c099660f1a8);
$parcel$export(module.exports, "tableHeader", () => $46f46d6d32249daa$export$48884d2a5190dc73);
$parcel$export(module.exports, "toJSONTableHeader", () => $46f46d6d32249daa$export$2af48797a1010bb1);
$parcel$export(module.exports, "tableWithNestedTable", () => $46f46d6d32249daa$export$ce086a560a1d05f5);
$parcel$export(module.exports, "tableRowWithNestedTable", () => $46f46d6d32249daa$export$7d657479499397);
$parcel$export(module.exports, "tableCellWithNestedTable", () => $46f46d6d32249daa$export$abf39ca178940ff3);
$parcel$export(module.exports, "tableHeaderWithNestedTable", () => $46f46d6d32249daa$export$2a5a518232fa1a97);

var $1tVDE = parcelRequire("1tVDE");

var $8GwJ7 = parcelRequire("8GwJ7");

var $lv4UF = parcelRequire("lv4UF");

var $2g8PV = parcelRequire("2g8PV");

var $30K2d = parcelRequire("30K2d");

var $7zyDf = parcelRequire("7zyDf");

var $7p61p = parcelRequire("7p61p");
function $46f46d6d32249daa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $46f46d6d32249daa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $46f46d6d32249daa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $46f46d6d32249daa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $46f46d6d32249daa$export$9cfceb893b24742a = 'pm-table';
var $46f46d6d32249daa$export$69cb4c3f80383763 = "".concat($46f46d6d32249daa$export$9cfceb893b24742a, "-cell-content-wrap");
var $46f46d6d32249daa$export$7b07d37d879c957f = "".concat($46f46d6d32249daa$export$9cfceb893b24742a, "-header-content-wrap");
var $46f46d6d32249daa$export$8dd42a84cd52da07 = "".concat($46f46d6d32249daa$export$9cfceb893b24742a, "-cell-nodeview-wrapper");
var $46f46d6d32249daa$export$5e26a5c19f0865d8 = "".concat($46f46d6d32249daa$export$9cfceb893b24742a, "-cell-nodeview-content-dom");
var $46f46d6d32249daa$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $2g8PV.N20).toLocaleLowerCase();
var $46f46d6d32249daa$export$43977bde391e007 = function getCellAttrs(dom) {
    var defaultValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var widthAttr = dom.getAttribute('data-colwidth');
    var width = widthAttr && /^\d+(,\d+)*$/.test(widthAttr) ? widthAttr.split(',').map(function(str) {
        return Number(str);
    }) : null;
    var colspan = Number(dom.getAttribute('colspan') || 1);
    var backgroundColor = dom.style.backgroundColor;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ var dataCellBackground = dom.getAttribute('data-cell-background');
    var dataCellBackgroundHexCode = dataCellBackground && (0, $2g8PV.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $2g8PV.isRgb)(backgroundColor)) {
        var result = (0, $2g8PV.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    var backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode
    };
};
// these are for test only
var $46f46d6d32249daa$var$testGlobalTheme;
var $46f46d6d32249daa$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $46f46d6d32249daa$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
var $46f46d6d32249daa$var$getGlobalTheme = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($46f46d6d32249daa$var$testGlobalTheme) return {
        colorMode: $46f46d6d32249daa$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $46f46d6d32249daa$var$cssVariablePattern = /^var\(--.*\)$/;
var $46f46d6d32249daa$export$363c8dda799bfe9c = function getCellDomAttrs(node) {
    var attrs = {};
    var nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        var background = node.attrs.background;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        var ignored = nodeType === 'tableHeader' && background === $46f46d6d32249daa$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $46f46d6d32249daa$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            var color = (0, $2g8PV.isRgb)(background) && (0, $2g8PV.rgbToHex)(background) ? (0, $2g8PV.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ var tokenColor = (0, $lv4UF.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = "background-color: ".concat(tokenColor, ";");
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $46f46d6d32249daa$var$cssVariablePattern.test(color)) attrs.style = "background-color: ".concat(color, ";");
            else // if we have a custom color, we need to check if we are in dark mode
            if ($46f46d6d32249daa$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = "background-color: ".concat((0, $7zyDf.getDarkModeLCHColor)(color), ";");
            else // if we are in light mode, we can just set the color
            attrs.style = "background-color: ".concat(background, ";");
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            attrs.colorname = $46f46d6d32249daa$export$219b7f492ad209f8.get(color);
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $46f46d6d32249daa$export$7b07d37d879c957f;
    else attrs.class = $46f46d6d32249daa$export$69cb4c3f80383763;
    return attrs;
};
var $46f46d6d32249daa$export$219b7f492ad209f8 = new Map();
var $46f46d6d32249daa$export$95e9c925fbf01d1c = (0, $2g8PV.hexToRgba)((0, $2g8PV.N800), 0.12) || (0, $2g8PV.N0);
var $46f46d6d32249daa$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $2g8PV.N0),
        'White'
    ],
    [
        (0, $2g8PV.B50),
        'Light blue'
    ],
    [
        (0, $2g8PV.T50),
        'Light teal'
    ],
    [
        (0, $2g8PV.G50),
        'Light green'
    ],
    [
        (0, $2g8PV.Y50),
        'Light yellow'
    ],
    [
        (0, $2g8PV.R50),
        'Light red'
    ],
    [
        (0, $2g8PV.P50),
        'Light purple'
    ],
    [
        (0, $2g8PV.N20),
        'Light gray'
    ],
    [
        (0, $2g8PV.B75),
        'Blue'
    ],
    [
        (0, $2g8PV.T75),
        'Teal'
    ],
    [
        (0, $2g8PV.G75),
        'Green'
    ],
    [
        (0, $2g8PV.Y75),
        'Yellow'
    ],
    [
        (0, $2g8PV.R75),
        'Red'
    ],
    [
        (0, $2g8PV.P75),
        'Purple'
    ],
    [
        (0, $2g8PV.N60),
        'Gray'
    ],
    [
        (0, $2g8PV.B100),
        'Dark blue'
    ],
    [
        (0, $2g8PV.T100),
        'Dark teal'
    ],
    [
        (0, $2g8PV.G200),
        'Dark green'
    ],
    [
        (0, $2g8PV.Y200),
        'Dark yellow'
    ],
    [
        (0, $2g8PV.R100),
        'Dark red'
    ],
    [
        (0, $2g8PV.P100),
        'Dark purple'
    ]
].forEach(function(_ref) {
    var _ref2 = (0, $8GwJ7.default)(_ref, 2), colorValue = _ref2[0], colorName = _ref2[1];
    $46f46d6d32249daa$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $46f46d6d32249daa$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
/**
 * @name table_node
 */ /**
 * @name table_row_node
 */ /**
 * @name table_cell_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name table_cell_node
 */ /**
 * @name table_header_node
 */ // table nodes with nested tables support
var $46f46d6d32249daa$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: function getAttrs(node) {
                var _dom$parentElement;
                var dom = node;
                var breakoutWrapper = (_dom$parentElement = dom.parentElement) === null || _dom$parentElement === void 0 ? void 0 : _dom$parentElement.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || // copying from renderer
                    (breakoutWrapper === null || breakoutWrapper === void 0 ? void 0 : breakoutWrapper.getAttribute('data-layout')) || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $30K2d.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: Fix any, potential issue. ED-5048
var $46f46d6d32249daa$var$createTableSpec = function createTableSpec() {
    return (0, $7p61p.table)($46f46d6d32249daa$var$tableNodeSpecOptions);
};
var $46f46d6d32249daa$export$9852986a3ec5f6a0 = $46f46d6d32249daa$var$createTableSpec();
var $46f46d6d32249daa$export$90e634fbace1f0c4 = $46f46d6d32249daa$var$createTableSpec();
var $46f46d6d32249daa$export$3862de5c8c9098cf = $46f46d6d32249daa$var$createTableSpec();
var $46f46d6d32249daa$var$shouldIncludeAttribute = function shouldIncludeAttribute(key, value) {
    return !key.startsWith('__') && (key !== 'localId' || !!value);
};
var $46f46d6d32249daa$export$1f92a2f429e06fa8 = function tableToJSON(node) {
    return {
        attrs: Object.keys(node.attrs).filter(function(key) {
            return $46f46d6d32249daa$var$shouldIncludeAttribute(key, node.attrs[key]);
        }).reduce(function(obj, key) {
            return $46f46d6d32249daa$var$_objectSpread($46f46d6d32249daa$var$_objectSpread({}, obj), {}, (0, $1tVDE.default)({}, key, node.attrs[key]));
        }, {})
    };
};
var $46f46d6d32249daa$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM: function toDOM() {
        return [
            'tr',
            0
        ];
    }
};
var $46f46d6d32249daa$export$ce666bf02318c957 = (0, $7p61p.tableRow)($46f46d6d32249daa$var$tableRowNodeSpecOptions);
var $46f46d6d32249daa$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    }
};
var $46f46d6d32249daa$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            getAttrs: function getAttrs(dom) {
                return $46f46d6d32249daa$export$43977bde391e007(dom);
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'td',
            $46f46d6d32249daa$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $46f46d6d32249daa$export$e1e720e5f4603e6a = (0, $7p61p.tableCell)($46f46d6d32249daa$var$tableCellNodeSpecOptions);
var $46f46d6d32249daa$export$2ac34c099660f1a8 = function toJSONTableCell(node) {
    return {
        attrs: Object.keys(node.attrs).reduce(function(obj, key) {
            if ($46f46d6d32249daa$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    };
};
var $46f46d6d32249daa$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: function getAttrs(dom) {
                return $46f46d6d32249daa$export$43977bde391e007(dom, {
                    background: $46f46d6d32249daa$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                });
            }
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'th',
            $46f46d6d32249daa$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
var $46f46d6d32249daa$export$48884d2a5190dc73 = (0, $7p61p.tableHeader)($46f46d6d32249daa$var$tableHeaderNodeSpecOptions);
var $46f46d6d32249daa$export$2af48797a1010bb1 = $46f46d6d32249daa$export$2ac34c099660f1a8;
var $46f46d6d32249daa$export$ce086a560a1d05f5 = (0, $7p61p.tableWithNestedTable)($46f46d6d32249daa$var$tableNodeSpecOptions);
var $46f46d6d32249daa$export$7d657479499397 = (0, $7p61p.tableRowWithNestedTable)($46f46d6d32249daa$var$tableRowNodeSpecOptions);
var $46f46d6d32249daa$export$abf39ca178940ff3 = (0, $7p61p.tableCellWithNestedTable)($46f46d6d32249daa$var$tableCellNodeSpecOptions);
var $46f46d6d32249daa$export$2a5a518232fa1a97 = (0, $7p61p.tableHeaderWithNestedTable)($46f46d6d32249daa$var$tableHeaderNodeSpecOptions);

});
parcelRegister("lv4UF", function(module, exports) {

$parcel$export(module.exports, "hexToEditorBorderPaletteColor", () => $fa704dd8ad2611e8$export$bad3c41dd33cb4bc);
$parcel$export(module.exports, "hexToEditorTextPaletteColor", () => $fa704dd8ad2611e8$export$9c2f408d391feb93);
$parcel$export(module.exports, "hexToEditorTextBackgroundPaletteColor", () => $fa704dd8ad2611e8$export$8b58ff1b36bb75e0);
$parcel$export(module.exports, "hexToEditorBackgroundPaletteRawValue", () => $fa704dd8ad2611e8$export$a270511a0e7fd61a);

var $c6GJD = parcelRequire("c6GJD");
function $fa704dd8ad2611e8$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $fa704dd8ad2611e8$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
var $fa704dd8ad2611e8$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $fa704dd8ad2611e8$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    return hexColor ? $fa704dd8ad2611e8$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
var $fa704dd8ad2611e8$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $fa704dd8ad2611e8$export$8b58ff1b36bb75e0(hexColor) {
    var orangeToYellowEnabled = (0, $c6GJD.default).getExperimentValue('editor_text_highlight_orange_to_yellow', 'cohort', 'control', {
        fireExperimentExposure: true
    });
    if (orangeToYellowEnabled === 'test') $fa704dd8ad2611e8$export$12a518ff137dd389['#FEDEC8'] = 'var(--ds-background-accent-yellow-subtler, #F8E6A0)';
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    return hexColor ? $fa704dd8ad2611e8$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
var $fa704dd8ad2611e8$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $fa704dd8ad2611e8$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    var tokenData = hexColor ? $fa704dd8ad2611e8$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
var $fa704dd8ad2611e8$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: function getValue() {
            return '#DEEBFF';
        },
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: function getValue() {
            return '#B3D4FF';
        },
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: function getValue() {
            return '#4C9AFF';
        },
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: function getValue() {
            return '#E6FCFF';
        },
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: function getValue() {
            return '#B3F5FF';
        },
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: function getValue() {
            return '#79E2F2';
        },
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: function getValue() {
            return '#E3FCEF';
        },
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: function getValue() {
            return '#ABF5D1';
        },
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: function getValue() {
            return '#57D9A3';
        },
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: function getValue() {
            return '#FFFAE6';
        },
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: function getValue() {
            return '#FFF0B3';
        },
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: function getValue() {
            return '#FFC400';
        },
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: function getValue() {
            return '#FFEBE6';
        },
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: function getValue() {
            return '#FFBDAD';
        },
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: function getValue() {
            return '#FF8F73';
        },
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: function getValue() {
            return '#EAE6FF';
        },
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: function getValue() {
            return '#C0B6F2';
        },
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: function getValue() {
            return '#998DD9';
        },
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: function getValue() {
            return '#FFFFFF';
        },
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: function getValue() {
            return '#F4F5F7';
        },
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: function getValue() {
            return '#B3BAC5';
        },
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};

});

parcelRegister("7zyDf", function(module, exports) {

$parcel$export(module.exports, "getDarkModeLCHColor", () => $5836aa799e5e130a$export$a5065c3b8aacaf99);
// https://en.wikipedia.org/wiki/HCL_color_space
// https://en.wikipedia.org/wiki/CIE_1931_color_space#CIE_xy_chromaticity_diagram_and_the_CIE_xyY_color_space
// https://en.wikipedia.org/wiki/CIELAB_color_space
var $5836aa799e5e130a$var$clamp = function clamp(i, min, max) {
    return Math.round(Math.min(Math.max(i, min), max));
};
var $5836aa799e5e130a$var$expandShorthandHex = function expandShorthandHex(input) {
    return input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });
};
var $5836aa799e5e130a$var$rgbFromHex = function rgbFromHex(input) {
    var fullHex = $5836aa799e5e130a$var$expandShorthandHex(input);
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
var $5836aa799e5e130a$var$rgbToHex = function rgbToHex(_ref) {
    var r = _ref.r, g = _ref.g, b = _ref.b;
    var convertComponent = function convertComponent(c) {
        var cBase16 = c.toString(16);
        return cBase16.length === 1 ? "0".concat(cBase16) : cBase16;
    };
    return "#".concat(convertComponent(r)).concat(convertComponent(g)).concat(convertComponent(b));
};
var $5836aa799e5e130a$var$rgbToXyz = function rgbToXyz(rgb) {
    var convertRgbComponent = function convertRgbComponent(c) {
        return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    };
    var convertXyzComponent = function convertXyzComponent(c) {
        return c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    };
    var r = convertRgbComponent(rgb.r / 255);
    var g = convertRgbComponent(rgb.g / 255);
    var b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
var $5836aa799e5e130a$var$xyzToLab = function xyzToLab(_ref2) {
    var x = _ref2.x, y = _ref2.y, z = _ref2.z;
    return {
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    };
};
var $5836aa799e5e130a$var$labToLch = function labToLch(_ref3) {
    var l = _ref3.l, a = _ref3.a, b = _ref3.b;
    var h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    var c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
var $5836aa799e5e130a$var$lchToLab = function lchToLab(_ref4) {
    var l = _ref4.l, c = _ref4.c, h = _ref4.h;
    var convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
var $5836aa799e5e130a$var$labToXyz = function labToXyz(_ref5) {
    var l = _ref5.l, a = _ref5.a, b = _ref5.b;
    var convertComponent = function convertComponent(c) {
        return c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    };
    var y = (l + 16) / 116;
    var x = a / 500 + y;
    var z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
var $5836aa799e5e130a$var$xyzToRgb = function xyzToRgb(_ref6) {
    var x = _ref6.x, y = _ref6.y, z = _ref6.z;
    var convertComponent = function convertComponent(c) {
        return 255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    };
    return {
        r: $5836aa799e5e130a$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $5836aa799e5e130a$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $5836aa799e5e130a$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
var $5836aa799e5e130a$var$rgbToLch = function rgbToLch(rgb) {
    return $5836aa799e5e130a$var$labToLch($5836aa799e5e130a$var$xyzToLab($5836aa799e5e130a$var$rgbToXyz(rgb)));
};
var $5836aa799e5e130a$var$lchToRgb = function lchToRgb(lch) {
    return $5836aa799e5e130a$var$xyzToRgb($5836aa799e5e130a$var$labToXyz($5836aa799e5e130a$var$lchToLab(lch)));
};
var $5836aa799e5e130a$export$313b8a8fcb34c3b8 = function clampLightness(color, newPercent) {
    var rgb = $5836aa799e5e130a$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    var lch = $5836aa799e5e130a$var$rgbToLch(rgb);
    lch.l = $5836aa799e5e130a$var$clamp(newPercent, 0, 100);
    return $5836aa799e5e130a$var$rgbToHex($5836aa799e5e130a$var$lchToRgb(lch));
};
var $5836aa799e5e130a$var$getLightness = function getLightness(color) {
    var rgb = $5836aa799e5e130a$var$rgbFromHex(color);
    if (rgb === null) return 0;
    var lch = $5836aa799e5e130a$var$rgbToLch(rgb);
    return lch.l;
};
var $5836aa799e5e130a$export$a5065c3b8aacaf99 = function getDarkModeLCHColor(currentBackgroundColor) {
    var lightness = $5836aa799e5e130a$var$getLightness(currentBackgroundColor);
    var newLightness = Math.abs(100 - lightness);
    return $5836aa799e5e130a$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};

});


parcelRegister("gF5vD", function(module, exports) {

$parcel$export(module.exports, "decisionListSelector", () => $c214bfb0db3decce$export$a5393ce68c2ff601);
$parcel$export(module.exports, "decisionList", () => $c214bfb0db3decce$export$62d45a65fb43d95e);

var $30K2d = parcelRequire("30K2d");

var $7p61p = parcelRequire("7p61p");
/**
 * @name decisionList_node
 */ var $c214bfb0db3decce$var$name = 'decisionList';
var $c214bfb0db3decce$export$a5393ce68c2ff601 = "[data-node-type=\"".concat($c214bfb0db3decce$var$name, "\"]");
var $c214bfb0db3decce$export$62d45a65fb43d95e = (0, $7p61p.decisionList)({
    parseDOM: [
        {
            tag: "ol".concat($c214bfb0db3decce$export$a5393ce68c2ff601),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $30K2d.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $c214bfb0db3decce$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});

});

parcelRegister("3MGtf", function(module, exports) {

$parcel$export(module.exports, "decisionItem", () => $2c16cc9d8fd69fae$export$6959e16eeff859b4);

var $30K2d = parcelRequire("30K2d");

var $7p61p = parcelRequire("7p61p");
var $2c16cc9d8fd69fae$export$6959e16eeff859b4 = (0, $7p61p.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $30K2d.uuid).generate(),
                    state: dom.getAttribute('data-decision-state')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});

});

parcelRegister("sHAtT", function(module, exports) {

$parcel$export(module.exports, "taskListSelector", () => $05646d30daf5a111$export$c0ec71adb7a18fb2);
$parcel$export(module.exports, "taskList", () => $05646d30daf5a111$export$375b6afcc5f4d291);

var $30K2d = parcelRequire("30K2d");

var $7p61p = parcelRequire("7p61p");
/**
 * @name taskList_node
 */ var $05646d30daf5a111$var$name = 'actionList';
var $05646d30daf5a111$export$c0ec71adb7a18fb2 = "[data-node-type=\"".concat($05646d30daf5a111$var$name, "\"]");
var $05646d30daf5a111$export$375b6afcc5f4d291 = (0, $7p61p.taskList)({
    parseDOM: [
        {
            tag: "div".concat($05646d30daf5a111$export$c0ec71adb7a18fb2),
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs() {
                return {
                    localId: (0, $30K2d.uuid).generate()
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var localId = node.attrs.localId;
        var attrs = {
            'data-node-type': $05646d30daf5a111$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("iamME", function(module, exports) {

$parcel$export(module.exports, "taskItem", () => $d39ad58ca717a52d$export$6d8b0ef52e2e6390);

var $30K2d = parcelRequire("30K2d");

var $7p61p = parcelRequire("7p61p");
var $d39ad58ca717a52d$export$6d8b0ef52e2e6390 = (0, $7p61p.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: function getAttrs(dom) {
                return {
                    localId: (0, $30K2d.uuid).generate(),
                    state: dom.getAttribute('data-task-state') || 'TODO'
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, localId = _node$attrs.localId, state = _node$attrs.state;
        var attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("gUPLp", function(module, exports) {

$parcel$export(module.exports, "date", () => $c50a077ce65cc56f$export$324d90190a8b822a);

var $7p61p = parcelRequire("7p61p");
var $c50a077ce65cc56f$export$324d90190a8b822a = (0, $7p61p.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: function getAttrs(dom) {
                return {
                    timestamp: dom.getAttribute('data-timestamp')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("jnsRQ", function(module, exports) {

$parcel$export(module.exports, "placeholder", () => $e1b68ec2d3711dcf$export$c7187bbd1a7a9244);

var $7p61p = parcelRequire("7p61p");
var $e1b68ec2d3711dcf$export$c7187bbd1a7a9244 = (0, $7p61p.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: function getAttrs(dom) {
                return {
                    text: dom.getAttribute('data-placeholder') || $e1b68ec2d3711dcf$export$c7187bbd1a7a9244.attrs.text.default
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var text = node.attrs.text;
        var attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("jlC8q", function(module, exports) {

$parcel$export(module.exports, "layoutSection", () => $e15d8f442e653ccd$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSectionWithSingleColumn", () => $e15d8f442e653ccd$export$4f9d8f623ff17117);

var $7p61p = parcelRequire("7p61p");
var $e15d8f442e653ccd$export$b3b6a70a7fa4a5be = (0, $7p61p.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $e15d8f442e653ccd$export$cdae19acb0a520fd = (0, $7p61p.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $e15d8f442e653ccd$export$4f9d8f623ff17117 = (0, $7p61p.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: function getAttrs(dom) {
                var columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM: function toDOM(node) {
        var columnRuleStyle = node.attrs.columnRuleStyle;
        var attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("wJ4ih", function(module, exports) {

$parcel$export(module.exports, "layoutColumn", () => $0625f2e3d84c3d6d$export$ab76e7c03cd6f650);

var $7p61p = parcelRequire("7p61p");
var $0625f2e3d84c3d6d$export$ab76e7c03cd6f650 = (0, $7p61p.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-layout-column': 'true'
        };
        var width = node.attrs.width;
        if (width) {
            attrs['style'] = "flex-basis: ".concat(width, "%");
            attrs['data-column-width'] = "".concat(width);
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        var contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});

});

parcelRegister("e0eEI", function(module, exports) {

$parcel$export(module.exports, "inlineCard", () => $a31c6f12c8491384$export$cbf8224b64e0d942);

var $7p61p = parcelRequire("7p61p");
var $a31c6f12c8491384$export$cbf8224b64e0d942 = (0, $7p61p.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                var data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});

});

parcelRegister("1cqNn", function(module, exports) {

$parcel$export(module.exports, "blockCard", () => $0dfbb26d948298db$export$c4c2f833baaebdb8);

var $1tVDE = parcelRequire("1tVDE");

var $7p61p = parcelRequire("7p61p");
function $0dfbb26d948298db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0dfbb26d948298db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0dfbb26d948298db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0dfbb26d948298db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name blockCard_node
 */ var $0dfbb26d948298db$var$getCommonAttributesFromDom = function getCommonAttributesFromDom(dom) {
    var anchor = dom;
    var data = anchor.getAttribute('data-card-data');
    var datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
var $0dfbb26d948298db$export$c4c2f833baaebdb8 = (0, $7p61p.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0dfbb26d948298db$var$_objectSpread({
                    url: anchor.getAttribute('href') || undefined
                }, $0dfbb26d948298db$var$getCommonAttributesFromDom(dom));
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: function getAttrs(dom) {
                var anchor = dom;
                return $0dfbb26d948298db$var$_objectSpread({
                    url: anchor.getAttribute('data-card-url') || undefined
                }, $0dfbb26d948298db$var$getCommonAttributesFromDom(dom));
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs;
        var _ref = node.attrs, url = _ref.url;
        var _ref2 = node.attrs, data = _ref2.data;
        var _ref3 = node.attrs, layout = _ref3.layout, width = _ref3.width, datasource = _ref3.datasource;
        var attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': "".concat(width)
        };
        return [
            'a',
            attrs,
            (node === null || node === void 0 ? void 0 : (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
        ];
    }
});

});

parcelRegister("faMeF", function(module, exports) {

$parcel$export(module.exports, "unsupportedBlock", () => $b0bd34c68cf69823$export$44b79b0979d0f0f7);

var $7p61p = parcelRequire("7p61p");
var $b0bd34c68cf69823$export$44b79b0979d0f0f7 = (0, $7p61p.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("cPaCL", function(module, exports) {

$parcel$export(module.exports, "unsupportedInline", () => $95627d2f3e275283$export$310ebe0d80122e9b);

var $7p61p = parcelRequire("7p61p");
var $95627d2f3e275283$export$310ebe0d80122e9b = (0, $7p61p.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: function getAttrs(dom) {
                return {
                    originalValue: JSON.parse(dom.getAttribute('data-original-value') || '{}')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});

});

parcelRegister("fbcXy", function(module, exports) {

$parcel$export(module.exports, "status", () => $b0d1ef9baa45c8a9$export$471f7ae5c4103ae1);

var $30K2d = parcelRequire("30K2d");

var $7p61p = parcelRequire("7p61p");
var $b0d1ef9baa45c8a9$export$471f7ae5c4103ae1 = (0, $7p61p.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                return {
                    text: dom.textContent.replace(/\n/, '').trim(),
                    color: dom.getAttribute('data-color'),
                    localId: (0, $30K2d.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, text = _node$attrs.text, color = _node$attrs.color, localId = _node$attrs.localId, style = _node$attrs.style;
        var attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});

});

parcelRegister("2SP0l", function(module, exports) {

$parcel$export(module.exports, "nestedExpand", () => $21983057a432e6a4$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpandWithoutNonBodiedMacros", () => $21983057a432e6a4$export$15ebf236772fa336);

var $7p61p = parcelRequire("7p61p");
/**
 * @name nestedExpand_content
 * @minItems 1
 * @allowUnsupportedBlock true
 */ /**
 * @name nestedExpand_node
 */ /**
 * @name nestedExpand_with_no_marks_node
 */ function $21983057a432e6a4$var$getExpandAttrs(domNode) {
    var dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
var $21983057a432e6a4$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $21983057a432e6a4$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $21983057a432e6a4$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $21983057a432e6a4$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: $21983057a432e6a4$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: $21983057a432e6a4$var$getExpandAttrs
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
var $21983057a432e6a4$export$63cadbf5f4296627 = (0, $7p61p.nestedExpand)($21983057a432e6a4$var$nestedExpandFactoryOptions);
var $21983057a432e6a4$export$15ebf236772fa336 = (0, $7p61p.nestedExpandWithoutNonBodiedMacros)($21983057a432e6a4$var$nestedExpandWithoutNonBodiedMacrosFactoryOptions);

});

parcelRegister("6fv5N", function(module, exports) {

$parcel$export(module.exports, "embedCard", () => $48cc431deecbb258$export$be4283d9a1cb1ff6);

var $7p61p = parcelRequire("7p61p");
var $48cc431deecbb258$export$be4283d9a1cb1ff6 = (0, $7p61p.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: function getAttrs(dom) {
                return {
                    url: dom.getAttribute('data-card-url'),
                    layout: dom.getAttribute('data-layout') || 'center',
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(dom.getAttribute('data-card-original-height')) || null
                };
            }
        }
    ],
    toDOM: function toDOM(node) {
        var _node$attrs = node.attrs, url = _node$attrs.url, layout = _node$attrs.layout, width = _node$attrs.width, originalWidth = _node$attrs.originalWidth, originalHeight = _node$attrs.originalHeight;
        var attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});

});

parcelRegister("jV2EZ", function(module, exports) {

$parcel$export(module.exports, "extension", () => $e805676d01056134$export$1b45514b112dd749);

var $9h6QM = parcelRequire("9h6QM");

var $7p61p = parcelRequire("7p61p");
var $e805676d01056134$export$1b45514b112dd749 = (0, $7p61p.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $9h6QM.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});

});
parcelRegister("9h6QM", function(module, exports) {

$parcel$export(module.exports, "getExtensionAttrs", () => $6c0b03e7f36c7283$export$1765e2758fc47004);
var $6c0b03e7f36c7283$export$d5f21755dc782a4a = function isValidLayout(name) {
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
var $6c0b03e7f36c7283$export$1765e2758fc47004 = function getExtensionAttrs(dom) {
    var isInline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var extensionType = dom.getAttribute('data-extension-type');
    var extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    var attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        var rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $6c0b03e7f36c7283$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};

});


parcelRegister("6NYOZ", function(module, exports) {

$parcel$export(module.exports, "inlineExtension", () => $4f467f8b70d131b4$export$16b353b2649bd8d9);

var $9h6QM = parcelRequire("9h6QM");

var $7p61p = parcelRequire("7p61p");
var $4f467f8b70d131b4$export$16b353b2649bd8d9 = (0, $7p61p.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            getAttrs: function getAttrs(domNode) {
                return (0, $9h6QM.getExtensionAttrs)(domNode, true);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});

});

parcelRegister("bCf9G", function(module, exports) {

$parcel$export(module.exports, "bodiedExtension", () => $874effd804625f60$export$27903d543b563e39);

var $9h6QM = parcelRequire("9h6QM");

var $7p61p = parcelRequire("7p61p");
var $874effd804625f60$export$27903d543b563e39 = (0, $7p61p.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $9h6QM.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});

parcelRegister("6jY0P", function(module, exports) {

$parcel$export(module.exports, "extensionFrame", () => $49a3119f9699265f$export$4fdcae991fd743e7);
$parcel$export(module.exports, "multiBodiedExtension", () => $49a3119f9699265f$export$c3c04d555a8b9013);

var $9h6QM = parcelRequire("9h6QM");

var $7p61p = parcelRequire("7p61p");
var $49a3119f9699265f$export$4fdcae991fd743e7 = (0, $7p61p.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM: function toDOM() {
        var attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
var $49a3119f9699265f$export$c3c04d555a8b9013 = (0, $7p61p.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: function getAttrs(domNode) {
                return (0, $9h6QM.getExtensionAttrs)(domNode);
            }
        }
    ],
    toDOM: function toDOM(node) {
        var attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});

});



parcelRegister("4YzAy", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $39f85f2abeac88db$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $39f85f2abeac88db$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $39f85f2abeac88db$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $39f85f2abeac88db$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $39f85f2abeac88db$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $39f85f2abeac88db$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $ixCvY = parcelRequire("ixCvY");
var $39f85f2abeac88db$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
var $39f85f2abeac88db$export$c9f92f5469372e0f = function isSafeUrl(url) {
    var urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $39f85f2abeac88db$var$whitelistedURLPatterns.some(function(p) {
        return p.test(urlTrimmed);
    });
};
var $39f85f2abeac88db$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ixCvY)))();
$39f85f2abeac88db$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$39f85f2abeac88db$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
var $39f85f2abeac88db$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$39f85f2abeac88db$export$8ccbde94d5c7f8e7.add('tel:', $39f85f2abeac88db$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$39f85f2abeac88db$export$8ccbde94d5c7f8e7.add('file:', $39f85f2abeac88db$var$urlWithoutSpacesValidator);
$39f85f2abeac88db$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
var $39f85f2abeac88db$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
var $39f85f2abeac88db$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$39f85f2abeac88db$var$tlds.push($39f85f2abeac88db$var$tlds2Char);
$39f85f2abeac88db$export$8ccbde94d5c7f8e7.tlds($39f85f2abeac88db$var$tlds, false);
var $39f85f2abeac88db$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
var $39f85f2abeac88db$export$6f7d7761b97f967 = function linkifyMatch(text) {
    if (!$39f85f2abeac88db$export$746d02eae03c72e1.test(text)) return [];
    var matches = [];
    var startpos = 0;
    var substr;
    while(substr = text.substr(startpos)){
        var link = (substr.match($39f85f2abeac88db$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            var index = substr.search($39f85f2abeac88db$export$746d02eae03c72e1);
            var start = index >= 0 ? index + startpos : index;
            var end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $39f85f2abeac88db$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    var match = $39f85f2abeac88db$export$6f7d7761b97f967(str);
    if (!match.length) match = $39f85f2abeac88db$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $39f85f2abeac88db$export$6535eb414fa2c8b6(url) {
    var match = $39f85f2abeac88db$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $39f85f2abeac88db$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("ixCvY", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d7f92f42a45686b4$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d7f92f42a45686b4$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d7f92f42a45686b4$var$isString(obj) {
    return $d7f92f42a45686b4$var$_class(obj) === '[object String]';
}
function $d7f92f42a45686b4$var$isObject(obj) {
    return $d7f92f42a45686b4$var$_class(obj) === '[object Object]';
}
function $d7f92f42a45686b4$var$isRegExp(obj) {
    return $d7f92f42a45686b4$var$_class(obj) === '[object RegExp]';
}
function $d7f92f42a45686b4$var$isFunction(obj) {
    return $d7f92f42a45686b4$var$_class(obj) === '[object Function]';
}
function $d7f92f42a45686b4$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d7f92f42a45686b4$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d7f92f42a45686b4$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d7f92f42a45686b4$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d7f92f42a45686b4$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d7f92f42a45686b4$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d7f92f42a45686b4$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d7f92f42a45686b4$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d7f92f42a45686b4$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d7f92f42a45686b4$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d7f92f42a45686b4$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("3zHGh"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d7f92f42a45686b4$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d7f92f42a45686b4$var$isObject(val)) {
            if ($d7f92f42a45686b4$var$isRegExp(val.validate)) compiled.validate = $d7f92f42a45686b4$var$createValidator(val.validate);
            else if ($d7f92f42a45686b4$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d7f92f42a45686b4$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d7f92f42a45686b4$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d7f92f42a45686b4$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d7f92f42a45686b4$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d7f92f42a45686b4$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $d7f92f42a45686b4$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d7f92f42a45686b4$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d7f92f42a45686b4$var$createMatch(self, shift) {
    var match = new $d7f92f42a45686b4$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d7f92f42a45686b4$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d7f92f42a45686b4$var$LinkifyIt)) return new $d7f92f42a45686b4$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d7f92f42a45686b4$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d7f92f42a45686b4$var$assign({}, $d7f92f42a45686b4$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d7f92f42a45686b4$var$assign({}, $d7f92f42a45686b4$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d7f92f42a45686b4$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d7f92f42a45686b4$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d7f92f42a45686b4$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d7f92f42a45686b4$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d7f92f42a45686b4$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d7f92f42a45686b4$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d7f92f42a45686b4$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d7f92f42a45686b4$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d7f92f42a45686b4$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d7f92f42a45686b4$var$LinkifyIt;

});
parcelRegister("3zHGh", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("6zGl4")).source;
    re.src_Cc = (parcelRequire("im6eO")).source;
    re.src_Z = (parcelRequire("9mUTK")).source;
    re.src_P = (parcelRequire("02PyJ")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,4}[a-zA-Z0-9%/]|' + // github has ... in commit range links,
    // google has .... in links (issue #66)
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});



parcelRegister("ODlve", function(module, exports) {

$parcel$export(module.exports, "getSchemaBasedOnStage", () => $098330e2db8b8a84$export$fd147e7d448dea03);
$parcel$export(module.exports, "defaultSchema", () => $098330e2db8b8a84$export$1db618b7b2275ea1);

var $csnse = parcelRequire("csnse");

var $hJ7IY = parcelRequire("hJ7IY");
var $6jY0P = parcelRequire("6jY0P");
var $jlC8q = parcelRequire("jlC8q");
var $bljJ6 = parcelRequire("bljJ6");
var $65GP4 = parcelRequire("65GP4");

var $kjY2u = parcelRequire("kjY2u");
var $098330e2db8b8a84$var$getDefaultSchemaConfig = function getDefaultSchemaConfig() {
    var defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            // https://product-fabric.atlassian.net/browse/ED-10214,
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
var $098330e2db8b8a84$export$e4e3ac1fa64862db = $098330e2db8b8a84$var$getDefaultSchemaConfig();
var $098330e2db8b8a84$export$fd147e7d448dea03 = (0, $csnse.default)(function() {
    var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
    var defaultSchemaConfig = $098330e2db8b8a84$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $jlC8q.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $6jY0P.multiBodiedExtension),
        extensionFrame: (0, $6jY0P.extensionFrame),
        expand: (0, $hJ7IY.expandWithNestedExpand),
        listItem: (0, $bljJ6.listItemWithDecisionStage0),
        table: (0, $65GP4.tableWithNestedTable),
        tableRow: (0, $65GP4.tableRowWithNestedTable),
        tableCell: (0, $65GP4.tableCellWithNestedTable),
        tableHeader: (0, $65GP4.tableHeaderWithNestedTable)
    };
    return (0, $kjY2u.createSchema)(defaultSchemaConfig);
});
var $098330e2db8b8a84$export$1db618b7b2275ea1 = $098330e2db8b8a84$export$fd147e7d448dea03();

});
parcelRegister("kjY2u", function(module, exports) {

$parcel$export(module.exports, "createSchema", () => $ecb427888a1f492b$export$5f4ce795563f4211);

var $kviC1 = parcelRequire("kviC1");

var $6Gom6 = parcelRequire("6Gom6");

var $8Nly5 = parcelRequire("8Nly5");

var $bspXV = parcelRequire("bspXV");
var $cdbMf = parcelRequire("cdbMf");
var $1u46O = parcelRequire("1u46O");
var $jATxp = parcelRequire("jATxp");
var $aiBqH = parcelRequire("aiBqH");
var $87gxy = parcelRequire("87gxy");
var $d7iPn = parcelRequire("d7iPn");
var $4HChC = parcelRequire("4HChC");
var $6YcE1 = parcelRequire("6YcE1");
var $ifQgG = parcelRequire("ifQgG");
var $egaSc = parcelRequire("egaSc");
var $7KPyX = parcelRequire("7KPyX");
var $9vUG3 = parcelRequire("9vUG3");
var $2bddB = parcelRequire("2bddB");
var $5s90Q = parcelRequire("5s90Q");
var $5Osx4 = parcelRequire("5Osx4");
var $evd4q = parcelRequire("evd4q");
var $ShNRe = parcelRequire("ShNRe");
var $jHy5g = parcelRequire("jHy5g");
var $eYrrm = parcelRequire("eYrrm");

var $1cqNn = parcelRequire("1cqNn");
var $bCf9G = parcelRequire("bCf9G");
var $anCdB = parcelRequire("anCdB");
var $DPd50 = parcelRequire("DPd50");
var $ddar1 = parcelRequire("ddar1");
var $4h1RM = parcelRequire("4h1RM");
var $3sY9d = parcelRequire("3sY9d");
var $4SZyh = parcelRequire("4SZyh");
var $gUPLp = parcelRequire("gUPLp");
var $3MGtf = parcelRequire("3MGtf");
var $gF5vD = parcelRequire("gF5vD");
var $7e7vU = parcelRequire("7e7vU");
var $6fv5N = parcelRequire("6fv5N");
var $VrJSs = parcelRequire("VrJSs");
var $hJ7IY = parcelRequire("hJ7IY");
var $jHRmz = parcelRequire("jHRmz");
var $kyLrk = parcelRequire("kyLrk");
var $jV2EZ = parcelRequire("jV2EZ");
var $6jY0P = parcelRequire("6jY0P");
var $dFBOI = parcelRequire("dFBOI");
var $kECe5 = parcelRequire("kECe5");
var $iXL55 = parcelRequire("iXL55");
var $e0eEI = parcelRequire("e0eEI");
var $6NYOZ = parcelRequire("6NYOZ");
var $wJ4ih = parcelRequire("wJ4ih");
var $jlC8q = parcelRequire("jlC8q");
var $bljJ6 = parcelRequire("bljJ6");
var $jGJid = parcelRequire("jGJid");
var $cApIr = parcelRequire("cApIr");
var $j99rC = parcelRequire("j99rC");
var $dQPhK = parcelRequire("dQPhK");
var $ilnFA = parcelRequire("ilnFA");
var $2SP0l = parcelRequire("2SP0l");
var $k9LfQ = parcelRequire("k9LfQ");
var $k9Kf6 = parcelRequire("k9Kf6");
var $jnsRQ = parcelRequire("jnsRQ");
var $8Pe9m = parcelRequire("8Pe9m");
var $fbcXy = parcelRequire("fbcXy");
var $65GP4 = parcelRequire("65GP4");
var $iamME = parcelRequire("iamME");
var $sHAtT = parcelRequire("sHAtT");
var $2UNHE = parcelRequire("2UNHE");
var $gl6qh = parcelRequire("gl6qh");
var $faMeF = parcelRequire("faMeF");
var $cPaCL = parcelRequire("cPaCL");
function $ecb427888a1f492b$var$addItems(builtInItems, config) {
    var customSpecs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!config) return {};
    /**
   * Add built-in Node / Mark specs
   */ var items = builtInItems.reduce(function(items, _ref) {
        var name = _ref.name, spec = _ref.spec;
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
   * Add Custom Node / Mark specs
   */ return Object.keys(customSpecs).reduce(function(items, name) {
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $ecb427888a1f492b$var$groupDeclaration(name) {
    return {
        name: "__".concat(name, "GroupDeclaration"),
        spec: {
            group: name
        }
    };
}
var $ecb427888a1f492b$var$markGroupDeclarations = [
    $ecb427888a1f492b$var$groupDeclaration((0, $6Gom6.COLOR)),
    $ecb427888a1f492b$var$groupDeclaration((0, $6Gom6.FONT_STYLE)),
    $ecb427888a1f492b$var$groupDeclaration((0, $6Gom6.SEARCH_QUERY)),
    $ecb427888a1f492b$var$groupDeclaration((0, $6Gom6.LINK))
];
var $ecb427888a1f492b$var$markGroupDeclarationsNames = $ecb427888a1f492b$var$markGroupDeclarations.map(function(groupMark) {
    return groupMark.name;
});
var $ecb427888a1f492b$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $7e7vU.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $k9Kf6.paragraph)
    },
    {
        name: 'text',
        spec: (0, $2UNHE.text)
    },
    {
        name: 'bulletList',
        spec: (0, $anCdB.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $k9LfQ.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $bljJ6.listItemWithTask)
    },
    {
        name: 'heading',
        spec: (0, $kECe5.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $jHRmz.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $ddar1.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $kyLrk.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $8Pe9m.rule)
    },
    {
        name: 'image',
        spec: (0, $iXL55.image)
    },
    {
        name: 'mention',
        spec: (0, $ilnFA.mention)
    },
    {
        name: 'caption',
        spec: (0, $DPd50.caption)
    },
    {
        name: 'media',
        spec: (0, $jGJid.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $cApIr.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $dQPhK.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $j99rC.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $jnsRQ.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $jlC8q.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $wJ4ih.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $dFBOI.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $VrJSs.emoji)
    },
    {
        name: 'table',
        spec: (0, $65GP4.table)
    },
    {
        name: 'tableCell',
        spec: (0, $65GP4.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $65GP4.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $65GP4.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $4h1RM.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $4SZyh.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $3sY9d.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $gF5vD.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $3MGtf.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $sHAtT.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $iamME.taskItem)
    },
    {
        name: 'date',
        spec: (0, $gUPLp.date)
    },
    {
        name: 'status',
        spec: (0, $fbcXy.status)
    },
    {
        name: 'expand',
        spec: (0, $hJ7IY.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $2SP0l.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $jV2EZ.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $6NYOZ.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $bCf9G.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $6jY0P.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $6jY0P.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $e0eEI.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $1cqNn.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $6fv5N.embedCard)
    },
    {
        name: 'unknownBlock',
        spec: (0, $gl6qh.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $faMeF.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $cPaCL.unsupportedInline)
    }
];
var $ecb427888a1f492b$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $7KPyX.link)
    },
    {
        name: 'em',
        spec: (0, $6YcE1.em)
    },
    {
        name: 'strong',
        spec: (0, $2bddB.strong)
    },
    {
        name: 'textColor',
        spec: (0, $5Osx4.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $1u46O.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $9vUG3.strike)
    },
    {
        name: 'subsup',
        spec: (0, $5s90Q.subsup)
    },
    {
        name: 'underline',
        spec: (0, $ShNRe.underline)
    },
    {
        name: 'code',
        spec: (0, $87gxy.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $evd4q.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $bspXV.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $cdbMf.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $d7iPn.confluenceInlineComment)
    }
].concat($ecb427888a1f492b$var$markGroupDeclarations, [
    {
        name: 'breakout',
        spec: (0, $aiBqH.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $4HChC.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $ifQgG.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $egaSc.indentation)
    },
    {
        name: 'border',
        spec: (0, $jATxp.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $jHy5g.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $eYrrm.unsupportedNodeAttribute)
    }
]);
function $ecb427888a1f492b$export$2d0c32a809131488() {
    var nodes = $ecb427888a1f492b$var$nodesInOrder.reduce(function(acc, _ref2) {
        var name = _ref2.name, spec = _ref2.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    var marks = $ecb427888a1f492b$var$marksInOrder.reduce(function(acc, _ref3) {
        var name = _ref3.name, spec = _ref3.spec;
        // @ts-expect-error - Type for SchemaBuiltInItem is not correct
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $ecb427888a1f492b$export$5f4ce795563f4211(config) {
    var customNodeSpecs = config.customNodeSpecs, customMarkSpecs = config.customMarkSpecs;
    var nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    var marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($ecb427888a1f492b$var$markGroupDeclarationsNames);
    var nodes = $ecb427888a1f492b$var$addItems($ecb427888a1f492b$var$nodesInOrder, nodesConfig, customNodeSpecs);
    var marks = $ecb427888a1f492b$var$addItems($ecb427888a1f492b$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $8Nly5.sanitizeNodes)(nodes, marks);
    return new (0, $kviC1.Schema)({
        nodes: nodes,
        marks: marks
    });
}
var $ecb427888a1f492b$export$c77b6d30da5276a1 = true;

});
parcelRegister("6Gom6", function(module, exports) {

$parcel$export(module.exports, "FONT_STYLE", () => $4dd98ed2a49434fd$export$4498a6080fed604c);
$parcel$export(module.exports, "SEARCH_QUERY", () => $4dd98ed2a49434fd$export$f8e8a5f34f6ea725);
$parcel$export(module.exports, "LINK", () => $4dd98ed2a49434fd$export$b395009ca7f092c7);
$parcel$export(module.exports, "COLOR", () => $4dd98ed2a49434fd$export$9b982809044276a6);
// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
var $4dd98ed2a49434fd$export$4498a6080fed604c = 'fontStyle';
var $4dd98ed2a49434fd$export$f8e8a5f34f6ea725 = 'searchQuery';
var $4dd98ed2a49434fd$export$b395009ca7f092c7 = 'link';
var $4dd98ed2a49434fd$export$9b982809044276a6 = 'color';
var $4dd98ed2a49434fd$export$470d0905851e47a1 = 'alignment';
var $4dd98ed2a49434fd$export$bacb7f4b06a06b22 = 'indentation';

});

parcelRegister("8Nly5", function(module, exports) {

$parcel$export(module.exports, "sanitizeNodes", () => $66739d74b62d4fcf$export$daf54fed04c8fb77);

var $1tVDE = parcelRequire("1tVDE");
function $66739d74b62d4fcf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66739d74b62d4fcf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66739d74b62d4fcf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66739d74b62d4fcf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $66739d74b62d4fcf$export$daf54fed04c8fb77(nodes, supportedMarks) {
    var nodeNames = Object.keys(nodes);
    nodeNames.forEach(function(nodeKey) {
        var nodeSpec = $66739d74b62d4fcf$var$_objectSpread({}, nodes[nodeKey]);
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter(function(mark) {
            return !!supportedMarks[mark];
        }).join(' ');
        if (nodeSpec.content) nodeSpec.content = $66739d74b62d4fcf$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $66739d74b62d4fcf$var$sanitizeNodeSpecContent(nodes, rawContent) {
    var content = rawContent.replace(/\W/g, ' ');
    var contentKeys = content.split(' ');
    var unsupportedContentKeys = contentKeys.filter(function(contentKey) {
        return !$66739d74b62d4fcf$var$isContentSupported(nodes, contentKey);
    });
    return unsupportedContentKeys.reduce(function(newContent, nodeName) {
        return $66739d74b62d4fcf$var$sanitizedContent(newContent, nodeName);
    }, rawContent);
}
function $66739d74b62d4fcf$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    if (!content || !content.match(/\w/)) return '';
    var pattern = "(".concat(invalidContent, "((\\s)*\\|)+)|((\\|(\\s)*)+").concat(invalidContent, "(\\+|\\*)?)|(").concat(invalidContent, "$)|(").concat(invalidContent, "(\\+|\\*))");
    return content.replace(new RegExp(pattern, 'g'), '').replace('  ', ' ').trim();
}
function $66739d74b62d4fcf$var$isContentSupported(nodes, contentKey) {
    var nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(var supportedKey in nodes){
        var nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}

});

parcelRegister("bspXV", function(module, exports) {

$parcel$export(module.exports, "alignmentPositionMap", () => $8576736fced175db$export$be9cf49015769bbd);
$parcel$export(module.exports, "alignment", () => $8576736fced175db$export$8e53000a4ec837);

var $d946C = parcelRequire("d946C");
var $8576736fced175db$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
var $8576736fced175db$export$8e53000a4ec837 = (0, $d946C.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: function getAttrs(dom) {
                var align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: "fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-".concat(mark.attrs.align),
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});

});
parcelRegister("d946C", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $991f4cefa69febb9$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $991f4cefa69febb9$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $991f4cefa69febb9$export$8c5a050822fd698c);
$parcel$export(module.exports, "border", () => $991f4cefa69febb9$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $991f4cefa69febb9$export$89015c65f1c75e3f);
$parcel$export(module.exports, "code", () => $991f4cefa69febb9$export$6565f9f03506010b);
$parcel$export(module.exports, "confluenceInlineComment", () => $991f4cefa69febb9$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $991f4cefa69febb9$export$3024f02c495408d6);
$parcel$export(module.exports, "em", () => $991f4cefa69febb9$export$c63c6f932822f543);
$parcel$export(module.exports, "fragment", () => $991f4cefa69febb9$export$f00aeb236b6f05af);
$parcel$export(module.exports, "indentation", () => $991f4cefa69febb9$export$480c699bd4ec0d86);
$parcel$export(module.exports, "link", () => $991f4cefa69febb9$export$9c30223ca0a664fb);
$parcel$export(module.exports, "strike", () => $991f4cefa69febb9$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $991f4cefa69febb9$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $991f4cefa69febb9$export$b3401ee80eb31041);
$parcel$export(module.exports, "textColor", () => $991f4cefa69febb9$export$32f78bffcd82ff28);
$parcel$export(module.exports, "typeAheadQuery", () => $991f4cefa69febb9$export$20af3dabbb5538df);
$parcel$export(module.exports, "underline", () => $991f4cefa69febb9$export$425327af25286e5e);
$parcel$export(module.exports, "unsupportedMark", () => $991f4cefa69febb9$export$30d78d5eb6719bb8);
$parcel$export(module.exports, "unsupportedNodeAttribute", () => $991f4cefa69febb9$export$a316dc07ff5182a2);
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $lW8kt = parcelRequire("lW8kt");
var $991f4cefa69febb9$export$8e53000a4ec837 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
var $991f4cefa69febb9$export$8512c9afa7b24c3b = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
var $991f4cefa69febb9$export$8c5a050822fd698c = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
var $991f4cefa69febb9$export$1edee58a52776cd9 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
var $991f4cefa69febb9$export$89015c65f1c75e3f = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
var $991f4cefa69febb9$export$6565f9f03506010b = (0, $lW8kt.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
var $991f4cefa69febb9$export$f3b72f8fc4684ecd = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
var $991f4cefa69febb9$export$3024f02c495408d6 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
var $991f4cefa69febb9$export$c63c6f932822f543 = (0, $lW8kt.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $991f4cefa69febb9$export$f00aeb236b6f05af = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
var $991f4cefa69febb9$export$480c699bd4ec0d86 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
var $991f4cefa69febb9$export$9c30223ca0a664fb = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
var $991f4cefa69febb9$export$4899a95d70ec5056 = (0, $lW8kt.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $991f4cefa69febb9$export$59ae2c325a998f89 = (0, $lW8kt.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $991f4cefa69febb9$export$b3401ee80eb31041 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
var $991f4cefa69febb9$export$32f78bffcd82ff28 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
var $991f4cefa69febb9$export$20af3dabbb5538df = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
var $991f4cefa69febb9$export$425327af25286e5e = (0, $lW8kt.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
var $991f4cefa69febb9$export$30d78d5eb6719bb8 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
var $991f4cefa69febb9$export$a316dc07ff5182a2 = (0, $lW8kt.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});

});


parcelRegister("cdbMf", function(module, exports) {

$parcel$export(module.exports, "AnnotationTypes", () => $8e3fd59f5302e62d$export$94aa2fc69ad33d19);
$parcel$export(module.exports, "AnnotationMarkStates", () => $8e3fd59f5302e62d$export$4bab14797673da9f);
$parcel$export(module.exports, "buildDataAttributes", () => $8e3fd59f5302e62d$export$93a98caa8bc6cb07);
$parcel$export(module.exports, "annotation", () => $8e3fd59f5302e62d$export$8512c9afa7b24c3b);

var $1tVDE = parcelRequire("1tVDE");

var $d946C = parcelRequire("d946C");
function $8e3fd59f5302e62d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8e3fd59f5302e62d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8e3fd59f5302e62d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8e3fd59f5302e62d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8e3fd59f5302e62d$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $8e3fd59f5302e62d$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $8e3fd59f5302e62d$export$93a98caa8bc6cb07(_ref) {
    var id = _ref.id, annotationType = _ref.annotationType, state = _ref.state;
    var data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return $8e3fd59f5302e62d$var$_objectSpread($8e3fd59f5302e62d$var$_objectSpread({}, data), {}, {
        'data-mark-annotation-state': state
    });
    return data;
}
var $8e3fd59f5302e62d$export$8512c9afa7b24c3b = (0, $d946C.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                var attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM: function toDOM(node) {
        /*
      Data attributes on the DOM node are a temporary means of
      incrementally switching over to the Annotation mark. Once renderer
      provides native support for inline comments the data attributes on the
      DOM nodes will be removed.
    */ return [
            'span',
            $8e3fd59f5302e62d$var$_objectSpread({
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation'
            }, $8e3fd59f5302e62d$export$93a98caa8bc6cb07({
                id: node.attrs.id,
                annotationType: node.attrs.annotationType
            })),
            0
        ];
    }
});

});

parcelRegister("1u46O", function(module, exports) {

$parcel$export(module.exports, "backgroundColorPalette", () => $114bc7b6db4cd2ed$export$14ec3f21a268e497);
$parcel$export(module.exports, "backgroundColor", () => $114bc7b6db4cd2ed$export$8c5a050822fd698c);

var $1tVDE = parcelRequire("1tVDE");

var $8GwJ7 = parcelRequire("8GwJ7");

var $d946C = parcelRequire("d946C");

var $lv4UF = parcelRequire("lv4UF");

var $2g8PV = parcelRequire("2g8PV");

var $5Osx4 = parcelRequire("5Osx4");

var $7zyDf = parcelRequire("7zyDf");
/**
 * @name backgroundColor_mark
 */ var $114bc7b6db4cd2ed$var$colorArrayPalette = [
    [
        (0, $2g8PV.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $2g8PV.T200),
        'Teal'
    ],
    // token: color.background.accent.teal.subtler
    [
        (0, $2g8PV.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $2g8PV.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $2g8PV.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $2g8PV.P200),
        'Purple'
    ] // token: color.background.accent.purple.subtler
];
var $114bc7b6db4cd2ed$export$14ec3f21a268e497 = new Map();
$114bc7b6db4cd2ed$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $8GwJ7.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $114bc7b6db4cd2ed$export$14ec3f21a268e497.set(color.toLowerCase(), label);
});
var $114bc7b6db4cd2ed$export$8c5a050822fd698c = (0, $d946C.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $2g8PV.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $114bc7b6db4cd2ed$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $114bc7b6db4cd2ed$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $lv4UF.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $5Osx4.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $7zyDf.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1tVDE.default)({
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-background-custom-color', mark.attrs.color)
        ];
    }
});

});
parcelRegister("5Osx4", function(module, exports) {

$parcel$export(module.exports, "colorPalette", () => $43b7c138cf3c5bd8$export$569885e57444f84a);
$parcel$export(module.exports, "getGlobalTheme", () => $43b7c138cf3c5bd8$export$813ecdf77207a053);
$parcel$export(module.exports, "textColor", () => $43b7c138cf3c5bd8$export$32f78bffcd82ff28);

var $1tVDE = parcelRequire("1tVDE");

var $8GwJ7 = parcelRequire("8GwJ7");

var $d946C = parcelRequire("d946C");

var $lv4UF = parcelRequire("lv4UF");

var $2g8PV = parcelRequire("2g8PV");

var $7zyDf = parcelRequire("7zyDf");
/**
 * @name textColor_mark
 */ // used for extended palette in text color picker
var $43b7c138cf3c5bd8$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $2g8PV.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $2g8PV.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $2g8PV.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $2g8PV.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $2g8PV.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $2g8PV.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $2g8PV.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $2g8PV.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $2g8PV.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $2g8PV.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $2g8PV.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $2g8PV.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $2g8PV.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $2g8PV.N0),
        'White'
    ],
    [
        (0, $2g8PV.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $2g8PV.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $2g8PV.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $2g8PV.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $2g8PV.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $2g8PV.P50),
        'Light purple'
    ] // Lavender secret
];
var $43b7c138cf3c5bd8$export$569885e57444f84a = new Map();
var $43b7c138cf3c5bd8$export$81e5ed9e84fe2e28 = $43b7c138cf3c5bd8$export$569885e57444f84a;
$43b7c138cf3c5bd8$var$colorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $8GwJ7.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $43b7c138cf3c5bd8$export$569885e57444f84a.set(color.toLowerCase(), label);
});
// these are for test only
var $43b7c138cf3c5bd8$var$testGlobalTheme;
var $43b7c138cf3c5bd8$export$fd7e0dd2b74807f7 = function setGlobalTheme(theme) {
    $43b7c138cf3c5bd8$var$testGlobalTheme = theme;
};
var $43b7c138cf3c5bd8$export$813ecdf77207a053 = function getGlobalTheme() {
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($43b7c138cf3c5bd8$var$testGlobalTheme) return {
        colorMode: $43b7c138cf3c5bd8$var$testGlobalTheme
    };
    var element = document.documentElement;
    var colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
var $43b7c138cf3c5bd8$export$32f78bffcd82ff28 = (0, $d946C.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: function getAttrs(maybeValue) {
                var value = maybeValue;
                var hexColor;
                if (value.match(/^rgb/i)) hexColor = (0, $2g8PV.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $43b7c138cf3c5bd8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: function getAttrs(maybeElement) {
                if (!(maybeElement instanceof HTMLElement)) return false;
                var hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $43b7c138cf3c5bd8$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ var tokenColor = (0, $lv4UF.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($43b7c138cf3c5bd8$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $7zyDf.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            (0, $1tVDE.default)({
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }, 'data-text-custom-color', mark.attrs.color)
        ];
    }
});

});


parcelRegister("jATxp", function(module, exports) {

$parcel$export(module.exports, "borderColorPalette", () => $03ae64ff1471831e$export$e4e044c989c86ca7);
$parcel$export(module.exports, "border", () => $03ae64ff1471831e$export$1edee58a52776cd9);

var $8GwJ7 = parcelRequire("8GwJ7");

var $d946C = parcelRequire("d946C");

var $lv4UF = parcelRequire("lv4UF");

var $2g8PV = parcelRequire("2g8PV");
/**
 * @name border_mark
 * @description This mark adds decoration to an element, and any element decorated with it will also have a border style.
 */ var $03ae64ff1471831e$var$borderColorArrayPalette = [
    [
        (0, $2g8PV.N300A),
        'Subtle gray'
    ],
    [
        (0, $2g8PV.N600),
        'Gray'
    ],
    [
        (0, $2g8PV.N1000),
        'Bold gray'
    ]
];
var $03ae64ff1471831e$export$e4e044c989c86ca7 = new Map();
$03ae64ff1471831e$var$borderColorArrayPalette.forEach(function(_ref) {
    var _ref2 = (0, $8GwJ7.default)(_ref, 2), color = _ref2[0], label = _ref2[1];
    return $03ae64ff1471831e$export$e4e044c989c86ca7.set(color.toLowerCase(), label);
});
var $03ae64ff1471831e$export$1edee58a52776cd9 = (0, $d946C.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: function getAttrs(domNode) {
                var _dom$getAttribute, _dom$getAttribute2;
                var dom = domNode;
                var color = ((_dom$getAttribute = dom.getAttribute('data-color')) !== null && _dom$getAttribute !== void 0 ? _dom$getAttribute : '').toLowerCase();
                var size = +((_dom$getAttribute2 = dom.getAttribute('data-size')) !== null && _dom$getAttribute2 !== void 0 ? _dom$getAttribute2 : '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $03ae64ff1471831e$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM: function toDOM(mark, isInline) {
        var wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        var paletteColorValue = (0, $lv4UF.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: "--custom-palette-color: ".concat(paletteColorValue)
            }
        ];
    }
});

});

parcelRegister("aiBqH", function(module, exports) {

$parcel$export(module.exports, "breakout", () => $77f89e9043480fad$export$89015c65f1c75e3f);

var $d946C = parcelRequire("d946C");
var $77f89e9043480fad$var$allowedTypes = [
    'wide',
    'full-width'
];
var $77f89e9043480fad$export$89015c65f1c75e3f = (0, $d946C.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs: function getAttrs(dom) {
                var mode = dom.getAttribute('data-mode');
                var width = dom.getAttribute('data-width');
                return {
                    mode: $77f89e9043480fad$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        var _mark$attrs;
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.width
            },
            0
        ];
    }
});

});

parcelRegister("87gxy", function(module, exports) {

$parcel$export(module.exports, "code", () => $5e8bcebc2d8ef8cf$export$6565f9f03506010b);

var $d946C = parcelRequire("d946C");
var $5e8bcebc2d8ef8cf$export$6565f9f03506010b = (0, $d946C.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: function getAttrs(domNode) {
                var dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});

});

parcelRegister("d7iPn", function(module, exports) {

$parcel$export(module.exports, "confluenceInlineComment", () => $98ca88968bce350b$export$f3b72f8fc4684ecd);

var $d946C = parcelRequire("d946C");
var $98ca88968bce350b$export$f3b72f8fc4684ecd = (0, $d946C.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});

});

parcelRegister("4HChC", function(module, exports) {

$parcel$export(module.exports, "dataConsumer", () => $36c8dfd03956cc4d$export$3024f02c495408d6);
$parcel$export(module.exports, "toJSON", () => $36c8dfd03956cc4d$export$54fd2c36b5cc6731);

var $1tVDE = parcelRequire("1tVDE");

var $d946C = parcelRequire("d946C");

var $c5sSV = parcelRequire("c5sSV");
function $36c8dfd03956cc4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $36c8dfd03956cc4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $36c8dfd03956cc4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $36c8dfd03956cc4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * This annotation is purely for reference, & does _nothing_ given annotating
 * `minLength` on an array of strings is not supported with our schema+spec
 * generator.
 *
 * We're keeping it to signal that data consumer `sources` shouldn't be empty
 * strings
 *
 * // @minLength 1
 */ /**
 * @name dataConsumer_mark
 * @description This mark is used for metadata surrounding a node consuming data
 * from a given source node
 */ var $36c8dfd03956cc4d$var$parseDataConsumer = function parseDataConsumer(maybeValue) {
    var sources = (0, $c5sSV.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch (_unused) {
        return false;
    }
};
var $36c8dfd03956cc4d$export$3024f02c495408d6 = (0, $d946C.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: function getAttrs(maybeValue) {
                return $36c8dfd03956cc4d$var$parseDataConsumer(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
var $36c8dfd03956cc4d$export$54fd2c36b5cc6731 = function toJSON(mark) {
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter(function(key) {
            return key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null;
        }).reduce(function(acc, key) {
            return $36c8dfd03956cc4d$var$_objectSpread($36c8dfd03956cc4d$var$_objectSpread({}, acc), {}, (0, $1tVDE.default)({}, key, mark.attrs[key]));
        }, {})
    };
};

});

parcelRegister("6YcE1", function(module, exports) {

$parcel$export(module.exports, "em", () => $5132279e62be3ce0$export$c63c6f932822f543);

var $d946C = parcelRequire("d946C");
/**
 * @name em_mark
 */ var $5132279e62be3ce0$var$emDOM = [
    'em'
];
var $5132279e62be3ce0$export$c63c6f932822f543 = (0, $d946C.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM: function toDOM() {
        return $5132279e62be3ce0$var$emDOM;
    }
});

});

parcelRegister("ifQgG", function(module, exports) {

$parcel$export(module.exports, "fragment", () => $d4a22c0c4f7ed584$export$f00aeb236b6f05af);
$parcel$export(module.exports, "toJSON", () => $d4a22c0c4f7ed584$export$54fd2c36b5cc6731);

var $1tVDE = parcelRequire("1tVDE");

var $d946C = parcelRequire("d946C");

var $c5sSV = parcelRequire("c5sSV");
function $d4a22c0c4f7ed584$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d4a22c0c4f7ed584$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d4a22c0c4f7ed584$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d4a22c0c4f7ed584$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * @name fragment_mark
 * @description Indicates that the elements decorated with this mark belong to a "fragment" entity, which represents a collection of ADF nodes.
 * This entity can be referred to later by its `localId` attribute.
 */ var $d4a22c0c4f7ed584$var$parseFragment = function parseFragment(maybeValue) {
    var _maybeValue$getAttrib;
    if (!(0, $c5sSV.isDOMElement)(maybeValue)) return false;
    var name = (_maybeValue$getAttrib = maybeValue.getAttribute('data-name')) !== null && _maybeValue$getAttrib !== void 0 ? _maybeValue$getAttrib : undefined;
    var localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
var $d4a22c0c4f7ed584$export$f00aeb236b6f05af = (0, $d946C.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: function getAttrs(maybeValue) {
                return $d4a22c0c4f7ed584$var$parseFragment(maybeValue);
            }
        }
    ],
    toDOM: function toDOM(mark, inline) {
        var wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
var $d4a22c0c4f7ed584$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: $d4a22c0c4f7ed584$var$_objectSpread({
            localId: mark.attrs.localId
        }, mark.attrs.name ? {
            name: mark.attrs.name
        } : {})
    };
};

});

parcelRegister("egaSc", function(module, exports) {

$parcel$export(module.exports, "indentation", () => $a61afe7958038fc2$export$480c699bd4ec0d86);

var $d946C = parcelRequire("d946C");
var $a61afe7958038fc2$export$480c699bd4ec0d86 = (0, $d946C.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs: function getAttrs(dom) {
                var level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});

});

parcelRegister("7KPyX", function(module, exports) {

$parcel$export(module.exports, "link", () => $0174fb2792c2d68a$export$9c30223ca0a664fb);
$parcel$export(module.exports, "toJSON", () => $0174fb2792c2d68a$export$54fd2c36b5cc6731);

var $1tVDE = parcelRequire("1tVDE");

var $d946C = parcelRequire("d946C");

var $4YzAy = parcelRequire("4YzAy");
function $0174fb2792c2d68a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0174fb2792c2d68a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0174fb2792c2d68a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0174fb2792c2d68a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $0174fb2792c2d68a$export$b5f67017585d1431 = function getLinkAttrs(attribute) {
    return function(domNode) {
        var dom = domNode;
        var href = dom.getAttribute(attribute) || '';
        var attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $4YzAy.isSafeUrl)(href)) return false;
        if ((0, $4YzAy.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $4YzAy.normalizeUrl)(href);
        return attrs;
    };
};
var $0174fb2792c2d68a$export$9c30223ca0a664fb = (0, $d946C.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $0174fb2792c2d68a$export$b5f67017585d1431('data-block-link'),
            contentElement: function contentElement(node) {
                var clone = node.cloneNode(true);
                clone.removeAttribute('data-block-link');
                clone.setAttribute('data-skip-paste', 'true');
                var wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $0174fb2792c2d68a$export$b5f67017585d1431('href')
        }
    ],
    toDOM: function toDOM(node, isInline) {
        var attrs = Object.keys(node.attrs).reduce(function(attrs, key) {
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $4YzAy.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            $0174fb2792c2d68a$var$_objectSpread($0174fb2792c2d68a$var$_objectSpread({}, attrs), {}, (0, $1tVDE.default)((0, $1tVDE.default)({}, 'data-block-link', 'true'), "class", 'blockLink')),
            0
        ];
    }
});
var $0174fb2792c2d68a$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
var $0174fb2792c2d68a$export$54fd2c36b5cc6731 = function toJSON(mark) {
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce(function(attrs, key) {
            if ($0174fb2792c2d68a$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    };
};

});

parcelRegister("9vUG3", function(module, exports) {

$parcel$export(module.exports, "strike", () => $6ed2f93b96258ef7$export$4899a95d70ec5056);

var $d946C = parcelRequire("d946C");
var $6ed2f93b96258ef7$export$4899a95d70ec5056 = (0, $d946C.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'line-through' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            's'
        ];
    }
});

});

parcelRegister("2bddB", function(module, exports) {

$parcel$export(module.exports, "strong", () => $1966dcc5a932b3f5$export$59ae2c325a998f89);

var $d946C = parcelRequire("d946C");
/**
 * @name strong_mark
 */ var $1966dcc5a932b3f5$var$strongDOM = [
    'strong'
];
var $1966dcc5a932b3f5$export$59ae2c325a998f89 = (0, $d946C.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs: function getAttrs(node) {
                var element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs: function getAttrs(node) {
                var element = node;
                var fontWeight = element.style.fontWeight;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || /^(bold(er)?|[5-9]\d{2,})$/.test(fontWeight)) && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return $1966dcc5a932b3f5$var$strongDOM;
    }
});

});

parcelRegister("5s90Q", function(module, exports) {

$parcel$export(module.exports, "subsup", () => $3f868f04b4cedf84$export$b3401ee80eb31041);

var $d946C = parcelRequire("d946C");
/**
 * @name subsup_mark
 */ function $3f868f04b4cedf84$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
var $3f868f04b4cedf84$export$b3401ee80eb31041 = (0, $d946C.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: function getAttrs(node) {
                return $3f868f04b4cedf84$var$getAttrFromVerticalAlign(node);
            }
        },
        {
            style: 'vertical-align=sub',
            getAttrs: function getAttrs(node) {
                return $3f868f04b4cedf84$var$getAttrFromVerticalAlign(node);
            }
        }
    ],
    toDOM: function toDOM(mark) {
        return [
            mark.attrs.type
        ];
    }
});

});

parcelRegister("evd4q", function(module, exports) {

$parcel$export(module.exports, "typeAheadQuery", () => $a8ee196b5f5e8870$export$20af3dabbb5538df);

var $d946C = parcelRequire("d946C");

var $2g8PV = parcelRequire("2g8PV");
var $a8ee196b5f5e8870$export$20af3dabbb5538df = (0, $d946C.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM: function toDOM(node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: "color: ".concat((0, $2g8PV.B400))
            }
        ];
    }
});

});

parcelRegister("ShNRe", function(module, exports) {

$parcel$export(module.exports, "underline", () => $0a32da9885595d0a$export$425327af25286e5e);

var $d946C = parcelRequire("d946C");
var $0a32da9885595d0a$export$425327af25286e5e = (0, $d946C.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: function getAttrs(value) {
                return value === 'underline' && null;
            }
        }
    ],
    toDOM: function toDOM() {
        return [
            'u'
        ];
    }
});

});

parcelRegister("jHy5g", function(module, exports) {

$parcel$export(module.exports, "unsupportedMark", () => $e57c78cd9bc803d4$export$30d78d5eb6719bb8);

var $d946C = parcelRequire("d946C");
var $e57c78cd9bc803d4$export$30d78d5eb6719bb8 = (0, $d946C.unsupportedMark)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});

parcelRegister("eYrrm", function(module, exports) {

$parcel$export(module.exports, "unsupportedNodeAttribute", () => $ae6bf458b3bc88ca$export$a316dc07ff5182a2);

var $d946C = parcelRequire("d946C");
var $ae6bf458b3bc88ca$export$a316dc07ff5182a2 = (0, $d946C.unsupportedNodeAttribute)({
    toDOM: function toDOM() {
        return [
            'span'
        ];
    }
});

});



parcelRegister("880DR", function(module, exports) {

$parcel$export(module.exports, "alignment", () => $5eaf9189be8aed62$export$8e53000a4ec837);
$parcel$export(module.exports, "annotation", () => $5eaf9189be8aed62$export$8512c9afa7b24c3b);
$parcel$export(module.exports, "backgroundColor", () => $5eaf9189be8aed62$export$8c5a050822fd698c);
$parcel$export(module.exports, "block_content", () => $5eaf9189be8aed62$export$a31afb40076fa18b);
$parcel$export(module.exports, "blockCard", () => $5eaf9189be8aed62$export$c4c2f833baaebdb8);
$parcel$export(module.exports, "blockquote", () => $5eaf9189be8aed62$export$67dc04e652a298ca);
$parcel$export(module.exports, "blockRootOnly", () => $5eaf9189be8aed62$export$ebb5393736e9ba23);
$parcel$export(module.exports, "bodiedExtension", () => $5eaf9189be8aed62$export$27903d543b563e39);
$parcel$export(module.exports, "bodiedExtension_with_marks", () => $5eaf9189be8aed62$export$ee052cc5b2356e83);
$parcel$export(module.exports, "border", () => $5eaf9189be8aed62$export$1edee58a52776cd9);
$parcel$export(module.exports, "breakout", () => $5eaf9189be8aed62$export$89015c65f1c75e3f);
$parcel$export(module.exports, "bulletList", () => $5eaf9189be8aed62$export$a140c94e5ea26bee);
$parcel$export(module.exports, "caption", () => $5eaf9189be8aed62$export$8e3c2dfdc4f0453d);
$parcel$export(module.exports, "code", () => $5eaf9189be8aed62$export$6565f9f03506010b);
$parcel$export(module.exports, "codeBlock", () => $5eaf9189be8aed62$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "codeBlock_root_only", () => $5eaf9189be8aed62$export$38d90d1aac6883a3);
$parcel$export(module.exports, "confluenceInlineComment", () => $5eaf9189be8aed62$export$f3b72f8fc4684ecd);
$parcel$export(module.exports, "dataConsumer", () => $5eaf9189be8aed62$export$3024f02c495408d6);
$parcel$export(module.exports, "date", () => $5eaf9189be8aed62$export$324d90190a8b822a);
$parcel$export(module.exports, "decisionItem", () => $5eaf9189be8aed62$export$6959e16eeff859b4);
$parcel$export(module.exports, "decisionList", () => $5eaf9189be8aed62$export$62d45a65fb43d95e);
$parcel$export(module.exports, "doc", () => $5eaf9189be8aed62$export$2a111da947c407d2);
$parcel$export(module.exports, "em", () => $5eaf9189be8aed62$export$c63c6f932822f543);
$parcel$export(module.exports, "embedCard", () => $5eaf9189be8aed62$export$be4283d9a1cb1ff6);
$parcel$export(module.exports, "emoji", () => $5eaf9189be8aed62$export$a19185d1233fc4b2);
$parcel$export(module.exports, "expand", () => $5eaf9189be8aed62$export$9f77e0932fb78f72);
$parcel$export(module.exports, "expand_root_only", () => $5eaf9189be8aed62$export$b2817c6954dd6d2c);
$parcel$export(module.exports, "extension", () => $5eaf9189be8aed62$export$1b45514b112dd749);
$parcel$export(module.exports, "extension_with_marks", () => $5eaf9189be8aed62$export$15be7c145cec614a);
$parcel$export(module.exports, "extensionFrame", () => $5eaf9189be8aed62$export$4fdcae991fd743e7);
$parcel$export(module.exports, "fragment", () => $5eaf9189be8aed62$export$f00aeb236b6f05af);
$parcel$export(module.exports, "hardBreak", () => $5eaf9189be8aed62$export$371da9dd35aba193);
$parcel$export(module.exports, "heading", () => $5eaf9189be8aed62$export$46e4a324ac90507f);
$parcel$export(module.exports, "heading_with_alignment", () => $5eaf9189be8aed62$export$c17edf9af655deaf);
$parcel$export(module.exports, "heading_with_indentation", () => $5eaf9189be8aed62$export$1902f9737466a0dc);
$parcel$export(module.exports, "heading_with_no_marks", () => $5eaf9189be8aed62$export$7b491e75f1be9278);
$parcel$export(module.exports, "indentation", () => $5eaf9189be8aed62$export$480c699bd4ec0d86);
$parcel$export(module.exports, "inline_content", () => $5eaf9189be8aed62$export$e23e6162adaa368d);
$parcel$export(module.exports, "inlineCard", () => $5eaf9189be8aed62$export$cbf8224b64e0d942);
$parcel$export(module.exports, "inlineExtension", () => $5eaf9189be8aed62$export$16b353b2649bd8d9);
$parcel$export(module.exports, "inlineExtension_with_marks", () => $5eaf9189be8aed62$export$e37f10815f36843d);
$parcel$export(module.exports, "layoutColumn", () => $5eaf9189be8aed62$export$ab76e7c03cd6f650);
$parcel$export(module.exports, "layoutSection", () => $5eaf9189be8aed62$export$b3b6a70a7fa4a5be);
$parcel$export(module.exports, "layoutSection_full", () => $5eaf9189be8aed62$export$941b63fbd931e449);
$parcel$export(module.exports, "layoutSection_with_single_column", () => $5eaf9189be8aed62$export$e0e9834198e8601d);
$parcel$export(module.exports, "link", () => $5eaf9189be8aed62$export$9c30223ca0a664fb);
$parcel$export(module.exports, "listItem", () => $5eaf9189be8aed62$export$76c7e83ecc9cdf05);
$parcel$export(module.exports, "media", () => $5eaf9189be8aed62$export$987d49ffe1b0900f);
$parcel$export(module.exports, "mediaGroup", () => $5eaf9189be8aed62$export$2855e964765eac9);
$parcel$export(module.exports, "mediaInline", () => $5eaf9189be8aed62$export$38bab695e3f720f1);
$parcel$export(module.exports, "mediaSingle", () => $5eaf9189be8aed62$export$969fe3781ca15058);
$parcel$export(module.exports, "mediaSingle_caption", () => $5eaf9189be8aed62$export$68b0ead306f9670f);
$parcel$export(module.exports, "mediaSingle_full", () => $5eaf9189be8aed62$export$f7fd577406abd5f8);
$parcel$export(module.exports, "mention", () => $5eaf9189be8aed62$export$db83999c14438df4);
$parcel$export(module.exports, "multiBodiedExtension", () => $5eaf9189be8aed62$export$c3c04d555a8b9013);
$parcel$export(module.exports, "nestedExpand", () => $5eaf9189be8aed62$export$63cadbf5f4296627);
$parcel$export(module.exports, "nestedExpand_content", () => $5eaf9189be8aed62$export$9584f52f3ebd5d7e);
$parcel$export(module.exports, "nestedExpand_with_no_marks", () => $5eaf9189be8aed62$export$b756fc994eb0bc4f);
$parcel$export(module.exports, "non_nestable_block_content", () => $5eaf9189be8aed62$export$ed866000601e7fa5);
$parcel$export(module.exports, "orderedList", () => $5eaf9189be8aed62$export$a5dc81035676e7a);
$parcel$export(module.exports, "panel", () => $5eaf9189be8aed62$export$21f42ab9b6679f44);
$parcel$export(module.exports, "paragraph", () => $5eaf9189be8aed62$export$9c206ddddb32a9b);
$parcel$export(module.exports, "paragraph_with_alignment", () => $5eaf9189be8aed62$export$9ca11c06877e5c64);
$parcel$export(module.exports, "paragraph_with_indentation", () => $5eaf9189be8aed62$export$a3bd66932996fb7d);
$parcel$export(module.exports, "paragraph_with_no_marks", () => $5eaf9189be8aed62$export$f06f75eb1e56b0c5);
$parcel$export(module.exports, "placeholder", () => $5eaf9189be8aed62$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "rule", () => $5eaf9189be8aed62$export$fbeb3a3956e8a3c7);
$parcel$export(module.exports, "status", () => $5eaf9189be8aed62$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "strike", () => $5eaf9189be8aed62$export$4899a95d70ec5056);
$parcel$export(module.exports, "strong", () => $5eaf9189be8aed62$export$59ae2c325a998f89);
$parcel$export(module.exports, "subsup", () => $5eaf9189be8aed62$export$b3401ee80eb31041);
$parcel$export(module.exports, "table", () => $5eaf9189be8aed62$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableCell", () => $5eaf9189be8aed62$export$e1e720e5f4603e6a);
$parcel$export(module.exports, "tableHeader", () => $5eaf9189be8aed62$export$48884d2a5190dc73);
$parcel$export(module.exports, "tableRow", () => $5eaf9189be8aed62$export$ce666bf02318c957);
$parcel$export(module.exports, "taskItem", () => $5eaf9189be8aed62$export$6d8b0ef52e2e6390);
$parcel$export(module.exports, "taskList", () => $5eaf9189be8aed62$export$375b6afcc5f4d291);
$parcel$export(module.exports, "text", () => $5eaf9189be8aed62$export$6f093cfa640b7166);
$parcel$export(module.exports, "text_code_inline", () => $5eaf9189be8aed62$export$5008c13f04d544f6);
$parcel$export(module.exports, "text_formatted", () => $5eaf9189be8aed62$export$d24a7becb4e0da7c);
$parcel$export(module.exports, "text_link_inline", () => $5eaf9189be8aed62$export$2a9d18d5b3064e6c);
$parcel$export(module.exports, "text_with_no_marks", () => $5eaf9189be8aed62$export$437a3d96346717e0);
$parcel$export(module.exports, "textColor", () => $5eaf9189be8aed62$export$32f78bffcd82ff28);
$parcel$export(module.exports, "underline", () => $5eaf9189be8aed62$export$425327af25286e5e);
var $5eaf9189be8aed62$export$8e53000a4ec837 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'alignment'
            ]
        },
        attrs: {
            props: {
                align: {
                    type: 'enum',
                    values: [
                        'center',
                        'end'
                    ]
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$8512c9afa7b24c3b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'annotation'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                annotationType: {
                    type: 'enum',
                    values: [
                        'inlineComment'
                    ]
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$8c5a050822fd698c = {
    props: {
        type: {
            type: 'enum',
            values: [
                'backgroundColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    pattern: '^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$a31afb40076fa18b = [
    'blockCard',
    'paragraph_with_no_marks',
    'paragraph_with_alignment',
    'paragraph_with_indentation',
    'mediaSingle_caption',
    'mediaSingle_full',
    'codeBlock',
    'taskList',
    'bulletList',
    'orderedList',
    'heading_with_no_marks',
    'heading_with_alignment',
    'heading_with_indentation',
    'mediaGroup',
    'decisionList',
    'rule',
    'panel',
    'blockquote',
    'extension_with_marks',
    'embedCard',
    'table',
    'expand',
    'bodiedExtension_with_marks'
];
var $5eaf9189be8aed62$export$c4c2f833baaebdb8 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        optional: true,
                        validatorFn: 'safeUrl'
                    },
                    datasource: {
                        props: {
                            id: {
                                type: 'string'
                            },
                            parameters: {
                                type: 'object'
                            },
                            views: {
                                items: [
                                    {
                                        props: {
                                            properties: {
                                                optional: true,
                                                type: 'object'
                                            },
                                            type: {
                                                type: 'string'
                                            }
                                        }
                                    }
                                ],
                                minItems: 1,
                                type: 'array'
                            }
                        }
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ]
    },
    required: [
        'attrs'
    ]
};
var $5eaf9189be8aed62$export$67dc04e652a298ca = {
    props: {
        type: {
            type: 'enum',
            values: [
                'blockquote'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'orderedList',
                    'bulletList',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$ebb5393736e9ba23 = [
    'multiBodiedExtension'
];
var $5eaf9189be8aed62$export$27903d543b563e39 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'non_nestable_block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$ee052cc5b2356e83 = [
    'bodiedExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$1edee58a52776cd9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'border'
            ]
        },
        attrs: {
            props: {
                size: {
                    type: 'number',
                    minimum: 1,
                    maximum: 3
                },
                color: {
                    pattern: '^#[0-9a-fA-F]{8}$|^#[0-9a-fA-F]{6}$',
                    type: 'string'
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$89015c65f1c75e3f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'breakout'
            ]
        },
        attrs: {
            props: {
                mode: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width'
                    ]
                },
                width: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$a140c94e5ea26bee = {
    props: {
        type: {
            type: 'enum',
            values: [
                'bulletList'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
var $5eaf9189be8aed62$export$8e3c2dfdc4f0453d = {
    props: {
        type: {
            type: 'enum',
            values: [
                'caption'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'hardBreak',
                    'mention',
                    'emoji',
                    'date',
                    'placeholder',
                    'inlineCard',
                    'status',
                    'text_formatted',
                    'text_code_inline'
                ]
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $5eaf9189be8aed62$export$6565f9f03506010b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'code'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$7bb0d5c671655cc4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'codeBlock'
            ]
        },
        attrs: {
            props: {
                language: {
                    type: 'string',
                    optional: true
                },
                uniqueId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'text_with_no_marks'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $5eaf9189be8aed62$export$38d90d1aac6883a3 = [
    'codeBlock',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$f3b72f8fc4684ecd = {
    props: {
        type: {
            type: 'enum',
            values: [
                'confluenceInlineComment'
            ]
        },
        attrs: {
            props: {
                reference: {
                    type: 'string'
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$3024f02c495408d6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'dataConsumer'
            ]
        },
        attrs: {
            props: {
                sources: {
                    type: 'array',
                    items: [
                        {
                            type: 'string'
                        }
                    ],
                    minItems: 1
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$324d90190a8b822a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'date'
            ]
        },
        attrs: {
            props: {
                timestamp: {
                    minLength: 1,
                    type: 'string'
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$6959e16eeff859b4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $5eaf9189be8aed62$export$62d45a65fb43d95e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'decisionList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'decisionItem'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$2a111da947c407d2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'doc'
            ]
        },
        version: {
            type: 'enum',
            values: [
                1
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'blockCard',
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'paragraph_with_indentation',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'bulletList',
                    'orderedList',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'mediaGroup',
                    'decisionList',
                    'rule',
                    'panel',
                    'blockquote',
                    'extension_with_marks',
                    'embedCard',
                    'table',
                    'expand',
                    'bodiedExtension_with_marks',
                    'codeBlock_root_only',
                    'layoutSection_with_single_column',
                    'layoutSection_full',
                    'multiBodiedExtension',
                    'expand_root_only'
                ]
            ],
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$c63c6f932822f543 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'em'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$be4283d9a1cb1ff6 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'embedCard'
            ]
        },
        attrs: {
            props: {
                url: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'wrap-right',
                        'wrap-left',
                        'align-end',
                        'align-start'
                    ]
                },
                width: {
                    type: 'number',
                    maximum: 100,
                    minimum: 0,
                    optional: true
                },
                originalHeight: {
                    type: 'number',
                    optional: true
                },
                originalWidth: {
                    type: 'number',
                    optional: true
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$a19185d1233fc4b2 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'emoji'
            ]
        },
        attrs: {
            props: {
                shortName: {
                    type: 'string'
                },
                id: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$9f77e0932fb78f72 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'expand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'decisionList',
                    'taskList',
                    'table',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$b2817c6954dd6d2c = [
    'expand',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$1b45514b112dd749 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$15be7c145cec614a = [
    'extension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$4fdcae991fd743e7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'extensionFrame'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'codeBlock',
                    'mediaGroup',
                    'mediaSingle_full',
                    'mediaSingle_caption',
                    'decisionList',
                    'taskList',
                    'table',
                    'extension_with_marks',
                    'bodiedExtension_with_marks',
                    'blockCard',
                    'embedCard'
                ]
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'dataConsumer',
                    'fragment'
                ]
            ]
        }
    }
};
var $5eaf9189be8aed62$export$f00aeb236b6f05af = {
    props: {
        type: {
            type: 'enum',
            values: [
                'fragment'
            ]
        },
        attrs: {
            props: {
                localId: {
                    minLength: 1,
                    type: 'string'
                },
                name: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$371da9dd35aba193 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'hardBreak'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'enum',
                    values: [
                        '\n'
                    ],
                    optional: true
                }
            },
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$46e4a324ac90507f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'heading'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                },
                localId: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$c17edf9af655deaf = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$1902f9737466a0dc = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$7b491e75f1be9278 = [
    'heading',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$480c699bd4ec0d86 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'indentation'
            ]
        },
        attrs: {
            props: {
                level: {
                    type: 'number',
                    minimum: 1,
                    maximum: 6
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$e23e6162adaa368d = [
    'text_formatted',
    'text_code_inline',
    'date',
    'emoji',
    'hardBreak',
    'inlineCard',
    'mention',
    'placeholder',
    'status',
    'inlineExtension_with_marks',
    'mediaInline'
];
var $5eaf9189be8aed62$export$cbf8224b64e0d942 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineCard'
            ]
        },
        attrs: [
            {
                props: {
                    url: {
                        type: 'string',
                        validatorFn: 'safeUrl'
                    }
                }
            },
            {
                props: {
                    data: {
                        type: 'object'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    },
    required: [
        'attrs'
    ]
};
var $5eaf9189be8aed62$export$16b353b2649bd8d9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'inlineExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    minLength: 1,
                    type: 'string'
                },
                extensionType: {
                    minLength: 1,
                    type: 'string'
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                localId: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$e37f10815f36843d = [
    'inlineExtension',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'dataConsumer',
                        'fragment'
                    ]
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$ab76e7c03cd6f650 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutColumn'
            ]
        },
        attrs: {
            props: {
                width: {
                    type: 'number',
                    minimum: 0,
                    maximum: 100
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'block_content'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$b3b6a70a7fa4a5be = {
    props: {
        type: {
            type: 'enum',
            values: [
                'layoutSection'
            ]
        },
        content: {
            type: 'array',
            items: [
                'layoutColumn'
            ],
            minItems: 1,
            maxItems: 3,
            allowUnsupportedBlock: true
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'breakout'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$941b63fbd931e449 = [
    'layoutSection',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 2,
                maxItems: 3,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$e0e9834198e8601d = [
    'layoutSection',
    {
        props: {
            attrs: {
                props: {
                    columnRuleStyle: {
                        type: 'enum',
                        values: [
                            'solid'
                        ],
                        optional: true
                    }
                },
                optional: true
            },
            content: {
                type: 'array',
                items: [
                    'layoutColumn'
                ],
                minItems: 1,
                maxItems: 5,
                allowUnsupportedBlock: true
            },
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'breakout'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$9c30223ca0a664fb = {
    props: {
        type: {
            type: 'enum',
            values: [
                'link'
            ]
        },
        attrs: {
            props: {
                href: {
                    type: 'string',
                    validatorFn: 'safeUrl'
                },
                title: {
                    type: 'string',
                    optional: true
                },
                id: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string',
                    optional: true
                },
                occurrenceKey: {
                    type: 'string',
                    optional: true
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$76c7e83ecc9cdf05 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'listItem'
            ]
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                [
                    'paragraph_with_no_marks',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ],
                [
                    'paragraph_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'taskList',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$2b82905b9aebbab0 = [
    'listItem',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    [
                        'paragraph_with_no_marks',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ],
                    [
                        'paragraph_with_no_marks',
                        'bulletList',
                        'orderedList',
                        'taskList',
                        'mediaSingle_caption',
                        'mediaSingle_full',
                        'codeBlock',
                        'decisionList',
                        'extension_with_marks'
                    ]
                ],
                minItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$987d49ffe1b0900f = {
    props: {
        type: {
            type: 'enum',
            values: [
                'media'
            ]
        },
        attrs: [
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'link',
                            'file'
                        ]
                    },
                    id: {
                        minLength: 1,
                        type: 'string'
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    collection: {
                        type: 'string'
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    occurrenceKey: {
                        minLength: 1,
                        type: 'string',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    }
                }
            },
            {
                props: {
                    type: {
                        type: 'enum',
                        values: [
                            'external'
                        ]
                    },
                    alt: {
                        type: 'string',
                        optional: true
                    },
                    height: {
                        type: 'number',
                        optional: true
                    },
                    width: {
                        type: 'number',
                        optional: true
                    },
                    url: {
                        type: 'string'
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    },
    required: [
        'attrs'
    ]
};
var $5eaf9189be8aed62$export$2855e964765eac9 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaGroup'
            ]
        },
        content: {
            type: 'array',
            items: [
                'media'
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$38bab695e3f720f1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaInline'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'link',
                        'file',
                        'image'
                    ],
                    optional: true
                },
                url: {
                    type: 'string',
                    optional: true
                },
                id: {
                    minLength: 1,
                    type: 'string'
                },
                alt: {
                    type: 'string',
                    optional: true
                },
                collection: {
                    type: 'string'
                },
                occurrenceKey: {
                    minLength: 1,
                    type: 'string',
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                },
                height: {
                    type: 'number',
                    optional: true
                },
                data: {
                    type: 'object',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                [
                    'link',
                    'annotation',
                    'border'
                ]
            ]
        }
    }
};
var $5eaf9189be8aed62$export$969fe3781ca15058 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mediaSingle'
            ]
        },
        attrs: [
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0,
                        maximum: 100,
                        optional: true
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'percentage'
                        ],
                        optional: true
                    }
                }
            },
            {
                props: {
                    width: {
                        type: 'number',
                        minimum: 0
                    },
                    widthType: {
                        type: 'enum',
                        values: [
                            'pixel'
                        ]
                    },
                    layout: {
                        type: 'enum',
                        values: [
                            'wide',
                            'full-width',
                            'center',
                            'wrap-right',
                            'wrap-left',
                            'align-end',
                            'align-start'
                        ]
                    }
                }
            }
        ],
        marks: {
            type: 'array',
            optional: true,
            items: [
                'link'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$68b0ead306f9670f = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                isTupleLike: true,
                items: [
                    'media',
                    'caption'
                ],
                minItems: 1,
                maxItems: 2,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$f7fd577406abd5f8 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$af10954ff7b86f88 = [
    'mediaSingle',
    {
        props: {
            content: {
                type: 'array',
                items: [
                    'media'
                ],
                minItems: 1,
                maxItems: 1,
                allowUnsupportedBlock: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$db83999c14438df4 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'mention'
            ]
        },
        attrs: {
            props: {
                id: {
                    type: 'string'
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                accessLevel: {
                    type: 'string',
                    optional: true
                },
                userType: {
                    type: 'enum',
                    values: [
                        'DEFAULT',
                        'SPECIAL',
                        'APP'
                    ],
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$c3c04d555a8b9013 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'multiBodiedExtension'
            ]
        },
        attrs: {
            props: {
                extensionKey: {
                    type: 'string',
                    minLength: 1
                },
                extensionType: {
                    type: 'string',
                    minLength: 1
                },
                parameters: {
                    type: 'object',
                    optional: true
                },
                text: {
                    type: 'string',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'default',
                        'wide',
                        'full-width'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    optional: true,
                    minLength: 1
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'extensionFrame'
            ]
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$63cadbf5f4296627 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'nestedExpand'
            ]
        },
        attrs: {
            props: {
                title: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: 'nestedExpand_content'
    },
    required: [
        'content'
    ]
};
var $5eaf9189be8aed62$export$9584f52f3ebd5d7e = {
    type: 'array',
    items: [
        [
            'paragraph_with_no_marks',
            'heading_with_no_marks',
            'mediaSingle_caption',
            'mediaSingle_full',
            'mediaGroup',
            'codeBlock',
            'bulletList',
            'orderedList',
            'taskList',
            'decisionList',
            'rule',
            'panel',
            'blockquote',
            'extension_with_marks'
        ]
    ],
    minItems: 1,
    allowUnsupportedBlock: true
};
var $5eaf9189be8aed62$export$b756fc994eb0bc4f = [
    'nestedExpand',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$ed866000601e7fa5 = [
    'paragraph_with_no_marks',
    'panel',
    'blockquote',
    'orderedList',
    'bulletList',
    'rule',
    'heading_with_no_marks',
    'codeBlock',
    'mediaGroup',
    'mediaSingle_caption',
    'mediaSingle_full',
    'decisionList',
    'taskList',
    'table',
    'blockCard',
    'embedCard',
    'extension_with_marks'
];
var $5eaf9189be8aed62$export$a5dc81035676e7a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'orderedList'
            ]
        },
        attrs: {
            props: {
                order: {
                    type: 'number',
                    minimum: 0,
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'listItem',
                    'listItem_with_nested_decision'
                ]
            ],
            minItems: 1
        }
    }
};
var $5eaf9189be8aed62$export$21f42ab9b6679f44 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'panel'
            ]
        },
        attrs: {
            props: {
                panelType: {
                    type: 'enum',
                    values: [
                        'info',
                        'note',
                        'tip',
                        'warning',
                        'error',
                        'success',
                        'custom'
                    ]
                },
                panelIcon: {
                    type: 'string',
                    optional: true
                },
                panelIconId: {
                    type: 'string',
                    optional: true
                },
                panelIconText: {
                    type: 'string',
                    optional: true
                },
                panelColor: {
                    type: 'string',
                    optional: true
                }
            }
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'heading_with_no_marks',
                    'bulletList',
                    'orderedList',
                    'blockCard',
                    'mediaGroup',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'codeBlock',
                    'taskList',
                    'rule',
                    'decisionList',
                    'extension_with_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$9c206ddddb32a9b = {
    props: {
        type: {
            type: 'enum',
            values: [
                'paragraph'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$9ca11c06877e5c64 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'alignment'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$a3bd66932996fb7d = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'indentation'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$f06f75eb1e56b0c5 = [
    'paragraph',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$c7187bbd1a7a9244 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'placeholder'
            ]
        },
        attrs: {
            props: {
                text: {
                    type: 'string'
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$fbeb3a3956e8a3c7 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'rule'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$471f7ae5c4103ae1 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'status'
            ]
        },
        attrs: {
            props: {
                text: {
                    minLength: 1,
                    type: 'string'
                },
                color: {
                    type: 'enum',
                    values: [
                        'neutral',
                        'purple',
                        'blue',
                        'red',
                        'yellow',
                        'green'
                    ]
                },
                localId: {
                    type: 'string',
                    optional: true
                },
                style: {
                    type: 'string',
                    optional: true
                }
            }
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'annotation'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$4899a95d70ec5056 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strike'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$59ae2c325a998f89 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'strong'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$b3401ee80eb31041 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'subsup'
            ]
        },
        attrs: {
            props: {
                type: {
                    type: 'enum',
                    values: [
                        'sub',
                        'sup'
                    ]
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$9852986a3ec5f6a0 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'table'
            ]
        },
        attrs: {
            props: {
                displayMode: {
                    type: 'enum',
                    values: [
                        'default',
                        'fixed'
                    ],
                    optional: true
                },
                isNumberColumnEnabled: {
                    type: 'boolean',
                    optional: true
                },
                layout: {
                    type: 'enum',
                    values: [
                        'wide',
                        'full-width',
                        'center',
                        'align-end',
                        'align-start',
                        'default'
                    ],
                    optional: true
                },
                localId: {
                    type: 'string',
                    minLength: 1,
                    optional: true
                },
                width: {
                    type: 'number',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                'tableRow'
            ],
            minItems: 1
        },
        marks: {
            type: 'array',
            optional: true,
            items: [
                'fragment'
            ]
        }
    }
};
var $5eaf9189be8aed62$export$e1e720e5f4603e6a = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableCell'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    },
    required: [
        'content'
    ]
};
var $5eaf9189be8aed62$export$48884d2a5190dc73 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableHeader'
            ]
        },
        attrs: {
            props: {
                colspan: {
                    type: 'number',
                    optional: true
                },
                rowspan: {
                    type: 'number',
                    optional: true
                },
                colwidth: {
                    type: 'array',
                    items: [
                        {
                            type: 'number'
                        }
                    ],
                    optional: true
                },
                background: {
                    type: 'string',
                    optional: true
                }
            },
            optional: true
        },
        content: {
            type: 'array',
            items: [
                [
                    'paragraph_with_no_marks',
                    'paragraph_with_alignment',
                    'panel',
                    'blockquote',
                    'orderedList',
                    'bulletList',
                    'rule',
                    'heading_with_no_marks',
                    'heading_with_alignment',
                    'heading_with_indentation',
                    'codeBlock',
                    'mediaSingle_caption',
                    'mediaSingle_full',
                    'mediaGroup',
                    'decisionList',
                    'taskList',
                    'blockCard',
                    'embedCard',
                    'extension_with_marks',
                    'nestedExpand_with_no_marks',
                    'nestedExpand'
                ]
            ],
            minItems: 1
        }
    },
    required: [
        'content'
    ]
};
var $5eaf9189be8aed62$export$ce666bf02318c957 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'tableRow'
            ]
        },
        content: {
            type: 'array',
            items: [
                [
                    'tableCell',
                    'tableHeader'
                ]
            ]
        }
    }
};
var $5eaf9189be8aed62$export$6d8b0ef52e2e6390 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskItem'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                },
                state: {
                    type: 'enum',
                    values: [
                        'TODO',
                        'DONE'
                    ]
                }
            }
        },
        content: {
            type: 'array',
            items: [
                'inline_content'
            ],
            optional: true,
            allowUnsupportedInline: true
        }
    }
};
var $5eaf9189be8aed62$export$375b6afcc5f4d291 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'taskList'
            ]
        },
        attrs: {
            props: {
                localId: {
                    type: 'string'
                }
            }
        },
        content: {
            type: 'array',
            isTupleLike: true,
            items: [
                'taskItem',
                [
                    'taskItem',
                    'taskList'
                ]
            ],
            minItems: 1,
            allowUnsupportedBlock: true
        }
    }
};
var $5eaf9189be8aed62$export$6f093cfa640b7166 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'text'
            ]
        },
        text: {
            type: 'string',
            minLength: 1
        },
        marks: {
            type: 'array',
            items: [],
            optional: true
        }
    }
};
var $5eaf9189be8aed62$export$5008c13f04d544f6 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'code',
                        'link',
                        'annotation'
                    ]
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$d24a7becb4e0da7c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    [
                        'link',
                        'em',
                        'strong',
                        'strike',
                        'subsup',
                        'underline',
                        'textColor',
                        'annotation',
                        'backgroundColor',
                        null
                    ]
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$2a9d18d5b3064e6c = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                optional: true,
                items: [
                    'link'
                ]
            }
        }
    }
];
var $5eaf9189be8aed62$export$437a3d96346717e0 = [
    'text',
    {
        props: {
            marks: {
                type: 'array',
                maxItems: 0,
                items: [],
                optional: true
            }
        }
    }
];
var $5eaf9189be8aed62$export$32f78bffcd82ff28 = {
    props: {
        type: {
            type: 'enum',
            values: [
                'textColor'
            ]
        },
        attrs: {
            props: {
                color: {
                    type: 'string',
                    pattern: '^#[0-9a-fA-F]{6}$'
                }
            }
        }
    }
};
var $5eaf9189be8aed62$export$425327af25286e5e = {
    props: {
        type: {
            type: 'enum',
            values: [
                'underline'
            ]
        }
    }
};

});

parcelRegister("lTYwY", function(module, exports) {

$parcel$export(module.exports, "AnalyticsStep", () => $ff1db033c51a8d13$export$cc33374693c7fb23);

var $hcxVq = parcelRequire("hcxVq");

var $4ow2D = parcelRequire("4ow2D");

var $1iGel = parcelRequire("1iGel");

var $fOU5P = parcelRequire("fOU5P");

var $gRL3C = parcelRequire("gRL3C");

var $hvsbO = parcelRequire("hvsbO");

var $1tVDE = parcelRequire("1tVDE");

var $4FvAQ = parcelRequire("4FvAQ");parcelRequire("4Z7QF");
var $4FvAQ = parcelRequire("4FvAQ");

var $kviC1 = parcelRequire("kviC1");
function $ff1db033c51a8d13$var$_callSuper(t, o, e) {
    return o = (0, $gRL3C.default)(o), (0, $fOU5P.default)(t, $ff1db033c51a8d13$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $gRL3C.default)(t).constructor) : o.apply(t, e));
}
function $ff1db033c51a8d13$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ff1db033c51a8d13$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ff1db033c51a8d13$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ff1db033c51a8d13$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ff1db033c51a8d13$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ff1db033c51a8d13$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ff1db033c51a8d13$export$9126078e8b0f76e4 = 'atlaskit-analytics';
var $ff1db033c51a8d13$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $ff1db033c51a8d13$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($ff1db033c51a8d13$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $ff1db033c51a8d13$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return $ff1db033c51a8d13$var$_objectSpread($ff1db033c51a8d13$var$_objectSpread({}, analyticsEvent), {}, {
        payload: {
            action: $ff1db033c51a8d13$var$HISTORY_ACTIONS.UNDID,
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: $ff1db033c51a8d13$var$_objectSpread($ff1db033c51a8d13$var$_objectSpread({}, analyticsEvent.payload.attributes), {}, {
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            }),
            eventType: 'track'
        }
    });
}
/** Toggles event action between undo & redo */ var $ff1db033c51a8d13$var$toggleEventAction = function toggleEventAction(analyticsEvent) {
    return $ff1db033c51a8d13$var$_objectSpread($ff1db033c51a8d13$var$_objectSpread({}, analyticsEvent), {}, {
        payload: $ff1db033c51a8d13$var$_objectSpread($ff1db033c51a8d13$var$_objectSpread({}, analyticsEvent.payload), {}, {
            action: analyticsEvent.payload.action === $ff1db033c51a8d13$var$HISTORY_ACTIONS.UNDID ? $ff1db033c51a8d13$var$HISTORY_ACTIONS.REDID : $ff1db033c51a8d13$var$HISTORY_ACTIONS.UNDID
        })
    });
};
function $ff1db033c51a8d13$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === $ff1db033c51a8d13$var$HISTORY_ACTIONS.UNDID || event.payload.action === $ff1db033c51a8d13$var$HISTORY_ACTIONS.REDID;
}
var $ff1db033c51a8d13$export$cc33374693c7fb23 = /*#__PURE__*/ function(_Step) {
    function AnalyticsStep(analyticsEvents) {
        var _this;
        var actionsToIgnore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var pos // Used to create the map, prevent splitting history.
         = arguments.length > 2 ? arguments[2] : undefined;
        (0, $4ow2D.default)(this, AnalyticsStep);
        _this = $ff1db033c51a8d13$var$_callSuper(this, AnalyticsStep);
        (0, $1tVDE.default)(_this, "analyticsEvents", []);
        (0, $1tVDE.default)(_this, "actionsToIgnore", []);
        _this.analyticsEvents = analyticsEvents;
        _this.actionsToIgnore = actionsToIgnore;
        _this.pos = pos;
        return _this;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ (0, $hvsbO.default)(AnalyticsStep, _Step);
    return (0, $1iGel.default)(AnalyticsStep, [
        {
            key: "invert",
            value: function invert() {
                var _this2 = this;
                var analyticsEvents = this.analyticsEvents.filter(function(analyticsEvent) {
                    return _this2.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1;
                }).map(function(analyticsEvent) {
                    if ($ff1db033c51a8d13$var$isHistoryAnalyticsEvent(analyticsEvent)) return $ff1db033c51a8d13$var$toggleEventAction(analyticsEvent);
                    else return $ff1db033c51a8d13$var$createUndoEvent(analyticsEvent);
                });
                return new AnalyticsStep(analyticsEvents, []);
            }
        },
        {
            key: "apply",
            value: function apply(doc) {
                return (0, $4FvAQ.StepResult).ok(doc);
            }
        },
        {
            key: "map",
            value: function map(mapping) {
                var newPos = this.pos;
                if (typeof newPos === 'number') newPos = mapping.map(newPos);
                // Return the same events, this step will never be removed
                return new AnalyticsStep(this.analyticsEvents, this.actionsToIgnore, newPos);
            }
        },
        {
            key: "getMap",
            value: function getMap() {
                if (typeof this.pos === 'number') return new (0, $4FvAQ.StepMap)([
                    this.pos,
                    0,
                    0
                ]);
                return new (0, $4FvAQ.StepMap)([]);
            }
        },
        {
            key: "merge",
            value: function merge(other) {
                if (other instanceof AnalyticsStep) {
                    var otherAnalyticsEvents = other.analyticsEvents;
                    return new AnalyticsStep([].concat((0, $hcxVq.default)(otherAnalyticsEvents), (0, $hcxVq.default)(this.analyticsEvents)));
                }
                return null;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    stepType: $ff1db033c51a8d13$export$9126078e8b0f76e4
                };
            }
        }
    ], [
        {
            key: "fromJSON",
            value: function fromJSON() {
                return new (0, $4FvAQ.ReplaceStep)(0, 0, (0, $kviC1.Slice).empty);
            }
        }
    ]);
}((0, $4FvAQ.Step));
/** Register this step with Prosemirror */ (0, $4FvAQ.Step).jsonID($ff1db033c51a8d13$export$9126078e8b0f76e4, $ff1db033c51a8d13$export$cc33374693c7fb23);

});
parcelRegister("4Z7QF", function(module, exports) {

$parcel$export(module.exports, "Step", () => (parcelRequire("4FvAQ")).Step);

var $1tVDE = parcelRequire("1tVDE");

var $dh538 = parcelRequire("dh538");

var $4FvAQ = parcelRequire("4FvAQ");
function $3a12f27a44d0e4be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a12f27a44d0e4be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a12f27a44d0e4be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $1tVDE.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a12f27a44d0e4be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
var $3a12f27a44d0e4be$var$originalFromJSON = (0, $4FvAQ.Step).fromJSON;
(0, $4FvAQ.Step).fromJSON = function(schema, jsonStep) {
    var stepImplementation = $3a12f27a44d0e4be$var$originalFromJSON(schema, jsonStep);
    // See https://switcheroo.atlassian.com/ui/gates/4e7e1e8c-9126-4dba-a2a3-1c2b86f81c36/key/platform_editor_metadata_steps
    if (!(0, $dh538.fg)('platform_editor_metadata_step')) return stepImplementation;
    return new Proxy(stepImplementation, {
        get: function get(target, prop, receiver) {
            if (prop === 'toJSON') {
                var toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                var classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply: function apply(target, thisArg, argArray) {
                        var originalResult = Reflect.apply(target, thisArg, argArray);
                        var metadata = $3a12f27a44d0e4be$var$_objectSpread($3a12f27a44d0e4be$var$_objectSpread($3a12f27a44d0e4be$var$_objectSpread({}, jsonStep.metadata), classMetadata), originalResult.metadata);
                        return $3a12f27a44d0e4be$var$_objectSpread($3a12f27a44d0e4be$var$_objectSpread({}, originalResult), Object.keys(metadata).length === 0 ? {} : {
                            metadata: metadata
                        });
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});


parcelRegister("2lAwa", function(module, exports) {

$parcel$export(module.exports, "PlatformSiteAri", () => $1b59dea3d8624ac3$export$62388e9e87e2e1c9);

var $f0FFk = parcelRequire("f0FFk");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/platform/site/manifest.ts
var $1b59dea3d8624ac3$var$platformSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $f0FFk.PlatformSiteAriResourceOwner),
    resourceType: (0, $f0FFk.PlatformSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/platform/site/index.ts
var $1b59dea3d8624ac3$export$62388e9e87e2e1c9 = class _PlatformSiteAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $1b59dea3d8624ac3$var$platformSiteAriStaticOpts.qualifier,
            platformQualifier: $1b59dea3d8624ac3$var$platformSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $1b59dea3d8624ac3$var$platformSiteAriStaticOpts.resourceOwner,
            resourceType: $1b59dea3d8624ac3$var$platformSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $1b59dea3d8624ac3$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $1b59dea3d8624ac3$var$platformSiteAriStaticOpts);
        return new _PlatformSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};

});
parcelRegister("f0FFk", function(module, exports) {

$parcel$export(module.exports, "PlatformSiteAriResourceOwner", () => $aed72d01c3cae0a4$export$2866935ccba4694c);
$parcel$export(module.exports, "PlatformSiteAriResourceType", () => $aed72d01c3cae0a4$export$c9ae8b227ea4b550);
// src/platform/site/types.ts
var $aed72d01c3cae0a4$export$2866935ccba4694c = "platform", $aed72d01c3cae0a4$export$c9ae8b227ea4b550 = "site";

});


parcelRegister("ayhth", function(module, exports) {

$parcel$export(module.exports, "ConfluenceBlogpostAri", () => $7aeaa1c79a69520d$export$8602a2c2f6ac09bc);

var $fEHEn = parcelRequire("fEHEn");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/blogpost/manifest.ts
var $7aeaa1c79a69520d$var$confluenceBlogpostAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $fEHEn.ConfluenceBlogpostAriResourceOwner),
    resourceType: (0, $fEHEn.ConfluenceBlogpostAriResourceType),
    resourceIdSlug: "{blogpostId}",
    resourceIdSegmentFormats: {
        blogpostId: /[0-9]+/
    }
};
// src/confluence/blogpost/index.ts
var $7aeaa1c79a69520d$export$8602a2c2f6ac09bc = class _ConfluenceBlogpostAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get blogpostId() {
        return this._blogpostId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $7aeaa1c79a69520d$var$confluenceBlogpostAriStaticOpts.qualifier,
            platformQualifier: $7aeaa1c79a69520d$var$confluenceBlogpostAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $7aeaa1c79a69520d$var$confluenceBlogpostAriStaticOpts.resourceOwner,
            resourceType: $7aeaa1c79a69520d$var$confluenceBlogpostAriStaticOpts.resourceType,
            resourceId: `${opts.blogpostId}`,
            resourceIdSegmentValues: {
                blogpostId: opts.blogpostId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $7aeaa1c79a69520d$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $7aeaa1c79a69520d$var$confluenceBlogpostAriStaticOpts);
        return new _ConfluenceBlogpostAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            blogpostId: this.blogpostId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._blogpostId = opts.resourceIdSegmentValues.blogpostId;
    }
};

});
parcelRegister("fEHEn", function(module, exports) {

$parcel$export(module.exports, "ConfluenceBlogpostAriResourceOwner", () => $b65c7378bdaab8c8$export$9389f06bd1d0765c);
$parcel$export(module.exports, "ConfluenceBlogpostAriResourceType", () => $b65c7378bdaab8c8$export$fb777a2d645a4129);
// src/confluence/blogpost/types.ts
var $b65c7378bdaab8c8$export$9389f06bd1d0765c = "confluence", $b65c7378bdaab8c8$export$fb777a2d645a4129 = "blogpost";

});


parcelRegister("ixUm0", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageAri", () => $d80705c85277073c$export$3f931dd15d96caff);

var $4VFbv = parcelRequire("4VFbv");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/page/manifest.ts
var $d80705c85277073c$var$confluencePageAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $4VFbv.ConfluencePageAriResourceOwner),
    resourceType: (0, $4VFbv.ConfluencePageAriResourceType),
    resourceIdSlug: "{pageId}",
    resourceIdSegmentFormats: {
        pageId: /[0-9]+/
    }
};
// src/confluence/page/index.ts
var $d80705c85277073c$export$3f931dd15d96caff = class _ConfluencePageAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get pageId() {
        return this._pageId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $d80705c85277073c$var$confluencePageAriStaticOpts.qualifier,
            platformQualifier: $d80705c85277073c$var$confluencePageAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $d80705c85277073c$var$confluencePageAriStaticOpts.resourceOwner,
            resourceType: $d80705c85277073c$var$confluencePageAriStaticOpts.resourceType,
            resourceId: `${opts.pageId}`,
            resourceIdSegmentValues: {
                pageId: opts.pageId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $d80705c85277073c$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $d80705c85277073c$var$confluencePageAriStaticOpts);
        return new _ConfluencePageAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            pageId: this.pageId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._pageId = opts.resourceIdSegmentValues.pageId;
    }
};

});
parcelRegister("4VFbv", function(module, exports) {

$parcel$export(module.exports, "ConfluencePageAriResourceOwner", () => $396c6eb68ee60f4f$export$da53e4f7db4c6a71);
$parcel$export(module.exports, "ConfluencePageAriResourceType", () => $396c6eb68ee60f4f$export$636fc622562a2c5b);
// src/confluence/page/types.ts
var $396c6eb68ee60f4f$export$da53e4f7db4c6a71 = "confluence", $396c6eb68ee60f4f$export$636fc622562a2c5b = "page";

});


parcelRegister("gcKE7", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDatabaseAri", () => $bcc1f3479d303589$export$317cd32472deea7e);

var $lGXNK = parcelRequire("lGXNK");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/database/manifest.ts
var $bcc1f3479d303589$var$confluenceDatabaseAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $lGXNK.ConfluenceDatabaseAriResourceOwner),
    resourceType: (0, $lGXNK.ConfluenceDatabaseAriResourceType),
    resourceIdSlug: "activation/{activationId}/{databaseId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        databaseId: /[0-9]+/
    }
};
// src/confluence/database/index.ts
var $bcc1f3479d303589$export$317cd32472deea7e = class _ConfluenceDatabaseAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get databaseId() {
        return this._databaseId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $bcc1f3479d303589$var$confluenceDatabaseAriStaticOpts.qualifier,
            platformQualifier: $bcc1f3479d303589$var$confluenceDatabaseAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $bcc1f3479d303589$var$confluenceDatabaseAriStaticOpts.resourceOwner,
            resourceType: $bcc1f3479d303589$var$confluenceDatabaseAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.databaseId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                databaseId: opts.databaseId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $bcc1f3479d303589$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $bcc1f3479d303589$var$confluenceDatabaseAriStaticOpts);
        return new _ConfluenceDatabaseAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            databaseId: this.databaseId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._databaseId = opts.resourceIdSegmentValues.databaseId;
    }
};

});
parcelRegister("lGXNK", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDatabaseAriResourceOwner", () => $fcabe883546c3266$export$e83bc7b627335f1d);
$parcel$export(module.exports, "ConfluenceDatabaseAriResourceType", () => $fcabe883546c3266$export$d26db9a1a0b750aa);
// src/confluence/database/types.ts
var $fcabe883546c3266$export$e83bc7b627335f1d = "confluence", $fcabe883546c3266$export$d26db9a1a0b750aa = "database";

});


parcelRegister("kgTLv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceEmbedAri", () => $ec208f109d5d54db$export$47d4b4205d0ac61a);

var $ewqTn = parcelRequire("ewqTn");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/embed/manifest.ts
var $ec208f109d5d54db$var$confluenceEmbedAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $ewqTn.ConfluenceEmbedAriResourceOwner),
    resourceType: (0, $ewqTn.ConfluenceEmbedAriResourceType),
    resourceIdSlug: "activation/{activationId}/{embedId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        embedId: /[0-9]+/
    }
};
// src/confluence/embed/index.ts
var $ec208f109d5d54db$export$47d4b4205d0ac61a = class _ConfluenceEmbedAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get embedId() {
        return this._embedId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $ec208f109d5d54db$var$confluenceEmbedAriStaticOpts.qualifier,
            platformQualifier: $ec208f109d5d54db$var$confluenceEmbedAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $ec208f109d5d54db$var$confluenceEmbedAriStaticOpts.resourceOwner,
            resourceType: $ec208f109d5d54db$var$confluenceEmbedAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.embedId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                embedId: opts.embedId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $ec208f109d5d54db$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $ec208f109d5d54db$var$confluenceEmbedAriStaticOpts);
        return new _ConfluenceEmbedAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            embedId: this.embedId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._embedId = opts.resourceIdSegmentValues.embedId;
    }
};

});
parcelRegister("ewqTn", function(module, exports) {

$parcel$export(module.exports, "ConfluenceEmbedAriResourceOwner", () => $a928ea0e719e1828$export$7a02af293cacddd2);
$parcel$export(module.exports, "ConfluenceEmbedAriResourceType", () => $a928ea0e719e1828$export$f817d48842ea0d4a);
// src/confluence/embed/types.ts
var $a928ea0e719e1828$export$7a02af293cacddd2 = "confluence", $a928ea0e719e1828$export$f817d48842ea0d4a = "embed";

});


parcelRegister("PWQud", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFolderAri", () => $09c269095c24312d$export$501a782385a3f485);

var $6JKI8 = parcelRequire("6JKI8");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/folder/manifest.ts
var $09c269095c24312d$var$confluenceFolderAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6JKI8.ConfluenceFolderAriResourceOwner),
    resourceType: (0, $6JKI8.ConfluenceFolderAriResourceType),
    resourceIdSlug: "activation/{activationId}/{folderId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        folderId: /[0-9]+/
    }
};
// src/confluence/folder/index.ts
var $09c269095c24312d$export$501a782385a3f485 = class _ConfluenceFolderAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get folderId() {
        return this._folderId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $09c269095c24312d$var$confluenceFolderAriStaticOpts.qualifier,
            platformQualifier: $09c269095c24312d$var$confluenceFolderAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $09c269095c24312d$var$confluenceFolderAriStaticOpts.resourceOwner,
            resourceType: $09c269095c24312d$var$confluenceFolderAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.folderId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                folderId: opts.folderId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $09c269095c24312d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $09c269095c24312d$var$confluenceFolderAriStaticOpts);
        return new _ConfluenceFolderAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            folderId: this.folderId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._folderId = opts.resourceIdSegmentValues.folderId;
    }
};

});
parcelRegister("6JKI8", function(module, exports) {

$parcel$export(module.exports, "ConfluenceFolderAriResourceOwner", () => $4e7b2dd89bba4fb2$export$77cf4e1b17902bfa);
$parcel$export(module.exports, "ConfluenceFolderAriResourceType", () => $4e7b2dd89bba4fb2$export$6256ff329bc25a9c);
// src/confluence/folder/types.ts
var $4e7b2dd89bba4fb2$export$77cf4e1b17902bfa = "confluence", $4e7b2dd89bba4fb2$export$6256ff329bc25a9c = "folder";

});


parcelRegister("iILKK", function(module, exports) {

$parcel$export(module.exports, "ConfluenceWhiteboardAri", () => $da1160cc362adfe4$export$ba3d25b6768ddb10);

var $l1pC0 = parcelRequire("l1pC0");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/whiteboard/manifest.ts
var $da1160cc362adfe4$var$confluenceWhiteboardAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $l1pC0.ConfluenceWhiteboardAriResourceOwner),
    resourceType: (0, $l1pC0.ConfluenceWhiteboardAriResourceType),
    resourceIdSlug: "{whiteboardId}",
    resourceIdSegmentFormats: {
        whiteboardId: /[0-9]+/
    }
};
// src/confluence/whiteboard/index.ts
var $da1160cc362adfe4$export$ba3d25b6768ddb10 = class _ConfluenceWhiteboardAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get whiteboardId() {
        return this._whiteboardId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $da1160cc362adfe4$var$confluenceWhiteboardAriStaticOpts.qualifier,
            platformQualifier: $da1160cc362adfe4$var$confluenceWhiteboardAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $da1160cc362adfe4$var$confluenceWhiteboardAriStaticOpts.resourceOwner,
            resourceType: $da1160cc362adfe4$var$confluenceWhiteboardAriStaticOpts.resourceType,
            resourceId: `${opts.whiteboardId}`,
            resourceIdSegmentValues: {
                whiteboardId: opts.whiteboardId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $da1160cc362adfe4$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $da1160cc362adfe4$var$confluenceWhiteboardAriStaticOpts);
        return new _ConfluenceWhiteboardAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            whiteboardId: this.whiteboardId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._whiteboardId = opts.resourceIdSegmentValues.whiteboardId;
    }
};

});
parcelRegister("l1pC0", function(module, exports) {

$parcel$export(module.exports, "ConfluenceWhiteboardAriResourceOwner", () => $f4dd8efd44c73237$export$6130ea1abbb885ef);
$parcel$export(module.exports, "ConfluenceWhiteboardAriResourceType", () => $f4dd8efd44c73237$export$d3070d1568a10e2d);
// src/confluence/whiteboard/types.ts
var $f4dd8efd44c73237$export$6130ea1abbb885ef = "confluence", $f4dd8efd44c73237$export$d3070d1568a10e2d = "whiteboard";

});


parcelRegister("jUSbx", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAri", () => $e7fd4755bf2fda8b$export$4e1bd9257e1b7213);

var $e8PAx = parcelRequire("e8PAx");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/space/manifest.ts
var $e7fd4755bf2fda8b$var$confluenceSpaceAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $e8PAx.ConfluenceSpaceAriResourceOwner),
    resourceType: (0, $e8PAx.ConfluenceSpaceAriResourceType),
    resourceIdSlug: "{spaceId}",
    resourceIdSegmentFormats: {
        spaceId: /[0-9]+/
    }
};
// src/confluence/space/index.ts
var $e7fd4755bf2fda8b$export$4e1bd9257e1b7213 = class _ConfluenceSpaceAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get spaceId() {
        return this._spaceId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $e7fd4755bf2fda8b$var$confluenceSpaceAriStaticOpts.qualifier,
            platformQualifier: $e7fd4755bf2fda8b$var$confluenceSpaceAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $e7fd4755bf2fda8b$var$confluenceSpaceAriStaticOpts.resourceOwner,
            resourceType: $e7fd4755bf2fda8b$var$confluenceSpaceAriStaticOpts.resourceType,
            resourceId: `${opts.spaceId}`,
            resourceIdSegmentValues: {
                spaceId: opts.spaceId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $e7fd4755bf2fda8b$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $e7fd4755bf2fda8b$var$confluenceSpaceAriStaticOpts);
        return new _ConfluenceSpaceAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            spaceId: this.spaceId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._spaceId = opts.resourceIdSegmentValues.spaceId;
    }
};

});
parcelRegister("e8PAx", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSpaceAriResourceOwner", () => $a4b9d469879d649c$export$204c4c730af505ce);
$parcel$export(module.exports, "ConfluenceSpaceAriResourceType", () => $a4b9d469879d649c$export$7c78a678ea7a8ac7);
// src/confluence/space/types.ts
var $a4b9d469879d649c$export$204c4c730af505ce = "confluence", $a4b9d469879d649c$export$7c78a678ea7a8ac7 = "space";

});


parcelRegister("fRK8K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $fQsf7 = parcelRequire("fQsf7");

var $bkWe9 = parcelRequire("bkWe9");

$fQsf7.__exportStar((parcelRequire("bXUmy")), module.exports); /**
                                                      * InvalidAriError - an error thrown if an invalid Ari is constructed
                                                      */ 
class $b8cf98b4decd8829$var$InvalidAriError extends Error {
    static withConstraintViolations(ariString, violations) {
        return new $b8cf98b4decd8829$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
    /**
   * Construct an InvalidAriError given an error message
   *
   * @param {string} ariString - the ARI that failed to parse
   * @param {string|undefined} description - The error message
   */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString; // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $b8cf98b4decd8829$var$InvalidAriError.prototype);
    }
}
module.exports.InvalidAriError = $b8cf98b4decd8829$var$InvalidAriError;
function $b8cf98b4decd8829$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
} // constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $b8cf98b4decd8829$var$basicCharConstraint = $bkWe9.pattern(/^[a-z][a-z.-]*$/); /**
                                                                       * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
                                                                       * It's a violation of the spec, but we still need to support that.
                                                                       * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
                                                                       */ 
const $b8cf98b4decd8829$var$resourceTypeCharConstraints = $bkWe9.pattern(/^[a-z][a-z.-]*$/i);
const $b8cf98b4decd8829$var$resourceOwnerConstraints = [
    $bkWe9.lengthBetween(3, 255),
    $b8cf98b4decd8829$var$basicCharConstraint
];
const $b8cf98b4decd8829$var$resourceTypeConstraints = [
    $bkWe9.lengthBetween(3, 255),
    $b8cf98b4decd8829$var$resourceTypeCharConstraints
];
const $b8cf98b4decd8829$var$cloudIdConstraints = [
    $bkWe9.lengthBetween(3, 255)
];
const $b8cf98b4decd8829$var$siteResourceType = 'site';
const $b8cf98b4decd8829$var$resourceIdChars = /[\w-._~:@#]/.source;
const $b8cf98b4decd8829$var$resourceIdConstraints = [
    $bkWe9.pattern(new RegExp(`^${$b8cf98b4decd8829$var$resourceIdChars}+(/${$b8cf98b4decd8829$var$resourceIdChars}*)*(;v=${$b8cf98b4decd8829$var$resourceIdChars}*)*$`))
]; /**
                                                                                                                                             * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
                                                                                                                                             * (like those for site wide ARIs) are upgraded to their latest form.
                                                                                                                                             */ 
function $b8cf98b4decd8829$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values; // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $b8cf98b4decd8829$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $b8cf98b4decd8829$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $b8cf98b4decd8829$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    static parse(ariString) {
        if (!ariString) throw new $b8cf98b4decd8829$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $b8cf98b4decd8829$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $b8cf98b4decd8829$var$InvalidAriError(ariString);
        return new $b8cf98b4decd8829$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $b8cf98b4decd8829$var$parse(decodeURIComponent(encodedAriString));
    }
    toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $b8cf98b4decd8829$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $b8cf98b4decd8829$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    toJSON() {
        return this.toString();
    }
    equals(other) {
        return other instanceof $b8cf98b4decd8829$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    contains(other) {
        return this.matches(new $b8cf98b4decd8829$var$ResourceIdentifier(other));
    }
    matches(other) {
        return $b8cf98b4decd8829$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $b8cf98b4decd8829$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $b8cf98b4decd8829$var$siteResourceType && !!other.resourceType || $b8cf98b4decd8829$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $b8cf98b4decd8829$var$siteResourceType && !!other.resourceType || $b8cf98b4decd8829$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $b8cf98b4decd8829$var$siteResourceType && !cloudId) return new $bkWe9.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $bkWe9.validateField(this, 'resourceOwner', $b8cf98b4decd8829$var$resourceOwnerConstraints),
            $bkWe9.validateField(this, 'resourceType', $b8cf98b4decd8829$var$resourceTypeConstraints),
            $bkWe9.validateField(this, 'resourceId', $b8cf98b4decd8829$var$resourceIdConstraints),
            $bkWe9.validateField(this, 'cloudId', $b8cf98b4decd8829$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $b8cf98b4decd8829$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $b8cf98b4decd8829$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
    constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $b8cf98b4decd8829$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
}
module.exports.ResourceIdentifier = $b8cf98b4decd8829$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $b8cf98b4decd8829$var$parse(ariString) {
    return $b8cf98b4decd8829$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $b8cf98b4decd8829$var$parse; /**
                        * Parse a URL encoded string as an Ari
                        *
                        * @param {string} encodedAriString - the string to parse
                        * @returns {Ari} the parsed ari
                        * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
                        */ 
function $b8cf98b4decd8829$var$parseEncoded(encodedAriString) {
    return $b8cf98b4decd8829$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $b8cf98b4decd8829$var$parseEncoded;

});
parcelRegister("bkWe9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $utZbE = parcelRequire("utZbE");
class $840ebaaa7827553e$var$LengthConstraint {
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
}
module.exports.LengthConstraint = $840ebaaa7827553e$var$LengthConstraint;
class $840ebaaa7827553e$var$RegexConstraint {
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
    constructor(regex){
        this.regex = regex;
    }
}
module.exports.RegexConstraint = $840ebaaa7827553e$var$RegexConstraint;
class $840ebaaa7827553e$var$GeneralValidationError {
    toString() {
        return this.error;
    }
    constructor(error){
        this.error = error;
    }
}
module.exports.GeneralValidationError = $840ebaaa7827553e$var$GeneralValidationError;
class $840ebaaa7827553e$var$ConstraintViolation {
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
}
module.exports.ConstraintViolation = $840ebaaa7827553e$var$ConstraintViolation;
function $840ebaaa7827553e$var$lengthBetween(min, max) {
    return new $840ebaaa7827553e$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $840ebaaa7827553e$var$lengthBetween;
function $840ebaaa7827553e$var$pattern(regex) {
    return new $840ebaaa7827553e$var$RegexConstraint(regex);
}
module.exports.pattern = $840ebaaa7827553e$var$pattern;
function $840ebaaa7827553e$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($utZbE.isDefined);
    return violatedConstraints.length > 0 ? new $840ebaaa7827553e$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $840ebaaa7827553e$var$validateField;

});

parcelRegister("bXUmy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dNjyi = parcelRequire("dNjyi");
var $8b60ecdaed5b5339$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($8b60ecdaed5b5339$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $8b60ecdaed5b5339$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $8b60ecdaed5b5339$var$AppFamilyAriError;
class $8b60ecdaed5b5339$var$NotAppFamilyAriError extends $8b60ecdaed5b5339$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $8b60ecdaed5b5339$var$NotAppFamilyAriError;
class $8b60ecdaed5b5339$var$NotExpectedAppFamilyAriTypeError extends $8b60ecdaed5b5339$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $8b60ecdaed5b5339$var$NotExpectedAppFamilyAriTypeError; /**
                                                                              * throws NotAppFamilyAriError if not a valid app family ari
                                                                              */ 
function $8b60ecdaed5b5339$var$parseAppAri(ari) {
    return $dNjyi.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $8b60ecdaed5b5339$var$parseAppAri;
function $8b60ecdaed5b5339$var$createAppAri(json) {
    return new $dNjyi.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $8b60ecdaed5b5339$var$createAppAri;

});
parcelRegister("dNjyi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $bXUmy = parcelRequire("bXUmy");

var $fRK8K = parcelRequire("fRK8K");

var $bkWe9 = parcelRequire("bkWe9");
const $a0af04a3ea56d232$var$versionPrefix = ';v=';
const $a0af04a3ea56d232$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $a0af04a3ea56d232$var$uuidConstraints = [
    $bkWe9.pattern(new RegExp(`^${$a0af04a3ea56d232$var$uuidRegExpString}$`, 'i'))
];
const $a0af04a3ea56d232$var$extensionGroupIdConstraints = [
    $bkWe9.pattern(new RegExp(`^(${$a0af04a3ea56d232$var$uuidRegExpString}|static)$`, 'i'))
];
class $a0af04a3ea56d232$var$AppFamilyAriImpl {
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $bXUmy.AppFamilyAri.resourceOwner) throw new $bXUmy.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$bXUmy.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $bXUmy.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $bXUmy.NotAppFamilyAriError(ari, `resourceType must be one of ${$bXUmy.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $bXUmy.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($a0af04a3ea56d232$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($a0af04a3ea56d232$var$versionPrefix) > versionIndex) throw new $bXUmy.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($a0af04a3ea56d232$var$versionPrefix);
        const segments = mainResourceId.split('/').map($a0af04a3ea56d232$var$stripToUndefined);
        if (segments.length > 4) throw new $bXUmy.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $bXUmy.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $bXUmy.AppFamilyAri.extensionGroupResourceType || resourceType === $bXUmy.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $bXUmy.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$bXUmy.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $bXUmy.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$bXUmy.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $bXUmy.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$bXUmy.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $bXUmy.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $bXUmy.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$bXUmy.AppFamilyAri.environmentResourceType}`);
        return new $a0af04a3ea56d232$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $bXUmy.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $bkWe9.validateField(this, 'environmentId', $a0af04a3ea56d232$var$uuidConstraints),
            $bkWe9.validateField(this, 'appId', $a0af04a3ea56d232$var$uuidConstraints),
            $bkWe9.validateField(this, 'extensionGroupId', $a0af04a3ea56d232$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $fRK8K.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $bXUmy.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$a0af04a3ea56d232$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $fRK8K.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $bXUmy.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
    constructor(json){
        this.json = json;
        this.validate();
    }
}
module.exports.AppFamilyAriImpl = $a0af04a3ea56d232$var$AppFamilyAriImpl;
function $a0af04a3ea56d232$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("bHPHO", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSiteAri", () => $885bd1836717e909$export$82e6693d75ffdd8);

var $jJxiA = parcelRequire("jJxiA");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/site/manifest.ts
var $885bd1836717e909$var$confluenceSiteAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $jJxiA.ConfluenceSiteAriResourceOwner),
    resourceType: (0, $jJxiA.ConfluenceSiteAriResourceType),
    resourceIdSlug: "{siteId}",
    resourceIdSegmentFormats: {
        siteId: /[a-zA-Z0-9_\-.]{1,255}/
    }
};
// src/confluence/site/index.ts
var $885bd1836717e909$export$82e6693d75ffdd8 = class _ConfluenceSiteAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $885bd1836717e909$var$confluenceSiteAriStaticOpts.qualifier,
            platformQualifier: $885bd1836717e909$var$confluenceSiteAriStaticOpts.platformQualifier,
            cloudId: void 0,
            resourceOwner: $885bd1836717e909$var$confluenceSiteAriStaticOpts.resourceOwner,
            resourceType: $885bd1836717e909$var$confluenceSiteAriStaticOpts.resourceType,
            resourceId: `${opts.siteId}`,
            resourceIdSegmentValues: {
                siteId: opts.siteId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $885bd1836717e909$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $885bd1836717e909$var$confluenceSiteAriStaticOpts);
        return new _ConfluenceSiteAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.resourceIdSegmentValues.siteId;
    }
};

});
parcelRegister("jJxiA", function(module, exports) {

$parcel$export(module.exports, "ConfluenceSiteAriResourceOwner", () => $03b518fab352952e$export$9e07499cd8b0bde5);
$parcel$export(module.exports, "ConfluenceSiteAriResourceType", () => $03b518fab352952e$export$57b7cabbf31f1f68);
// src/confluence/site/types.ts
var $03b518fab352952e$export$9e07499cd8b0bde5 = "confluence", $03b518fab352952e$export$57b7cabbf31f1f68 = "site";

});


parcelRegister("9icEp", function(module, exports) {
"use strict";
var $6c3f9ba978738607$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $6c3f9ba978738607$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $6c3f9ba978738607$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$6c3f9ba978738607$var$__exportStar((parcelRequire("jbIzz")), module.exports);

});
parcelRegister("jbIzz", function(module, exports) {
"use strict";
var $df819e9875b936d0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $df819e9875b936d0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $df819e9875b936d0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$df819e9875b936d0$var$__exportStar((parcelRequire("43fG0")), module.exports);

});
parcelRegister("43fG0", function(module, exports) {
"use strict";
var $2f339a450cad1648$var$__assign = module.exports && module.exports.__assign || function() {
    $2f339a450cad1648$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2f339a450cad1648$var$__assign.apply(this, arguments);
};
var $2f339a450cad1648$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2f339a450cad1648$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createIframeBridge = void 0;

var $2oerg = parcelRequire("2oerg");

var $dWGPy = parcelRequire("dWGPy");
var $2f339a450cad1648$var$setupMessageListeners = function(window, domain, listeners) {
    return Object.entries(listeners).map(function(_a) {
        var eventKey = _a[0], eventHandler = _a[1];
        return (0, $2oerg.on)(eventKey, {
            window: window,
            domain: domain
        }, function(event) {
            if (eventHandler && event.origin === domain) return eventHandler(event);
        });
    });
};
var $2f339a450cad1648$var$createIframeBridge = function(options) {
    if (!options.withWindow) throw new Error('Target window to setup the bridge with is not defined');
    var bridge = {
        open: function() {
            var withWindow = options.withWindow, withDomain = options.withDomain, features = options.features, theme = options.theme, surfaceColor = options.surfaceColor, sendHandshakeMetric = options.sendHandshakeMetric;
            var listeners = $2f339a450cad1648$var$setupMessageListeners(withWindow, withDomain, features);
            // We only listen for the READY_EVENT fired from the iframe to support hot-reloading via
            // the tunnel. Without this code the hot-reloading would not work. However we do not need
            // to send success / failure analytics as this is only relied upon during development and
            // not in production
            var cancelReadyHandler = (0, $2oerg.on)($dWGPy.READY_EVENT, {
                window: withWindow,
                domain: withDomain
            }, function() {
                return $2f339a450cad1648$var$__awaiter(void 0, void 0, void 0, function() {
                    return $2f339a450cad1648$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            true
                        ];
                    });
                });
            }).cancel;
            // This is the main READY_EVENT that we rely on in production to establish the bridge
            // We send an analytics event to indicate whether this handshake procedure was successful
            // or not and this is how we measure the reliability of the bridge. If an error argument
            // is not sent then the handshake was successful, when we send the caught error it was not
            (0, $2oerg.send)(withWindow, $dWGPy.READY_EVENT, $2f339a450cad1648$var$__assign({
                theme: theme,
                surfaceColor: surfaceColor
            }, options.metadata || {}), {
                timeout: 10000
            }).then(function() {
                sendHandshakeMetric(true);
            }).catch(function(error) {
                sendHandshakeMetric(false, error);
                return (0, $dWGPy.handleMissingHandlerError)(error);
            });
            return {
                enableTheming: function() {
                    (0, $2oerg.send)(withWindow, $dWGPy.THEME_ENABLE_EVENT).catch($dWGPy.handleMissingHandlerError);
                },
                setTheme: function(theme, surfaceColor, env) {
                    (0, $2oerg.send)(withWindow, $dWGPy.THEME_CHANGE_EVENT, {
                        theme: theme,
                        surfaceColor: surfaceColor,
                        env: env
                    }).catch($dWGPy.handleMissingHandlerError);
                },
                close: function() {
                    cancelReadyHandler();
                    listeners.forEach(function(_a) {
                        var cancel = _a.cancel;
                        return cancel();
                    });
                }
            };
        }
    };
    return bridge;
};
module.exports.createIframeBridge = $2f339a450cad1648$var$createIframeBridge;

});
parcelRegister("dWGPy", function(module, exports) {
"use strict";
var $a271ea68035db43b$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $a271ea68035db43b$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.THEME_CHANGE_EVENT = module.exports.THEME_ENABLE_EVENT = module.exports.READY_EVENT = module.exports.handleMissingHandlerError = module.exports.firstToResolve = void 0;
var $a271ea68035db43b$var$invertPromise = function(p) {
    return new Promise(function(resolve, reject) {
        return p.then(reject, resolve);
    });
};
var $a271ea68035db43b$var$firstToResolve = function(promises) {
    return $a271ea68035db43b$var$__awaiter(void 0, void 0, void 0, function() {
        var err_1;
        return $a271ea68035db43b$var$__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    _a.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4 /*yield*/ ,
                        $a271ea68035db43b$var$invertPromise(Promise.all(promises.map($a271ea68035db43b$var$invertPromise)))
                    ];
                case 1:
                    return [
                        2 /*return*/ ,
                        _a.sent()
                    ];
                case 2:
                    err_1 = _a.sent();
                    throw err_1[0];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
module.exports.firstToResolve = $a271ea68035db43b$var$firstToResolve;
var $a271ea68035db43b$var$handleMissingHandlerError = function(error) {
    if (error === null || error === void 0 ? void 0 : error.message.startsWith('No handler found for post message:')) return Promise.resolve();
    else return Promise.reject("Error while sending bridge message: ".concat(error === null || error === void 0 ? void 0 : error.message));
};
module.exports.handleMissingHandlerError = $a271ea68035db43b$var$handleMissingHandlerError;
module.exports.READY_EVENT = '__ready';
module.exports.THEME_ENABLE_EVENT = '__theme_enable';
module.exports.THEME_CHANGE_EVENT = '__theme_change';

});




parcelRegister("ebIYH", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLongRunningTaskAri", () => $a544fb7c2fbea928$export$ebd9af01759f4a9a);

var $6xrk6 = parcelRequire("6xrk6");

var $fY4NL = parcelRequire("fY4NL");

var $3w0K2 = parcelRequire("3w0K2");
// src/confluence/long-running-task/manifest.ts
var $a544fb7c2fbea928$var$confluenceLongRunningTaskAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $6xrk6.ConfluenceLongRunningTaskAriResourceOwner),
    resourceType: (0, $6xrk6.ConfluenceLongRunningTaskAriResourceType),
    resourceIdSlug: "activation/{activationId}/{taskId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        taskId: /[0-9]+/
    }
};
// src/confluence/long-running-task/index.ts
var $a544fb7c2fbea928$export$ebd9af01759f4a9a = class _ConfluenceLongRunningTaskAri extends (0, $fY4NL.RegisteredAri) {
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get taskId() {
        return this._taskId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $a544fb7c2fbea928$var$confluenceLongRunningTaskAriStaticOpts.qualifier,
            platformQualifier: $a544fb7c2fbea928$var$confluenceLongRunningTaskAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $a544fb7c2fbea928$var$confluenceLongRunningTaskAriStaticOpts.resourceOwner,
            resourceType: $a544fb7c2fbea928$var$confluenceLongRunningTaskAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.taskId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                taskId: opts.taskId
            }
        }, ariOpts = (0, $3w0K2.AriParser).fromOpts(derivedOpts, $a544fb7c2fbea928$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $3w0K2.AriParser).fromString(maybeAri, $a544fb7c2fbea928$var$confluenceLongRunningTaskAriStaticOpts);
        return new _ConfluenceLongRunningTaskAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            taskId: this.taskId
        };
    }
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._taskId = opts.resourceIdSegmentValues.taskId;
    }
};

});
parcelRegister("6xrk6", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLongRunningTaskAriResourceOwner", () => $4c2b04f3b1451801$export$c3f2be88215e7f96);
$parcel$export(module.exports, "ConfluenceLongRunningTaskAriResourceType", () => $4c2b04f3b1451801$export$d803f499be36f7e2);
// src/confluence/long-running-task/types.ts
var $4c2b04f3b1451801$export$c3f2be88215e7f96 = "confluence", $4c2b04f3b1451801$export$d803f499be36f7e2 = "long-running-task";

});



//# sourceMappingURL=atl.f825dc62.js.map
